import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SalesServices from "../SalesServices";
import {
    address,
    address2,
    ccity,
    ccountry,
    clientname,
    companyemail,
    contactnumber,
    cstate,
    currency,
    currentTenant,
    czip,
    gstin,
    logo,
    pan,
    prefix1,
    taxtype,
    thousandsdisplay,
    userid,
} from "../../Common/Credentials";
import { rupeeFormatter } from "../../Common/rupeeFormatter.jsx";
import { spin } from "../../Common/NewLoader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ToWords } from "to-words";
import {
    Autocomplete,
    Backdrop,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Collapse,
    FormControl,
    FormControlLabel,
    FormGroup,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    Tooltip,
    Paper,
    Chip,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { NumericFormat } from "react-number-format";
import { Modal } from "react-bootstrap";
import UploadFilesService from "../../Common/upload/UploadFilesService";
import FileServices from "../../Common/upload/FileServices";
import SettingsServices from "../../Settings/SettingsServices";
import BankServices from "../../Masters/Bank/BankServices";
import Swal from "sweetalert2";
import QRCode from "qrcode";
import ewbbutton from "../../images/Eway final.png";
import einvbutton from "../../images/E-invoice.png";
import { Form, Formik } from "formik";
import MasterService from "../../Masters/MasterService.js";
import TransporterServices from "../../Masters/Transporter/TransporterServices.js";
import { salesid } from "../../Common/Permissions.js";
import { screens } from "../../Common/Products.js";
import pdficon from "../../images/Icons/pdf.png";
import mailIcon from "../../images/Icons/email1.png";
import whatsappIcon from "../../images/Icons/whatsapp.png";
import smsIcon from "../../images/Icons/chat1.png";
import receiptIcon from "../../images/Icons/bill.png";
import cloneicon from "../../images/Icons/clone.webp"
import CurrencyWordsFormatter from "../../Common/CurrencyWordsFormatter";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import { RefreshCw } from "lucide-react";
import { toast } from "../../NewUI/NewComponents/toastService.js";

let curmonth, year, day, path;
let doctype = "invoice";

class ViewInvoice extends Component {
    constructor(props) {
        super(props);
        const id = this.props.location.state.id;

        this.state = {
            pagename:
                this.props.location.state === undefined
                    ? ""
                    : this.props.location.state.pagename,
            type:
                this.props.location.state === undefined
                    ? ""
                    : this.props.location.state.type,
            temp: this.props.location.state === undefined
                ? false
                : this.props.location.state.temp,
            showPricesIn: 0,
            Invoicedata: "",
            saleorderitems: [],
            invoiceservicelist: [],
            milestones: [],
            id: id,
            stat: 0,
            loading: false,
            loader: false,
            show: false,
            templete: "",
            currency: currency,
            basecurrency: currency,

            selectedFiles: undefined,
            currentFile: undefined,
            progress: 0,
            message: "",
            isError: false,
            fileInfos: [],
            fileInfo: "",
            partyid: "",
            error: false,
            bankdetails: {},
            additionalchareslist: [],
            einvoicedata: "",
            remarks: "",
            showrem: false,
            showfields: false,
            errormsg: "",
            err: false,
            msg: "",
            transportername: null,
            deliverymethods: [
                { value: "1", name: "Own Vehicle" },
                { value: "2", name: "Hired Vehicle" },
                { value: "3", name: "GTA" },
                { value: "4", name: "Others" },
            ],
            transmode: 1,
            vehicletypes: [
                { value: "O", name: "ODC" },
                { value: "R", name: "Regular" },
            ],
            vehicletype: "R",
            vehiclenum: null,
            distance: 0,
            transporterid: null,
            QRcode: "",
            ewaybillQRcode: "",
            ewaybilldata: "",
            supplytype: "I",
            transportationmode: "1",
            transactiontype: 1,

            fromPlace: "",
            fromState: "",
            fromCountry: "",
            fromStatecode: "",
            remainingDistance: "",
            transDocNo: "",
            transDocDate: "",
            extnRsnCode: "",
            extnRemarks: "",
            fromPincode: "",
            consignmentStatus: "",
            transitType: "",
            addressLine1: "",
            addressLine2: "",
            addressLine3: "",

            CountryData: [],
            StatesData: [],
            CitiesData: [],
            showtrans: false,
            showupdtveh: false,
            ResforVehChange: [
                { value: "1", name: "Due to Break Down" },
                { value: "2", name: "Due to Transshipment" },
                { value: "3", name: "Others (Pls. Specify)" },
                { value: "4", name: "First Time" },
            ],
            ResforCancellation: [
                { value: "1", name: "Duplicate" },
                { value: "2", name: "Order Cancelled" },
                { value: "3", name: "Data Entry mistake" },
                { value: "4", name: "Others" },
            ],
            ResforEWBExt: [
                { value: 1, name: "Natural Calamity" },
                { value: 2, name: "Law and Order Situation" },
                { value: 3, name: "Transshipment" },
                { value: 4, name: "Accident" },
                { value: 99, name: "Others" },
            ],
            reasonCodeforcnl: "1",
            reasonCodeforvehchg: "1",
            reasonCodeforewbext: 1,
            transporterslist: [],
            transporterselectiontype: false,
            validtrnsid: false,
            imgwidth: 0,
            imgheight: 0,
            mailbehavior: "NO",
            creditnoteslist: [],
            showCancelModal: false,
            transidreq: false,
            licenses: [],
            ispaymentpending: false,
            edebitnoteslist: [],
            opendropdown: "",
            hovered: null,
            hoveredBtn: null,
            expandedRows: {},
            activeProductDetail: null,
            activeServiceDetail: null,
            receiptData: [],
        };
        this.selectFile = this.selectFile.bind(this);
        this.upload = this.upload.bind(this);
    }

    styles = {
        container: {
            backgroundColor: '#f8fafc',
            minHeight: '100vh',
            padding: '16px',
        },
        card: {
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
        },
        header: {
            padding: '16px 20px',
            borderBottom: '1px solid #e2e8f0',
            backgroundColor: '#ffffff',
            gap: '20px',
        },
        breadcrumb: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '0.8rem',
            color: '#64748b',
            marginBottom: '12px',
            listStyle: 'none',
            padding: 0,
            margin: 0,
        },
        breadcrumbItem: {
            color: '#64748b',
            textDecoration: 'none',
            transition: 'color 0.03s ease, transform 0.03s ease',
            display: 'inline-block',
        },
        breadcrumbActive: {
            color: '#1e293b',
            fontWeight: 500,
        },
        headerContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        title: {
            fontSize: '1.5rem',
            fontWeight: 600,
            color: '#1e293b',
            margin: 0,
        },
        subtitle: {
            margin: '4px 0 0 0',
            color: '#64748b',
            fontSize: '0.8rem',
        },
        headerActions: {
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
        },
        btn: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            borderRadius: '6px',
            border: 'none',
            fontSize: '0.8rem',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.03s ease',
            boxSizing: 'border-box',
            border: '1px solid transparent',
            textDecoration: 'none',
        },
        btnPrimary: {
            backgroundColor: '#4d4d4d',
            color: '#ffffff',
        },
        btnOutline: {
            backgroundColor: '#ffffff',
            borderColor: '#4d4d4d',
            border: '1px solid #4d4d4d',
        },
        btnDanger: {
            backgroundColor: '#ffffff',
            color: '#dc2626',
            border: '1px solid #dc2626',
        },
        hoveredBtnDanger: {
            backgroundColor: '#dc2626',
            color: '#ffffff',
            border: '1px solid #ffffff',
        },
        tableContainer: {
            overflow: 'auto',
            padding: '0',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.8rem',
        },
        tableHeader: {
            backgroundColor: '#2f6aa5',
            borderBottom: '1px solid #e2e8f0',
        },
        th: {
            padding: '10px 12px',
            textAlign: 'left',
            fontWeight: 600,
            color: '#1e293b',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
        },
        tableRow: {
            borderBottom: '1px solid #f1f5f9',
            cursor: 'pointer',
            transition: 'all 0.03s ease',
            backgroundColor: '#ffffff',
        },
        tableRowHovered: {
            backgroundColor: '#f8fafc',
            transform: 'scale(1.01)',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            transition: 'all 0.03s ease',
        },
        td: {
            maxWidth: '350px',
            padding: '12px',
            fontSize: '0.8rem',
            color: '#374151',
        },
        itemName: {
            fontWeight: 500,
            color: '#1e293b',
        },
        detailGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '10px',
            marginBottom: '15px',
        },
        detailSectionMain: {
            backgroundColor: '#f8fafc',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            minHeight: 'fit-content',
        },
        detailSection: {
            backgroundColor: '#ffffff',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            minHeight: 'fit-content',
        },
        sectionTitle: {
            fontSize: '0.9rem',
            fontWeight: 600,
            color: '#1e293b',
            marginBottom: '12px',
            paddingBottom: '8px',
            borderBottom: '1px solid #e2e8f0',
        },
        sectionTitleMain: {
            fontSize: '1rem',
            fontWeight: 600,
            color: '#1e293b',
            marginBottom: '5px',
            paddingBottom: '5px',
        },
        detailRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            padding: '8px 0',
            borderBottom: '1px solid #f1f5f9',
            minHeight: '32px',
        },
        detailLabel: {
            fontSize: '0.75rem',
            color: '#64748b',
            fontWeight: 500,
            maxWidth: '200px',
            flexShrink: 0,
        },
        detailValue: {
            fontSize: '0.8rem',
            color: '#1e293b',
            fontWeight: 500,
            textAlign: 'right',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            flex: 1,
            marginLeft: '8px',
        },
        statusBadge: {
            padding: '4px 8px',
            borderRadius: '12px',
            fontSize: '0.7rem',
            fontWeight: 500,
            display: 'inline-block',
        },
        statusActive: {
            backgroundColor: '#d1fae5',
            color: '#065f46',
        },
        statusCompleted: {
            backgroundColor: '#dbeafe',
            color: '#1e40af',
        },
        statusCancelled: {
            backgroundColor: '#fee2e2',
            color: '#b91c1c',
        },
        actionButtons: {
            display: 'flex',
            gap: '8px',
            justifyContent: 'center',
        },
        loadingContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            color: '#64748b',
        },
        detailView: {
            backgroundColor: '#f8fafc',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            marginBottom: '16px',
        },
        detailViewHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            paddingBottom: '12px',
            borderBottom: '1px solid #e2e8f0',
        },
        backButton: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            backgroundColor: 'transparent',
            border: '1px solid #d1d5db',
            borderRadius: '6px',
            fontSize: '0.8rem',
            cursor: 'pointer',
            color: '#4d4d4d',
        },
        sidebar: {
            width: '280px',
            borderRight: '1px solid #e2e8f0',
            backgroundColor: '#f8fafc',
            flexShrink: 0,
            padding: '0px',
            overflowY: 'auto',
            maxHeight: '600px',
        },
        sidebarItem: {
            display: 'block',
            padding: '8px 12px',
            borderBottom: '1px solid #f1f5f9',
            textDecoration: 'none',
            color: '#4d4d4d',
            transition: 'background-color 0.03s ease',
            cursor: 'pointer',
            borderRadius: '4px',
            marginBottom: '4px',
        },
        sidebarItemActive: {
            backgroundColor: '#dbeafe',
            borderRight: '3px solid #4d4d4d',
            color: '#4d4d4d',
            fontWeight: 500,
        },
        sidebarItemName: {
            fontSize: '0.8rem',
            fontWeight: 500,
            marginBottom: '2px',
        },
        sidebarItemDetails: {
            fontSize: '0.7rem',
            color: '#6b7280',
        },
        detailContent: {
            flex: 1,
            padding: '16px',
            overflowY: 'auto',
        },
        modalHeader: {
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            padding: '16px 20px',
        },
        modalTitle: {
            fontSize: '1.1rem',
            fontWeight: 600,
            color: '#1e293b',
            margin: 0,
        },
        modalBody: {
            padding: '20px',
            backgroundColor: '#ffffff',
        },
        modalFooter: {
            backgroundColor: '#f8fafc',
            borderTop: '1px solid #e2e8f0',
            padding: '12px 20px',
        },
        dropdownContainer: {
            position: 'relative',
            display: 'inline-block',
        },
        tooltipDropdown: {
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            backgroundColor: '#1f2937',
            borderRadius: '6px',
            padding: '4px',
            minWidth: 'auto',
            maxHeight: '250px',
            overflowY: 'auto',
            marginTop: '4px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            border: '1px solid #374151',
        },
        tooltipDropdownItem: {
            display: 'block',
            width: '100%',
            textAlign: 'left',
            padding: '8px 5px',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            fontSize: '0.7rem',
            color: '#f3f4f6',
            borderRadius: '4px',
            transition: 'all 0.1s ease',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
        },
        tooltipDropdownItemHover: {
            backgroundColor: '#4d4d4d',
        },
        tooltipArrow: {
            position: 'absolute',
            top: '-5px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '0',
            height: '0',
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderBottom: '5px solid #1f2937',
        },
    };

    fetchPaymentStatus = () => {
        SalesServices.SyncSoPayment({ custominvid: this.state.Invoicedata.custominvid, tenantId: currentTenant })
            .then((res) => {
                this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp)
            })
    }

    TransporteridChange = (val) => {
        this.setState({
            transporterid: val,
        });
        if (val.length === 15) {
            let data = {
                tenantId: currentTenant,
                reqparam: val,
            };
            SalesServices.validateGSTIN(data).then((response) => {
                if (
                    response.data.body === null ||
                    response.data.body.statusCodeValue === 400
                ) {
                    this.setState({ err: true, validtrnsid: false });
                    Swal.fire({
                        title: `Invalid Transporter ID`,
                        text: ".",
                        icon: "error",
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#152f5f",
                    });
                } else {
                    this.setState({ validtrnsid: true });
                }
            });
        } else {
            this.setState({
                err: false,
                validtrnsid: false,
            });
        }
    };

    handleShow = () => {
        this.setState({ show: true, partyid: this.state.Invoicedata.customer });
    };

    handleClose = () => {
        this.setState({
            show: false,
            selectedFiles: undefined,
            currentFile: undefined,
            progress: 0,
            message: "",
            isError: false,
            fileInfos: [],
            fileInfo: "",
            partyid: this.state.sellerid,
            error: false,
        });
    };

    getLogoDimensions(imgWidth, imgHeight, logoExists = true) {
        if (!logoExists || !imgWidth || !imgHeight) {
            return {
                width: 0,
                height: 0
            };
        }

        const aspectRatio = imgWidth / imgHeight;
        console.log(imgWidth, imgHeight, aspectRatio);

        let width;
        let height;

        if (aspectRatio >= 2) {
            // Very wide landscape logo
            height = 45;
            width = height * aspectRatio;

        } else if (aspectRatio >= 1.2 && aspectRatio < 2) {
            // Normal landscape logo
            width = 60;
            height = width / aspectRatio;

        } else if (aspectRatio >= 0.7 && aspectRatio <= 1.2) {
            // Portrait / Square logo
            height = 60;
            width = 60;
        } else {
            width = 45;
            height = width / aspectRatio;
        }

        return {
            width: Number(width.toFixed(2)),
            height: Number(height.toFixed(2))
        };
    }


    /**
     * =====================================================================================
     * handleDownload - Universal PDF Invoice Generator
     * =====================================================================================
     *
     * SUPPORTED INVOICE TYPES (determined by pagename state):
     * -------------------------------------------------------
     * 1. TAX INVOICE ("Tax Invoice Details")
     *    - Full GST-compliant invoice with HSN summary table
     *    - Includes e-Invoice QR code and IRN if approved
     *    - Shows "(ORIGINAL FOR RECIPIENT)" or "(SAMPLE INVOICE)"
     *    - Supports additional charges and insurance as separate line items
     *
     * 2. PROFORMA INVOICE ("Proforma Invoice Details")
     *    - Pre-sale quotation format without GST compliance markings
     *    - No e-Invoice integration
     *    - Additional charges NOT included in main table
     *
     * 3. QUOTATION ("Quotation Details")
     *    - Estimate/quote format for customer approval
     *    - Simplified structure without tax breakdowns
     *
     * TAX TYPES SUPPORTED:
     * --------------------
     * - GST (India): INTRASTATE (CGST + SGST split) or INTERSTATE (IGST only)
     * - VAT: Single tax rate applied to all items
     *
     * DATA SOURCES:
     * -------------
     * - Invoicedata: Main invoice object with customer, items, services, charges
     * - invoiceitemlist: Product line items (physical goods with HSN codes)
     * - invoiceservicelist: Service line items (with SAC codes)
     * - additionalchares: Extra charges (freight, packaging, TCS, etc.)
     * - insurance: Optional insurance charge (added to sub-total)
     *
     * CURRENCY HANDLING:
     * ------------------
     * - Supports multi-currency via ccprice/cctaxamount fields (converted currency)
     * - Falls back to base currency (price/taxamount) when cc* fields are null
     *
     * PDF STRUCTURE:
     * --------------
     * [Header] → [Client/Billing/Shipping Info] → [Main Table] → [Sub Totals] →
     * [Additional Charges] → [Amount Chargeable] → [HSN Summary] →
     * [Footer + Bank Details] → [Remarks] → [Terms & Conditions]
     *
     * @param {Object} Invoicedata - Complete invoice data object from backend
     * @param {string} type - Output type: "pdf" (download) or "email" (send attachment)
     * =====================================================================================
     */
    handleDownload = (Invoicedata, type) => {
        console.log("LINE268", Invoicedata)
        console.log("LINE269", this.state.showPricesIn)

        // ─────────────────────────────────────────────────────────────────────
        // SECTION 1: DATA PREPARATION
        // Normalize products, services, and charges into unified data arrays
        // ─────────────────────────────────────────────────────────────────────
        let pagename = this.state.pagename;

        let curdate = moment().format("DD-MM-YYYY HH:mm:ss");
        let data = []
        let servdata = [];
        let additionalchares = [];
        let hsn = [];

        let supplytype = Invoicedata.gsttype.substring(0, 1).toUpperCase() + Invoicedata.gsttype.substring(1, Invoicedata.gsttype.length).toLowerCase();

        let addchargeslist =
            Invoicedata.additionalchares === null ? [] : Invoicedata.additionalchares;

        if (Invoicedata.invoiceitemlist !== null && Invoicedata.invoiceitemlist.length > 0) {
            Invoicedata.invoiceitemlist.map(e => {
                const itemPrice = Number(e.ccprice !== undefined && e.ccprice !== null ? e.ccprice : (e.price || 0));
                const itemQty = Number(e.quantity || 1);
                const itemDiscountAmount = Number(e.ccdiscountamount !== undefined && e.ccdiscountamount !== null ? e.ccdiscountamount : (e.ccdiscount !== undefined && e.ccdiscount !== null ? e.ccdiscount : (e.discountamount || 0)));
                const itemTotalPrice = itemPrice * itemQty;
                const itemTaxableValue = itemTotalPrice - itemDiscountAmount;
                const itemTaxAmount = e.cctaxamount !== undefined && e.cctaxamount !== null ? e.cctaxamount : (e.taxamount || 0);

                data.push({
                    name: e.name,
                    hsn: e.hsn,
                    price: itemPrice.toFixed(2),
                    quantity: e.quantity,
                    uom: e.uom,
                    discount: e.discount,
                    discountamount: itemDiscountAmount.toFixed(2),
                    totalprice: itemTotalPrice.toFixed(2),
                    taxablevalue: itemTaxableValue.toFixed(2),
                    taxamount: itemTaxAmount,
                    tax: e.tax,
                    type: 'product',
                    description: e.description || ''
                });
            });
        }
        if (Invoicedata.invoiceservicelist !== null && Invoicedata.invoiceservicelist.length > 0) {
            Invoicedata.invoiceservicelist.map(e => {
                const servicePrice = Number(e.ccservicecost !== undefined && e.ccservicecost !== null ? e.ccservicecost : (e.servicecost || e.ccservicetotal || e.servicetotal || 0));
                const qty = Number(e.quantity ? e.quantity : 1);
                const discAmt = Number(e.ccservicediscountamount !== undefined && e.ccservicediscountamount !== null ? e.ccservicediscountamount : (e.servicediscountamount || 0));
                const taxAmt = e.ccservicetaxamount !== undefined && e.ccservicetaxamount !== null ? e.ccservicetaxamount : (e.servicetaxamount !== undefined && e.servicetaxamount !== null ? e.servicetaxamount : (e.servicetaxamt !== undefined && e.servicetaxamt !== null ? e.servicetaxamt : ((servicePrice * qty - discAmt) * (Number(e.servicetax || 0) / 100))));

                data.push({
                    name: e.service,
                    hsn: e.servicecode,
                    price: servicePrice.toFixed(2),
                    quantity: qty,
                    uom: "OTH",
                    discount: e.servicediscount,
                    discountamount: discAmt.toFixed(2),
                    totalprice: (servicePrice * qty).toFixed(2),
                    taxablevalue: ((servicePrice * qty) - discAmt).toFixed(2),
                    taxamount: taxAmt,
                    tax: e.servicetax,
                    type: 'service',
                    description: e.description || ''
                });
            });
        }
        if (Invoicedata.additionalchares) {
            additionalchares = Invoicedata.additionalchares ?
                JSON.parse(JSON.stringify(Invoicedata.additionalchares)) : [];
            if (Invoicedata.insurancereq) {
                const insAmount = Number(Invoicedata.ccinsuranceamount !== undefined && Invoicedata.ccinsuranceamount !== null ? Invoicedata.ccinsuranceamount : (Invoicedata.insuranceamount || 0));
                const totalIns = Number(Invoicedata.cctotalinsurance !== undefined && Invoicedata.cctotalinsurance !== null ? Invoicedata.cctotalinsurance : (Invoicedata.totalinsurance || 0));
                data.push({
                    name: "INSURANCE",
                    hsn: 9917,
                    price: insAmount.toFixed(2),
                    quantity: '1',
                    uom: "OTH",
                    discountamount: (0).toFixed(2),
                    totalprice: insAmount.toFixed(2),
                    taxablevalue: insAmount.toFixed(2), // Added missing key for HSN aggregation
                    taxamount: (totalIns - insAmount).toFixed(2),
                    tax: Invoicedata.insurancetax,
                    type: 'insurance'
                });
            }
            additionalchares = additionalchares.map(e => {
                const additionalcharges = Number(e.ccadditionalcharges !== undefined && e.ccadditionalcharges !== null ?
                    e.ccadditionalcharges : (typeof e?.additionalcharges === 'number' ? e.additionalcharges : parseFloat(e?.additionalcharges || 0)));

                const additionalchargestaxamount = Number(e.ccadditionalchargestaxamount !== undefined && e.ccadditionalchargestaxamount !== null ?
                    e.ccadditionalchargestaxamount : (typeof e?.additionalchargestaxamount === 'number' ? e.additionalchargestaxamount : parseFloat(e?.additionalchargestaxamount || 0)));

                const totaladditionalcharges = Number(e.cctotaladditionalcharges !== undefined && e.cctotaladditionalcharges !== null ?
                    e.cctotaladditionalcharges : (typeof e?.totaladditionalcharges === 'number' ? e.totaladditionalcharges : parseFloat(e?.totaladditionalcharges || 0)));

                return {
                    ...e,
                    additionalcharges: additionalcharges.toFixed(2),
                    additionalchargestaxamount: additionalchargestaxamount.toFixed(2),
                    totaladditionalcharges: totaladditionalcharges.toFixed(2)
                };
            });

            // Push charges to data for HSN tax consistency
            additionalchares.forEach(c => {
                data.push({
                    name: c.natureofcharge,
                    hsn: '9965', // Default SAC for transport/services if not provided
                    price: parseFloat(c.additionalcharges || 0).toFixed(2),
                    quantity: 1,
                    uom: "OTH",
                    discountamount: (0).toFixed(2),
                    totalprice: parseFloat(c.additionalcharges || 0).toFixed(2),
                    taxablevalue: parseFloat(c.additionalcharges || 0).toFixed(2),
                    taxamount: parseFloat(c.additionalchargestaxamount || 0).toFixed(2),
                    tax: c.additionalchargestax,
                    type: 'charge'
                });
            });
        }
        hsn = data.map((e) => e.hsn);

        // ==================== PROCESS SERVICES DATA SEPARATELY FOR TAX CALCULATIONS ====================
        if (
            Invoicedata.sotype === "Services" ||
            Invoicedata.sotype === "ProductsServices"
        ) {
            servdata = (Invoicedata.invoiceservicelist || []).map((v) => {
                const cost = parseFloat(v.servicecost) || 0;
                const qty = parseFloat(v.quantity) || 1;
                let sTotal = v.servicetotal != null ? parseFloat(v.servicetotal) : (cost * qty);
                const taxRate = parseFloat(v.servicetax) || 0;
                const totalWithTax = v.servicetotalwtax != null ? parseFloat(v.servicetotalwtax) : (sTotal + (sTotal * taxRate / 100));
                const taxAmt = totalWithTax - sTotal;

                return {
                    ...v,
                    servicetotal: sTotal.toFixed(2),
                    servicetotalwtax: totalWithTax.toFixed(2),
                    cgst: (taxRate / 2).toFixed(2),
                    sgst: (taxRate / 2).toFixed(2),
                    servicetaxamt: taxAmt.toFixed(2),
                    cgstamt: (taxAmt / 2).toFixed(2),
                    sgstamt: (taxAmt / 2).toFixed(2),
                    servicecosttotal: (qty * sTotal).toFixed(2),
                    servicecost: sTotal.toFixed(2),
                };
            });
            if (servdata.length !== 0) {
                hsn = servdata.map((e) => e.servicecode);
            }
        }
        let tablecolp, tablecols, tablecolm;

        let baseTotalInvoice = data.filter(r => r.type === 'product' || r.type === 'service').reduce((sum, row) => sum + parseFloat(row.totalprice || 0), 0);
        let totalinvoice = baseTotalInvoice.toFixed(2);
        // Compute tax from line items (products + services + insurance)
        let productTaxSum = data.filter(r => r.type === 'product').reduce((s, r) => s + parseFloat(r.taxamount || 0), 0);
        let serviceTaxSum = data.filter(r => r.type === 'service').reduce((s, r) => s + parseFloat(r.taxamount || 0), 0);
        let insuranceTaxSum = data.filter(r => r.type === 'insurance').reduce((s, r) => s + parseFloat(r.taxamount || 0), 0);
        let additionalChargesTaxSum = (Invoicedata.additionalchares || []).reduce((s, e) => {
            const tax = parseFloat(e.ccadditionalchargestaxamount ?? e.additionalchargestaxamount) || 0;
            return s + tax;
        }, 0);
        let taxamount = (productTaxSum + serviceTaxSum + insuranceTaxSum + additionalChargesTaxSum).toFixed(2);
        // Compute discount from line items (only products and services)
        let totalDiscountFromItems = data.filter(r => r.type === 'product' || r.type === 'service').reduce((s, r) => s + parseFloat(r.discountamount || 0), 0);
        // totalinvoicewtax will be computed after all components are resolved
        let totalinvoicewtax = '0.00';
        let advance = Number(Invoicedata.ccadvanceamountreq !== undefined && Invoicedata.ccadvanceamountreq !== null ? Invoicedata.ccadvanceamountreq :
            (Invoicedata.advanceamountreq === null || Invoicedata.advanceamountreq === undefined
                ? 0.0
                : Invoicedata.advanceamountreq)).toFixed(2);
        let totaladditionalchares = 0;
        let insuranceamount = 0;
        let totaladdincinsu = 0;
        let tcsamount = 0;
        let totalexctcs = 0;
        totaladditionalchares = Number(Invoicedata.cctotaladditionalchares !== undefined && Invoicedata.cctotaladditionalchares !== null ?
            Invoicedata.cctotaladditionalchares : (Invoicedata.totaladditionalchares || 0)).toFixed(2);

        insuranceamount = Invoicedata.insurancereq ?
            Number(Invoicedata.cctotalinsurance !== undefined && Invoicedata.cctotalinsurance !== null ?
                Invoicedata.cctotalinsurance : (Invoicedata.totalinsurance || 0)).toFixed(2) : 0;

        totaladdincinsu = (
            parseFloat(totaladditionalchares) + parseFloat(insuranceamount)
        ).toFixed(2);
        if (Invoicedata.tcsreq) {
            tcsamount = Number(Invoicedata.cctcsamount !== undefined && Invoicedata.cctcsamount !== null ? Invoicedata.cctcsamount : (Invoicedata.tcsamount || 0)).toFixed(2);
        }
        // Compute totalinvoicewtax from all components
        // Note: insuranceamount is NOT added here because it is already in baseTotalInvoice (data[].totalprice)
        // totaladditionalchares IS added because charges in data[] do not have 'totalprice' key
        // Compute totalinvoicewtax from all components
        totalinvoicewtax = (
            baseTotalInvoice - totalDiscountFromItems + parseFloat(taxamount) +
            parseFloat(totaladditionalchares) + parseFloat(insuranceamount) +
            parseFloat(tcsamount)
        ).toFixed(2);
        if (Invoicedata.tcsreq) {
            totalexctcs = (parseFloat(totalinvoicewtax) - parseFloat(tcsamount)).toFixed(2);
        }
        const modifiedRows = data.filter(r => r.type === 'product' || r.type === 'service').map(row => {
            if (row.type === 'product' || row.type === 'service') {
                return {
                    ...row,
                    totaldiscount: (row.discount !== undefined && row.discount !== null ? `(${row.discount}%)` : "(0%)"),
                    quantity: row.quantity ?? 1,
                    uom: (row.uom ?? "OTH"),
                    combined: row.description ? `${row.name || ''}\n${row.description}` : (row.name || '')
                };
            }
            return {
                ...row,
                totaldiscount: (row.discount !== undefined && row.discount !== null ? `(${row.discount}%)` : "(0%)"),
                quantity: row.quantity ?? '',
                uom: (row.uom ?? ""),
                combined: row.name || ''
            };
        });
        const productCount = data.filter(r => r.type === 'product').length;
        const serviceCount = data.filter(r => r.type === 'service').length;
        let dynamicHeader = "Name of Product / Service";

        if (productCount > 0 && serviceCount === 0) {
            dynamicHeader = productCount === 1 ? "Name of Product" : "Names of Products";
        } else if (serviceCount > 0 && productCount === 0) {
            dynamicHeader = serviceCount === 1 ? "Name of Service" : "Names of Services";
        } else if (productCount > 0 && serviceCount > 0) {
            dynamicHeader = (productCount + serviceCount) > 1 ? "Names of Products & Services" : "Name of Product & Service";
        }
        if (Invoicedata.sotype === "Services") {
            tablecolp = [
                { header: dynamicHeader, dataKey: "combined" },
                ...(Invoicedata.taxtype === "GST" && ccountry === "India"
                    ? [{ header: "HSN/SAC", dataKey: "hsn" }]
                    : [{ header: "VAT (%)", dataKey: "tax" }]
                ),
                { header: "Quantity", dataKey: "quantity" },
                { header: `Rate in (${Invoicedata.currency})`, dataKey: "price" },
                { header: "UOM", dataKey: "uom" },
                { header: "Discount (%)", dataKey: "totaldiscount" },
                { header: `Amount in (${Invoicedata.currency})`, dataKey: "totalprice" },
            ];
        } else if (Invoicedata.sotype === "Products") {
            tablecolp = [
                { header: dynamicHeader, dataKey: "combined" },
                ...(Invoicedata.taxtype === "GST" && ccountry === "India"
                    ? [{ header: "HSN/SAC", dataKey: "hsn" }]
                    : [{ header: "VAT (%)", dataKey: "tax" }]
                ),
                { header: "Quantity", dataKey: "quantity" },
                { header: `Rate in (${Invoicedata.currency})`, dataKey: "price" },
                { header: "UOM", dataKey: "uom" },
                { header: "Discount (%)", dataKey: "totaldiscount" },
                { header: `Amount in (${Invoicedata.currency})`, dataKey: "totalprice" },
            ];
        } else if (Invoicedata.sotype === "ProductsServices") {
            tablecolp = [
                { header: dynamicHeader, dataKey: "combined" },
                ...(Invoicedata.taxtype === "GST" && ccountry === "India"
                    ? [{ header: "HSN/SAC", dataKey: "hsn" }]
                    : [{ header: "VAT (%)", dataKey: "tax" }]
                ),
                { header: "Quantity", dataKey: "quantity" },
                { header: `Rate in (${Invoicedata.currency})`, dataKey: "price" },
                { header: "UOM", dataKey: "uom" },
                { header: "Discount (%)", dataKey: "totaldiscount" },
                { header: `Amount in (${Invoicedata.currency})`, dataKey: "totalprice" },
            ];
        }
        tablecols = [
            { header: dynamicHeader, dataKey: "service" },
            { header: "HSN/SAC", dataKey: "servicecode" },
            { header: "Service Cost", dataKey: "servicetotal" },
            { header: "CGST (%)", dataKey: "cgst" },
            {
                header: `CGST Amount (${Invoicedata.currency})`,
                dataKey: "cgstamt",
            },
            { header: "SGST (%)", dataKey: "sgst" },
            {
                header: `SGST Amount (${Invoicedata.currency})`,
                dataKey: "sgstamt",
            },
            {
                header: `Total (${Invoicedata.currency})`,
                dataKey: "servicecosttotal",
            },
        ];
        tablecolm = [
            { header: "Nature of charge", dataKey: "natureofcharge" },
            { header: "CGST (%)", dataKey: "cgst" },
            // { header: "Total", dataKey: "totaladditionalcharges" },
            {
                header: `CGST Amount (${Invoicedata.currency})`,
                dataKey: "cgstamt",
            },
            { header: "SGST (%)", dataKey: "sgst" },
            {
                header: `SGST Amount (${Invoicedata.currency})`,
                dataKey: "sgstamt",
            },
            { header: "Amount", dataKey: "additionalcharges" },
        ];
        if (
            addchargeslist !== null &&
            addchargeslist !== undefined &&
            addchargeslist !== "" &&
            addchargeslist.length > 0
        ) {
            addchargeslist = addchargeslist.map((v) => {
                const taxAmount = typeof v?.additionalchargestaxamount === 'number' ?
                    v.additionalchargestaxamount : parseFloat(v?.additionalchargestaxamount || 0);
                const taxRate = typeof v?.additionalchargestax === 'number' ?
                    v.additionalchargestax : parseFloat(v?.additionalchargestax || 0);

                return {
                    ...v,
                    cgstamt: (taxAmount / 2).toFixed(2),
                    cgst: (taxRate / 2).toFixed(2),
                    sgstamt: (taxAmount / 2).toFixed(2),
                    sgst: (taxRate / 2).toFixed(2),
                };
            });
        }
        let order =
            pagename === "Tax Invoice Details" ? Invoicedata.approvestatus === "Approved" ? "TAX INVOICE" : "TEMP INVOICE" : "PROFORMA INVOICE";
        let invdate = moment(Invoicedata.createdAt).format("DD-MM-yyyy");
        let duedate = moment(Invoicedata.duedate).format("DD-MM-yyyy");
        let ackDt = moment(this.state.einvoicedata.ackDt).format(
            "DD-MM-yyyy HH:mm"
        );

        let milestones =
            Invoicedata.invoiceservicelist.length === 0
                ? []
                : Invoicedata.invoiceservicelist.find((e) => e).invoicemilestones ===
                    null
                    ? []
                    : Invoicedata.invoiceservicelist.map((e) => e.invoicemilestones);
        let declaration = "Declaration: We declare that the invoice shows the acctual price of the goods/services described and the particulers are true and correct."
        let temphsnlist = data.reduce((
            hsns,
            {
                hsn,
                name,
                totalprice,
                taxablevalue,
                taxamount,
                tax
            }
        ) => {
            if (!hsns[hsn]) hsns[hsn] = [];
            hsns[hsn].push({
                name: name,
                hsn: hsn,
                totalprice: totalprice,
                taxablevalue: taxablevalue,
                taxamount: taxamount,
                tax: tax
            });
            return hsns;
        },
            {}
        )

        let hsnlist = []
        Object.entries(temphsnlist).forEach(([key, value]) => {
            let a = {
                name: value.map((e) => e.name)[0],
                hsn: key,
                totalprice: value.reduce((a, v) => (a = a + parseFloat(v.taxablevalue || 0)), 0).toFixed(2),
                taxamount: value.reduce((a, v) => (a = a + parseFloat(v.taxamount || 0)), 0),
                tax: value.map((e) => e.tax)[0],
                cgst: value.reduce((a, v) => (a = a + parseFloat(v.taxamount || 0)), 0) / 2,
                cgstrate: value.map((e) => e.tax)[0] / 2,
                sgst: value.reduce((a, v) => (a = a + parseFloat(v.taxamount || 0)), 0) / 2,
                sgstrate: value.map((e) => e.tax)[0] / 2,
                totalwtax: parseFloat(value.reduce((a, v) => (a = a + parseFloat(v.taxablevalue || 0)), 0).toFixed(2)) + value.reduce((a, v) => (a = a + parseFloat(v.taxamount || 0)), 0)
            }
            hsnlist.push(a)
        })
        const processedHsnList = hsnlist.map(item => {
            const taxable = parseFloat(item.totalprice) || 0;
            const taxRate = parseFloat(item.tax) || 0;
            let cgstRate = 0, sgstRate = 0, igstRate = 0;
            let cgstAmt = 0, sgstAmt = 0, igstAmt = 0;
            if (Invoicedata.gsttype === "INTRASTATE") {
                cgstRate = taxRate / 2;
                sgstRate = taxRate / 2;
                cgstAmt = parseFloat((taxable * (cgstRate / 100)).toFixed(2));
                sgstAmt = parseFloat((taxable * (sgstRate / 100)).toFixed(2));
            } else {
                igstRate = taxRate;
                igstAmt = parseFloat((taxable * (igstRate / 100)).toFixed(2));
            }
            const totalTax = parseFloat((cgstAmt + sgstAmt + igstAmt).toFixed(2));
            const totalWithTax = parseFloat((taxable + totalTax).toFixed(2));

            return {
                ...item,
                totalprice: taxable.toFixed(2),
                cgstRate: cgstRate.toFixed(2),
                sgstRate: sgstRate.toFixed(2),
                igstRate: igstRate.toFixed(2),
                cgstAmt: cgstAmt.toFixed(2),
                sgstAmt: sgstAmt.toFixed(2),
                igstAmt: igstAmt.toFixed(2),
                taxamount: totalTax.toFixed(2),
                totalwtax: totalWithTax.toFixed(2),
            };
        });
        const grandTotals = processedHsnList.reduce(
            (acc, item) => {
                acc.taxable += parseFloat(item.totalprice) || 0;
                acc.cgst += parseFloat(item.cgstAmt) || 0;
                acc.sgst += parseFloat(item.sgstAmt) || 0;
                acc.igst += parseFloat(item.igstAmt) || 0;
                acc.totalTax += parseFloat(item.taxamount) || 0;
                return acc;
            },
            { taxable: 0, cgst: 0, sgst: 0, igst: 0, totalTax: 0 }
        );
        const hsnListWithoutTotal = processedHsnList.filter(item =>
            !item.hsn?.includes(`Total (${Invoicedata.currency})`)
        );
        hsnListWithoutTotal.push({
            hsn: `Total (${Invoicedata.currency})  `,
            cgstRate: "",
            sgstRate: "",
            igstRate: "",
            cgstAmt: grandTotals.cgst.toFixed(2),
            sgstAmt: grandTotals.sgst.toFixed(2),
            igstAmt: grandTotals.igst.toFixed(2),
            taxamount: grandTotals.totalTax.toFixed(2),
        });
        let totalinwords = CurrencyWordsFormatter.formatAmountInWords(
            parseFloat(totalinvoicewtax || 0),
            Invoicedata.currency || currency
        );

        let advanceinwords = CurrencyWordsFormatter.formatAmountInWords(
            parseFloat(advance || 0),
            Invoicedata.currency || currency
        );

        // ─────────────────────────────────────────────────────────────────────
        // SECTION 2: PDF DOCUMENT CREATION
        // Initialize jsPDF with A4 landscape orientation (842 x 595 pts)
        // ─────────────────────────────────────────────────────────────────────
        const doc = new jsPDF("p", "pt", [842, 595], true);

        // ----------------- Page Size Setup -----------------
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

        // ----------------- Border Variables -----------------
        const leftBorder = 15;
        const rightBorder = pageWidth - 15;
        const topBorder = 25;
        const bottomBorder = pageHeight - 40;

        // ----------------- Key Positioning Points -----------------
        const headerTopY = topBorder - 5;
        const headerCenterX = leftBorder + (rightBorder - leftBorder) / 2;
        const middleLine = leftBorder + (rightBorder - leftBorder) / 2;
        const footerY = bottomBorder + 15;
        const totalWidth = rightBorder - leftBorder;

        // ─────────────────────────────────────────────────────────────────────
        // SECTION 3: HSN TABLE CONFIGURATION
        // Dynamic columns based on GST type (INTRASTATE vs INTERSTATE)
        // ─────────────────────────────────────────────────────────────────────
        const hasDiscount = data.some(row => {
            const disc = row.discountamount || row.ccdiscountamount || row.discount || row.ccdiscount;
            return parseFloat(disc || 0) > 0;
        });
        let hsncolumns = [
            { header: "HSN/SAC", dataKey: "hsn" }
        ];

        if (hasDiscount) {
            hsncolumns.push({ header: `Taxable Value (${Invoicedata.currency})`, dataKey: "totalprice" });
        }
        if (Invoicedata.gsttype === "INTRASTATE") {
            hsncolumns.push(
                { header: "CGST (%)", dataKey: "cgstRate" },
                { header: `CGST (${Invoicedata.currency})`, dataKey: "cgstAmt" },
                { header: "SGST (%)", dataKey: "sgstRate" },
                { header: `SGST (${Invoicedata.currency})`, dataKey: "sgstAmt" }
            );
        } else {
            hsncolumns.push(
                { header: "IGST (%)", dataKey: "igstRate" },
                { header: `IGST (${Invoicedata.currency})`, dataKey: "igstAmt" }
            );
        }

        hsncolumns.push({ header: `Total Tax (${Invoicedata.currency})`, dataKey: "taxamount" });
        let hsnColumnStyles = {};

        if (Invoicedata.gsttype === "INTRASTATE") {
            if (hasDiscount) {
                hsnColumnStyles = {
                    0: {
                        cellWidth: totalWidth * 0.38,
                        halign: "left",
                        cellPadding: { left: 10, top: 2, right: 2, bottom: 2 },
                        fontSize: 6
                    },
                    1: {
                        cellWidth: totalWidth * 0.12,
                        halign: "right",
                        cellPadding: { right: 4, left: 4, top: 2, bottom: 2 }
                    },
                    2: {
                        cellWidth: totalWidth * 0.08,
                        halign: "center"
                    },
                    3: {
                        cellWidth: totalWidth * 0.12,
                        halign: "center"
                    },
                    4: {
                        cellWidth: totalWidth * 0.08,
                        halign: "center"
                    },
                    5: {
                        cellWidth: totalWidth * 0.10,
                        halign: "center"
                    },
                    6: {
                        cellWidth: totalWidth * 0.12,
                        halign: "right",
                        fontStyle: "normal"
                    }
                };
            } else {
                hsnColumnStyles = {
                    0: {
                        cellWidth: totalWidth * 0.50,
                        halign: "left",
                        cellPadding: { left: 10, top: 2, right: 2, bottom: 2 },
                        fontSize: 6
                    },
                    1: {
                        cellWidth: totalWidth * 0.08,
                        halign: "center"
                    },
                    2: {
                        cellWidth: totalWidth * 0.12,
                        halign: "center"
                    },
                    3: {
                        cellWidth: totalWidth * 0.08,
                        halign: "center"
                    },
                    4: {
                        cellWidth: totalWidth * 0.10,
                        halign: "center"
                    },
                    5: {
                        cellWidth: totalWidth * 0.12,
                        halign: "right",
                        fontStyle: "normal"
                    }
                };
            }
        } else {
            if (hasDiscount) {
                hsnColumnStyles = {
                    0: {
                        cellWidth: totalWidth * 0.58,
                        halign: "left",
                        cellPadding: { left: 10, top: 2, right: 2, bottom: 2 },
                        fontSize: 6
                    },
                    1: {
                        cellWidth: totalWidth * 0.12,
                        halign: "right",
                        cellPadding: { right: 4, left: 4, top: 2, bottom: 2 }
                    },
                    2: {
                        cellWidth: totalWidth * 0.08,
                        halign: "center"
                    },
                    3: {
                        cellWidth: totalWidth * 0.10,
                        halign: "center"
                    },
                    4: {
                        cellWidth: totalWidth * 0.12,
                        halign: "right",
                        fontStyle: "normal"
                    }
                };
            } else {
                hsnColumnStyles = {
                    0: {
                        cellWidth: totalWidth * 0.70,
                        halign: "left",
                        cellPadding: { left: 10, top: 2, right: 2, bottom: 2 },
                        fontSize: 6
                    },
                    1: {
                        cellWidth: totalWidth * 0.08,
                        halign: "center"
                    },
                    2: {
                        cellWidth: totalWidth * 0.10,
                        halign: "center"
                    },
                    3: {
                        cellWidth: totalWidth * 0.12,
                        halign: "right",
                        fontStyle: "normal"
                    }
                };
            }
        }

        // ─────────────────────────────────────────────────────────────────────
        // SECTION 4: INVOICE HEADER & DOCUMENT TYPE
        // Renders title (TAX INVOICE / PROFORMA / QUOTATION) and approval status
        // ─────────────────────────────────────────────────────────────────────
        doc.setDrawColor("#000000");

        doc.setFont("helvetica", "bold").setFontSize(6);
        // doc.text(`${curdate}`, leftBorder + 3, headerTopY);
        doc.setFontSize(10).setFont("helvetica", "bold").setTextColor("#000000");
        const orderTextWidth = doc.getTextWidth(order);
        doc.text(order, headerCenterX - orderTextWidth / 2, headerTopY - 3);
        if (order === "TAX INVOICE") {
            doc.setFontSize(6).setFont("helvetica", "bold");
            const extra = Invoicedata.approvestatus === "Approved" ? `(ORIGINAL FOR RECIPIENT)` : "(SAMPLE INVOICE)";
            doc.text(extra, rightBorder - doc.getTextWidth(extra) - 3, headerTopY);
        }

        // ----------------- Document Structure Variables -----------------
        const centerX = middleLine;
        const rightCenterX = middleLine + (rightBorder - middleLine) * 0.56;
        const leftText = leftBorder + 10;
        let leftY = topBorder + 15;
        doc.setTextColor("#000000");

        function wrapTextSmart(str, max = 50) {
            if (!str) return [];

            if (!str.includes(" ")) {
                const chunks = [];
                for (let i = 0; i < str.length; i += max) {
                    chunks.push(str.substring(i, i + max));
                }
                return chunks;
            }

            const words = str.split(" "), lines = [];
            let current = "";
            words.forEach(w => {
                if ((current + w).length <= max) {
                    current += (current ? " " : "") + w;
                } else {
                    lines.push(current);
                    current = w;
                }
            });
            if (current) lines.push(current);
            return lines;
        }

        doc.setTextColor("#000000");
        doc.setFont("helvetica", "bold").setFontSize(8).setTextColor("#000000");
        const clientNameStr = (clientname || "").toUpperCase();
        const clientLines = wrapTextSmart(clientNameStr, 50);
        clientLines.forEach((ln, i) => doc.text(ln, leftText, leftY + i * 10));
        leftY += clientLines.length * 10;
        doc.setFont("helvetica", "normal").setFontSize(6).setTextColor("#333333");
        [address, address2, `${ccity}, ${cstate}, ${ccountry} - ${czip}`]
            .filter(l => l)
            .forEach(l => {
                const wrapped = wrapTextSmart(l.toUpperCase(), 50);
                wrapped.forEach((line, i) => {
                    doc.text(line, leftText, leftY + i * 8);
                });
                leftY += wrapped.length * 8;
            });
        leftY += 2;
        doc.setTextColor("#000000");
        doc.setFontSize(7).setTextColor("#000000");
        if (pan && ccountry === "India") {
            doc.setFont("helvetica", "bold").text("PAN :", leftText, leftY);
            doc.setFont("helvetica", "normal").text(pan, leftText + 25, leftY);
            leftY += 10;
        }
        if (gstin && ccountry === "India") {
            doc.setFont("helvetica", "bold").text("GSTIN :", leftText, leftY);
            doc.setFont("helvetica", "normal").text(gstin, leftText + 30, leftY);
            leftY += 10;
        }
        if (companyemail) {
            doc.setFont("helvetica", "bold").text("EMAIL ID :", leftText, leftY);
            const emailLines = wrapTextSmart(companyemail, 65);
            emailLines.forEach((line, i) => {
                doc.setFont("helvetica", "normal")
                    .text(line, leftText + 40, leftY + i * 8);
            });
            leftY += emailLines.length * 8 + 2;
        }
        if (contactnumber) {
            doc.setFont("helvetica", "bold").text("PHONE NO :", leftText, leftY);
            doc.setFont("helvetica", "normal").text(contactnumber, leftText + 45, leftY);
            leftY += 5;
        }
        doc.setTextColor("#000000");
        // const logoW = 75, logoH = 60;

        const logoDimensions = this.getLogoDimensions(this.state.imgwidth, this.state.imgheight, !!logo)


        const logoW = logoDimensions.width;
        const logoH = logoDimensions.height;

        const logoX = rightBorder - logoW + 2;
        const logoY = topBorder + 5;
        const logoBottomY = logoY + logoH;
        const qRW = 60, qRH = 60;
        const qRX = centerX + 3;
        const qRY = topBorder + 3;
        const qRBottomY = qRY + qRH;
        const minClientBottom = logoBottomY + 5;
        const clientActualEnd = leftY;
        const clientSectionBottomY = Math.max(clientActualEnd, minClientBottom);
        leftY = clientSectionBottomY;
        doc.line(leftBorder, clientSectionBottomY, centerX, clientSectionBottomY);
        doc.line(centerX, topBorder, centerX, clientSectionBottomY);

        leftY = clientSectionBottomY + 8;
        const custName = (Invoicedata.customer || "").toUpperCase();
        doc.setFont("helvetica", "normal").setFontSize(7).text("(Billing Address)", leftText, leftY);
        leftY += 12;

        doc.setFont("helvetica", "bold").setFontSize(8);
        const billCustName = (Invoicedata.customer || "").toUpperCase();
        const billCustLines = wrapTextSmart(billCustName, 50);
        billCustLines.forEach((ln, i) => {
            doc.text(ln, leftText, leftY + i * 10);
        });
        leftY += billCustLines.length * 10;
        doc.setFont("helvetica", "normal").setFontSize(6).setTextColor("#333333");
        [
            Invoicedata.custadress,
            Invoicedata.custaddress2,
            `${Invoicedata.cityname}, ${Invoicedata.state}, ${Invoicedata.country} - ${Invoicedata.zip}`
        ]
            .filter(l => l)
            .forEach(l => {
                const wrapped = wrapTextSmart(l.toUpperCase(), 50);
                wrapped.forEach((line, i) => {
                    doc.text(line, leftText, leftY + i * 8);
                });
                leftY += wrapped.length * 8;
            });
        leftY += 2;
        doc.setTextColor("#000000");
        if (Invoicedata.custgstin) {
            doc.setFontSize(7).setTextColor("#000000")
                .setFont("helvetica", "bold").text("PAN :", leftText, leftY)
                .setFont("helvetica", "normal").text(Invoicedata.custgstin.substring(2, 12), leftText + 25, leftY);
            leftY += 10;
            doc.setFont("helvetica", "bold").text("GSTIN :", leftText, leftY)
                .setFont("helvetica", "normal").text(Invoicedata.custgstin, leftText + 30, leftY);
            leftY += 10;
        }
        if (Invoicedata.custmail) {
            doc.setFontSize(7);
            doc.setFont("helvetica", "bold").text("EMAIL ID :", leftText, leftY);
            const billEmailLines = wrapTextSmart(Invoicedata.custmail, 65);
            billEmailLines.forEach((line, i) => {
                doc.setFont("helvetica", "normal").text(line, leftText + 40, leftY + i * 8);
            });
            leftY += billEmailLines.length * 8 + 2;
        }
        if (Invoicedata.custphno) {
            doc.setFont("helvetica", "bold").text("PHONE NO :", leftText, leftY);
            doc.setFont("helvetica", "normal").text(`${Invoicedata.custphonecode}-${Invoicedata.custphno}`, leftText + 45, leftY);
            leftY += 5;
        }
        if (Invoicedata.vehiclenum) {
            leftY += 5;
            doc.setFont("helvetica", "bold").text("VEHICLE NO :", leftText, leftY);
            doc.setFont("helvetica", "normal").text(Invoicedata.vehiclenum, leftText + 45, leftY);
            leftY += 5;
        }
        const billingEndY = leftY;

        doc.setTextColor("#000000");
        const orderIdBoxIndex = 3;
        const tempRowH = 20;
        const orderIdBoxBottomY = clientSectionBottomY + (orderIdBoxIndex + 1) * tempRowH;
        const billingShippingDividerY = Math.max(billingEndY, orderIdBoxBottomY);
        leftY = billingShippingDividerY;
        doc.line(leftBorder, billingShippingDividerY, centerX, billingShippingDividerY);
        leftY = billingShippingDividerY + 8;
        doc.setFont("helvetica", "normal").setFontSize(7).text("(Shipping Address)", leftText, leftY);
        leftY += 12;

        doc.setFont("helvetica", "bold").setFontSize(8);
        const shipCustName = (Invoicedata.customer || "").toUpperCase();
        const shipCustLines = wrapTextSmart(shipCustName, 50);
        shipCustLines.forEach((ln, i) => {
            doc.text(ln, leftText, leftY + i * 10);
        });
        leftY += shipCustLines.length * 10;
        doc.setFont("helvetica", "normal").setFontSize(6).setTextColor("#333333");
        [
            Invoicedata.custadress,
            Invoicedata.custaddress2,
            `${Invoicedata.cityname}, ${Invoicedata.state}, ${Invoicedata.country} - ${Invoicedata.zip}`
        ]
            .filter(l => l)
            .forEach(l => {
                const wrapped = wrapTextSmart(l.toUpperCase(), 50);
                wrapped.forEach((line, i) => {
                    doc.text(line, leftText, leftY + i * 8);
                });
                leftY += wrapped.length * 8;
            });
        leftY += 2;
        doc.setTextColor("#000000");
        if (Invoicedata.custmail) {
            doc.setFontSize(7).setTextColor("#000000")
                .setFont("helvetica", "bold").text("EMAIL ID :", leftText, leftY);
            const shipEmailLines = wrapTextSmart(Invoicedata.custmail, 65);
            shipEmailLines.forEach((line, i) => {
                doc.setFont("helvetica", "normal").text(line, leftText + 40, leftY + i * 8);
            });
            leftY += shipEmailLines.length * 8 + 2;
        }
        if (Invoicedata.custphno) {
            doc.setFont("helvetica", "bold").text("PHONE NO :", leftText, leftY);
            doc.setFont("helvetica", "normal").text(`${Invoicedata.custphonecode}-${Invoicedata.custphno}`, leftText + 45, leftY);
            leftY += 5;
        }
        const leftSectionEndY = leftY;
        // const addImageCentered = (img, x, y, boxWidth, boxHeight, format = "GIF") => {
        //     console.log(boxWidth, boxHeight, "logoWidth1, logoHeight2");
        //     const imgAspect = 1; // 1:1 ratio - change to 1.5 for 3:2, 1.33 for 4:3, etc.

        //     let finalWidth, finalHeight, finalX, finalY;

        //     const boxAspect = boxWidth / boxHeight;

        //     if (imgAspect > boxAspect) {
        //         finalWidth = boxWidth;
        //         finalHeight = boxWidth / imgAspect;
        //         finalX = x;
        //         finalY = y + (boxHeight - finalHeight) / 2;
        //     } else {
        //         finalHeight = boxHeight;
        //         finalWidth = boxHeight * imgAspect;
        //         finalX = x + (boxWidth - finalWidth) / 2;
        //         finalY = y;
        //     }

        //     doc.addImage(img, format, finalX, finalY, finalWidth, finalHeight);
        // };

        const addImageCentered = (
            img,
            x,
            y,
            boxWidth,
            boxHeight,
            format = "GIF"
        ) => {
            const imgWidth = this.state.imgwidth
            const imgHeight = this.state.imgheight

            if (!img || !imgWidth || !imgHeight) return;

            // Actual image aspect ratio
            const imgAspect = imgWidth / imgHeight;

            // Box aspect ratio
            const boxAspect = boxWidth / boxHeight;

            let finalWidth;
            let finalHeight;
            let finalX;
            let finalY;

            // Image is wider than the box
            if (imgAspect > boxAspect) {

                finalWidth = boxWidth;
                finalHeight = boxWidth / imgAspect;

                finalX = x - 2;
                finalY = y + (boxHeight - finalHeight) / 2;

            } else {

                finalHeight = boxHeight;
                finalWidth = boxHeight * imgAspect;

                finalX = x - 5;
                finalY = y;
            }

            doc.addImage(
                img,
                format,
                finalX,
                finalY,
                finalWidth,
                finalHeight
            );
        };
        if (
            Invoicedata.einvoicestatus === "Generated" &&
            this.state.einvoicedata.irn !== undefined &&
            pagename === "Tax Invoice Details"
        ) {
            doc.setFillColor(255, 255, 255);

            doc.rect(qRX, qRY, qRW, qRH, "F");

            doc.addImage(this.state.QRcode, "PNG", qRX, qRY, qRW, qRH);

            let textStartY = qRBottomY + 18;
            doc.setFontSize(7);
            const irnRaw = this.state.einvoicedata.irn || "";
            const irnno = doc.splitTextToSize(irnRaw, 250);

            doc.setFont("helvetica", "bold");
            doc.text("IRN :", qRX, textStartY);

            doc.setFont("helvetica", "normal");
            if (irnno.length > 0) {
                doc.text(irnno, qRX + 20, textStartY, { maxWidth: 250 });
            }
        }
        if (logo) {
            doc.setFillColor(255, 255, 255);
            doc.rect(logoX, logoY, logoW, logoH, "F");
            addImageCentered(logo, logoX, logoY, logoW, logoH, "GIF");
        }
        const includeSupplyType = Invoicedata.taxtype === "GST" && ccountry === "India";
        const billingBoxes = [
            { label: "Invoice Id", value: `${Invoicedata.einvid ? Invoicedata.einvid : ""}` },
            { label: "Detailed Invoice Id", value: pagename === "Tax Invoice Details" ? Invoicedata.custominvid : Invoicedata.invid },
            { label: "Invoice Date", value: `${invdate}` },
            { label: "Due Date", value: `${Invoicedata.duedate ? duedate : invdate}` },
            ...(includeSupplyType ? [{ label: "Order Id", value: `${Invoicedata.customsoid ?? ""}` }] : []),
        ];
        const shippingBoxes = [
            ...(includeSupplyType
                ? [{ label: "Supply Type", value: `${supplytype?.toUpperCase() ?? ""}` }]
                : [{ label: "Order Id", value: `${Invoicedata.customsoid ?? ""}` }]
            ),
            { label: "Dispatch Through", value: `${Invoicedata.vehicletype ? Invoicedata.vehicletype : "N / A"}` },
            { label: "Vessel/Flight No / Vehicle No.", value: `${Invoicedata.vehiclenum ? Invoicedata.vehiclenum : "N / A"}` },
            { label: "Payment Terms", value: `${Invoicedata.paymentTerms ?? ""}` },
        ];
        const billingStartY = clientSectionBottomY;
        const billingEnd = billingShippingDividerY;
        const billingH = billingEnd - billingStartY;
        const brH = billingH / billingBoxes.length;
        const shipStart = billingShippingDividerY;
        const shipEnd = leftSectionEndY;
        const shipH = shipEnd - shipStart;
        const srH = shipH / shippingBoxes.length;
        doc.setDrawColor("#000000");
        doc.line(centerX, billingStartY, centerX, billingEnd);
        doc.line(rightCenterX, billingStartY, rightCenterX, billingEnd);
        doc.line(centerX, shipStart, centerX, shipEnd);
        doc.line(rightBorder, shipStart, rightBorder, shipEnd);
        doc.line(rightCenterX, shipStart, rightCenterX, shipEnd);
        const lblX = centerX + 10, valX = rightCenterX + 10;
        doc.setFontSize(7);
        doc.setDrawColor("#000000");
        billingBoxes.forEach((r, i) => {
            const y = billingStartY + i * brH;
            doc.line(centerX, y, rightBorder, y);

            const labelFont = 7;
            const valueFont = 7;
            const boxWidth = rightBorder - rightCenterX - 15;

            doc.setFont("helvetica", "bold").setFontSize(labelFont);
            doc.text(r.label, lblX, y + brH * 0.6);

            doc.setFont("helvetica", "normal").setFontSize(valueFont);
            const wrapped = doc.splitTextToSize(r.value || "", boxWidth);

            const textBlockHeight = wrapped.length * (valueFont + 2);
            const startY = y + (brH - textBlockHeight) / 2 + valueFont;


            doc.text(wrapped, valX, startY, { maxWidth: boxWidth });
        });
        shippingBoxes.forEach((r, i) => {
            const y = shipStart + i * srH;
            doc.line(centerX, y, rightBorder, y);

            const labelFont = 7;
            const valueFont = 7;
            const boxWidth = rightBorder - rightCenterX - 15;

            doc.setFont("helvetica", "bold").setFontSize(labelFont);
            doc.text(r.label, lblX, y + srH * 0.6);

            doc.setFont("helvetica", "normal").setFontSize(valueFont);
            const wrapped = doc.splitTextToSize(r.value || "", boxWidth);

            const textBlockHeight = wrapped.length * (valueFont + 2);
            const startY = y + (srH - textBlockHeight) / 2 + valueFont;


            doc.text(wrapped, valX, startY, { maxWidth: boxWidth });
        });

        // ─────────────────────────────────────────────────────────────────────
        // SECTION 5: MAIN PRODUCT/SERVICE TABLE
        // ─────────────────────────────────────────────────────────────────────
        let yax = shipEnd;
        let y = yax;
        let cellHeight = 15;

        doc.setDrawColor("#000000");

        const unifiedWidths = [0.38, 0.12, 0.08, 0.12, 0.08, 0.10, 0.12];
        let columnStyles = {};
        tablecolp.forEach((col, idx) => {
            if (idx < unifiedWidths.length) {
                columnStyles[idx] = {
                    cellWidth: totalWidth * unifiedWidths[idx],
                    halign: "center",
                    valign: "middle"
                };

                if (idx === 0) {
                    columnStyles[idx].halign = "left";
                    columnStyles[idx].valign = "top";
                    columnStyles[idx].cellPadding = { top: 10, right: 5, bottom: 5, left: 10 };
                } else if (idx === 6) {
                    columnStyles[idx].halign = "right";
                    columnStyles[idx].cellPadding = { right: 2 };
                } else if (idx === 3) {
                    columnStyles[idx].halign = "center";
                }
            }
        });
        let actualTableEndY = y;

        autoTable(doc, {
            theme: "grid",
            startY: y,
            margin: { top: 0, bottom: 40, right: 15, left: 15 },
            rowPageBreak: 'avoid',
            tableLineWidth: 0.1,
            tableLineColor: [51, 51, 51],

            didDrawPage: (HookData) => {
                HookData.settings.margin.top = 25;
                actualTableEndY = HookData.cursor.y;
                if (HookData.pageNumber > 1) {
                    doc.setFont("helvetica", "bold").setFontSize(8);
                    doc.setTextColor(0, 0, 0);

                    // Add "Continued..." text in the top border area
                    // const continueText = `Continued from previous page (${order} - ${Invoicedata.custominvid || Invoicedata.invid})`;
                    // const continueX = headerCenterX - doc.getTextWidth(continueText) / 2;
                    // doc.text(continueText, continueX, topBorder + 10);

                    doc.setFont("helvetica", "normal").setFontSize(7);
                }
            },

            didDrawCell: function (data) {
                if (data.column.dataKey === "combined" && data.cell.section === "body") {
                    const [serviceLine = '', descriptionLine = ''] = data.cell.raw.split('\n');
                    const { doc } = data;

                    const cellPadding = data.cell.styles.cellPadding || { top: 0, left: 0 };
                    const maxWidth = data.cell.width - 15;

                    doc.setFont("helvetica", "bold").setFontSize(7).setTextColor("#000000");
                    const wrappedService = doc.splitTextToSize(serviceLine, maxWidth);
                    const serviceHeight = wrappedService.length * 8;

                    let yPos;
                    if (!descriptionLine.trim()) {
                        yPos = data.cell.y + (data.cell.height - serviceHeight) / 2 + 6.5;
                    } else {
                        yPos = data.cell.y + cellPadding.top;
                    }

                    const xPos = data.cell.x + cellPadding.left;

                    wrappedService.forEach((line, index) => {
                        doc.text(line, xPos, yPos + (index * 8));
                    });
                    if (descriptionLine.trim()) {
                        yPos += (wrappedService.length * 8);

                        doc.setFont("helvetica", "normal").setFontSize(6).setTextColor("#333333");
                        const wrappedDescription = doc.splitTextToSize(descriptionLine, maxWidth);

                        wrappedDescription.forEach((line, index) => {
                            if (yPos + 7 > bottomBorder - 40) {
                                doc.addPage();
                                yPos = topBorder;
                            }
                            doc.text(line, xPos, yPos + index * 7);
                        });
                    }
                }

                if (data.cell.section === "body") {
                    actualTableEndY = Math.max(actualTableEndY, data.cell.y + data.cell.height);
                }
            },

            didParseCell: function (data) {
                if (data.column.dataKey === "combined" && data.cell.section === "body") {
                    const [serviceLine = '', descriptionLine = ''] = data.cell.raw.split('\n');

                    const targetCol0Width = totalWidth * 0.35;
                    doc.setFont("helvetica", "bold").setFontSize(7);
                    const serviceLines = doc.splitTextToSize(serviceLine, targetCol0Width - 4);

                    doc.setFont("helvetica", "normal").setFontSize(6);
                    const descriptionLines = doc.splitTextToSize(descriptionLine, targetCol0Width - 4);

                    const serviceHeight = serviceLines.length * 8;
                    const descriptionHeight = descriptionLine.trim() ? (descriptionLines.length * 7) : 0;

                    // Reduce height for INSURANCE type
                    const isInsurance = data.row.raw.type === 'insurance';

                    if (isInsurance) {
                        // Override global padding (top:10, bottom:5) which forces ~22pt height
                        data.cell.styles.cellPadding = { top: 2, left: 10, bottom: 2, right: 5 };
                    }

                    const verticalPadding = isInsurance ? 2 : (descriptionLine.trim() ? 8 : 5);
                    const minRowHeight = isInsurance ? 10 : cellHeight;

                    const totalContentHeight = serviceHeight + descriptionHeight + verticalPadding;
                    const requiredHeight = Math.max(minRowHeight, totalContentHeight);

                    data.cell.text = [''];
                    data.cell.styles.minCellHeight = requiredHeight;
                }

                if (data.section === "body" && data.column.dataKey !== "combined") {
                    const rows = data.table.body;
                    if (data.row.index === rows.length - 1) {
                        data.cell.styles.minCellHeight = cellHeight;
                    }
                }

                if (data.section === "head") {
                    data.cell.styles.minCellHeight = 15;
                    data.cell.styles.valign = "middle";

                    if (data.column.index === 0) {
                        data.cell.styles.halign = "left";
                        data.cell.styles.cellPadding = {
                            left: 10,
                        };

                    } else if (data.column.dataKey === "totalprice") {
                        data.cell.styles.halign = "right";
                    } else {
                        data.cell.styles.halign = "center";
                    }
                }

                if (data.section === "body") {
                    if (data.column.dataKey === "price" || data.column.dataKey === "totalprice") {
                        if (!isNaN(data.cell.raw)) {
                            data.cell.text = [rupeeFormatter(data.cell.raw)];
                        }
                    }
                }
            },

            styles: {
                textColor: [0, 0, 0],
                fontSize: 7,
                cellPadding: 0.8,
                overflow: 'linebreak',
                cellWidth: 'wrap'
            },

            headStyles: {
                fillColor: [256, 256, 256],
                textColor: [0, 0, 0],
                fontStyle: "bold",
                halign: "center",
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
            },

            bodyStyles: {
                halign: "center",
                lineColor: [51, 51, 51],
                lineWidth: 0.1,
                valign: 'top'
            },

            columnStyles,
            body: modifiedRows,
            columns: tablecolp,
        });

        doc.setDrawColor("#000000");

        const tableEndY = actualTableEndY;

        // ==================== SUB TOTAL 1 (Products + Services + Insurance) ====================
        const subTotal1 = baseTotalInvoice;

        let subTotal1Y = actualTableEndY + 10;
        let boxHeight = 20;
        let boxX = rightCenterX;
        let boxWidth = (rightBorder - boxX);
        let dividerX = leftBorder + (rightBorder - leftBorder) * 0.88;

        doc.setDrawColor(0);
        doc.setLineWidth(0.1);
        doc.rect(boxX, subTotal1Y - 10, boxWidth, boxHeight);
        doc.line(dividerX, subTotal1Y - 10, dividerX, subTotal1Y - 10 + boxHeight);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(7.0);
        doc.text(`Sub Total (${Invoicedata.currency})`, boxX + 2, subTotal1Y + 2, { align: "left" });
        doc.text(rupeeFormatter(subTotal1.toFixed(2)), rightBorder - 2, subTotal1Y + 2, { align: "right" });

        // ==================== ADDITIONAL CHARGES TABLE ====================
        let lineY = subTotal1Y + 10;
        let hasCharges = Invoicedata.additionalchares && Invoicedata.additionalchares.length > 0;

        if (hasCharges) {
            let isIntrastate = Invoicedata.gsttype === "INTRASTATE" && Invoicedata.taxtype === "GST";
            let chargeColumns = [];
            let chargeColumnStyles = {};
            const tableAvailableWidth = rightBorder - leftBorder;

            if (isIntrastate) {
                chargeColumns = [
                    { header: "Nature of charge", dataKey: "natureofcharge" },
                    { header: `Taxable Value (${Invoicedata.currency})`, dataKey: "additionalcharges" },
                    { header: "CGST (%)", dataKey: "cgstRate" },
                    { header: `CGST (${Invoicedata.currency})`, dataKey: "cgstAmt" },
                    { header: "SGST (%)", dataKey: "sgstRate" },
                    { header: `SGST (${Invoicedata.currency})`, dataKey: "sgstAmt" },
                    { header: `Total (${Invoicedata.currency})`, dataKey: "totaladditionalcharges" }
                ];
                chargeColumnStyles = {
                    0: { cellWidth: tableAvailableWidth * 0.38, halign: "left", cellPadding: { left: 10 } },
                    1: { cellWidth: tableAvailableWidth * 0.12, halign: "right" },
                    2: { cellWidth: tableAvailableWidth * 0.08, halign: "center" },
                    3: { cellWidth: tableAvailableWidth * 0.12, halign: "center" },
                    4: { cellWidth: tableAvailableWidth * 0.08, halign: "center" },
                    5: { cellWidth: tableAvailableWidth * 0.10, halign: "center" },
                    6: { cellWidth: tableAvailableWidth * 0.12, halign: "right" }
                };
            } else {
                let taxLabel = Invoicedata.taxtype || "Tax";
                if (Invoicedata.taxtype === "GST" && ccountry === "India") {
                    taxLabel = "IGST";
                }
                chargeColumns = [
                    { header: "Nature of charge", dataKey: "natureofcharge" },
                    { header: `Taxable Value (${Invoicedata.currency})`, dataKey: "additionalcharges" },
                    { header: `${taxLabel} (%)`, dataKey: "taxRate" },
                    { header: `${taxLabel} (${Invoicedata.currency})`, dataKey: "taxAmt" },
                    { header: `Total (${Invoicedata.currency})`, dataKey: "totaladditionalcharges" }
                ];
                chargeColumnStyles = {
                    0: { cellWidth: tableAvailableWidth * 0.58, halign: "left", cellPadding: { left: 10 } },
                    1: { cellWidth: tableAvailableWidth * 0.12, halign: "right", cellPadding: { right: 4, left: 4, top: 2, bottom: 2 } },
                    2: { cellWidth: tableAvailableWidth * 0.08, halign: "center" },
                    3: { cellWidth: tableAvailableWidth * 0.10, halign: "center" },
                    4: { cellWidth: tableAvailableWidth * 0.12, halign: "right" }
                };
            }

            let chargeY = subTotal1Y - 10 + boxHeight;

            const pageHeight = doc.internal.pageSize.height;
            if (chargeY > pageHeight - 60) {
                doc.addPage();
                chargeY = topBorder;
                doc.setDrawColor("#000000");
            }

            let body = Invoicedata.additionalchares.map(row => {
                const baseAmt = parseFloat(row.additionalcharges || 0);
                const taxRate = parseFloat(row.additionalchargestax || 0);
                const taxAmt = parseFloat(row.additionalchargestaxamount || 0);
                const totalAmt = parseFloat(row.totaladditionalcharges || 0);

                if (isIntrastate) {
                    return {
                        natureofcharge: row.natureofcharge,
                        additionalcharges: rupeeFormatter(baseAmt.toFixed(2)),
                        cgstRate: `${(taxRate / 2).toFixed(2)}%`,
                        cgstAmt: rupeeFormatter((taxAmt / 2).toFixed(2)),
                        sgstRate: `${(taxRate / 2).toFixed(2)}%`,
                        sgstAmt: rupeeFormatter((taxAmt / 2).toFixed(2)),
                        totaladditionalcharges: rupeeFormatter(totalAmt.toFixed(2))
                    };
                } else {
                    return {
                        natureofcharge: row.natureofcharge,
                        additionalcharges: rupeeFormatter(baseAmt.toFixed(2)),
                        taxRate: `${taxRate}%`,
                        taxAmt: rupeeFormatter(taxAmt.toFixed(2)),
                        totaladditionalcharges: rupeeFormatter(totalAmt.toFixed(2))
                    };
                }
            });

            if (Invoicedata.tcsreq && (Invoicedata.cctcsamount || Invoicedata.tcsamount)) {
                const tcsRateVal = parseFloat(Invoicedata.tcs || 0);
                const tcsAmtVal = parseFloat(Invoicedata.cctcsamount || Invoicedata.tcsamount || 0);
                const tcsBase = parseFloat(Invoicedata.cctcsableamount || Invoicedata.tcsableamount || 0);

                if (isIntrastate) {
                    body.push({
                        natureofcharge: `TCS (${tcsRateVal}%)`,
                        additionalcharges: rupeeFormatter(tcsBase.toFixed(2)),
                        cgstRate: `${(tcsRateVal / 2).toFixed(2)}%`,
                        cgstAmt: rupeeFormatter((tcsAmtVal / 2).toFixed(2)),
                        sgstRate: `${(tcsRateVal / 2).toFixed(2)}%`,
                        sgstAmt: rupeeFormatter((tcsAmtVal / 2).toFixed(2)),
                        totaladditionalcharges: rupeeFormatter(tcsAmtVal.toFixed(2))
                    });
                } else {
                    body.push({
                        natureofcharge: `TCS (${tcsRateVal}%)`,
                        additionalcharges: rupeeFormatter(tcsBase.toFixed(2)),
                        taxRate: `${tcsRateVal.toFixed(2)}%`,
                        taxAmt: rupeeFormatter(tcsAmtVal.toFixed(2)),
                        totaladditionalcharges: rupeeFormatter(tcsAmtVal.toFixed(2))
                    });
                }
            }



            autoTable(doc, {
                startY: chargeY,
                theme: "grid",
                margin: { left: leftBorder, right: 15, top: topBorder },
                head: [chargeColumns.map(col => col.header)],
                body,
                tableLineWidth: 0,
                columns: chargeColumns,
                columnStyles: chargeColumnStyles,
                styles: {
                    fontSize: 6,
                    cellPadding: 2,
                    lineWidth: 0.1,
                    lineColor: [51, 51, 51],
                    textColor: [0, 0, 0],
                    overflow: 'linebreak',
                    cellWidth: 'wrap',
                    valign: 'middle'
                },
                headStyles: {
                    fillColor: [256, 256, 256],
                    textColor: [0, 0, 0],
                    fontStyle: "bold",
                    halign: "center",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    valign: "middle",
                    minCellHeight: 15,
                    fontSize: 6.5
                },
                bodyStyles: {
                    lineColor: [51, 51, 51],
                    lineWidth: 0.1
                },
                didParseCell: function (data) {
                    if (data.section === "head") {
                        if (data.column.index === 0) {
                            data.cell.styles.halign = "left";
                            data.cell.styles.cellPadding = { left: 10 };
                        } else if (data.column.dataKey.includes("Rate") || data.column.dataKey.includes("Amt")) {
                            data.cell.styles.halign = "center";
                        } else if (data.column.dataKey === "additionalcharges") {
                            data.cell.styles.halign = "right";
                            // Synced with HSN table: 4pt padding as requested
                            data.cell.styles.cellPadding = { right: 4, left: 4, top: 2, bottom: 2 };
                        } else {
                            data.cell.styles.halign = "right";
                        }
                    }
                    if (data.section === "body") {
                        if (data.column.dataKey.includes("Rate")) {
                            data.cell.styles.halign = "center";
                        }
                        if (data.column.dataKey === "totaladditionalcharges") {
                            data.cell.styles.fontStyle = "normal";
                            data.cell.styles.fontSize = 7;
                        }
                        if (data.column.dataKey === "additionalcharges") {
                            data.cell.styles.halign = "right";
                            data.cell.styles.cellPadding = { right: 4 };
                        }
                    }
                },
                didDrawPage: (hookData) => {
                    lineY = hookData.cursor.y;
                }
            });

            const chargesTableSum = body.reduce((sum, row) => {
                const amt = parseFloat(row.totaladditionalcharges.replace(/[^0-9.-]+/g, "")) || 0;
                return sum + amt;
            }, 0);
            const subTotal2 = subTotal1 + chargesTableSum;

            let subTotal2Y = lineY + 10;
            doc.setDrawColor(0);
            doc.setLineWidth(0.1);
            doc.rect(boxX, subTotal2Y - 10, boxWidth, boxHeight);
            doc.line(dividerX, subTotal2Y - 10, dividerX, subTotal2Y - 10 + boxHeight);

            doc.setFont("helvetica", "bold");
            doc.setFontSize(7.0);
            doc.text(`Sub Total (${Invoicedata.currency})`, boxX + 2, subTotal2Y + 2, { align: "left" });
            doc.text(rupeeFormatter(subTotal2.toFixed(2)), rightBorder - 2, subTotal2Y + 2, { align: "right" });

            lineY = subTotal2Y + 10;
        } else {
            lineY = subTotal1Y + 10;
        }

        doc.setDrawColor("#000000");
        doc.setLineWidth(0.1);

        // ==================== AMOUNT CHARGEABLE SECTION ====================
        y = lineY;

        if (y + 50 > bottomBorder) {
            doc.addPage([595.28, 841.89]);
            y = topBorder;
            doc.setFont("helvetica", "normal");
            doc.setTextColor("#000");
            doc.setFontSize(7);
        }

        doc.setFontSize(7);
        doc.setTextColor("#000000");

        let rows = [];

        const discountVal = totalDiscountFromItems;
        if (discountVal > 0) {
            rows.push({
                label: "Discount",
                value: "(" + rupeeFormatter(discountVal.toFixed(2)) + ")",
                bold: true
            });
        }

        if (Invoicedata.taxtype === "GST" && ccountry === "India") {
            if (Invoicedata.gsttype === "INTRASTATE") {
                rows.push(
                    { label: "CGST", value: rupeeFormatter((taxamount / 2).toFixed(2)), bold: true },
                    { label: "SGST", value: rupeeFormatter((taxamount / 2).toFixed(2)), bold: true }
                );
            } else {
                rows.push({ label: "IGST", value: rupeeFormatter(taxamount), bold: true });
            }
        } else {
            rows.push({
                label: `${Invoicedata.taxtype} (${Invoicedata.currency})`,
                value: rupeeFormatter(taxamount),
                bold: true
            });
        }

        const hasChargesTable = Invoicedata.additionalchares && Invoicedata.additionalchares.length > 0;
        if (Invoicedata.tcsreq && tcsamount) {
            rows.push({
                label: `TCS (${Invoicedata.tcs || 0}% On ${rupeeFormatter((parseFloat(Invoicedata.cctcsableamount ?? Invoicedata.tcsableamount) || 0).toFixed(2))})`,
                value: rupeeFormatter(parseFloat(tcsamount).toFixed(2)),
                bold: true
            });
        }

        rows.push({ label: `Total (${Invoicedata.currency})`, value: rupeeFormatter(totalinvoicewtax), bold: true });

        const rowHeight = 20;
        const yStart = y;
        let yEnd = yStart + rows.length * rowHeight;

        doc.setFontSize(7);
        let maxValueWidth = 0;
        rows.forEach((row) => {
            const valueText =
                typeof row.value === "string" ? row.value : rupeeFormatter(`${row.value}`);
            const width = doc.getTextWidth(valueText);
            if (width > maxValueWidth) maxValueWidth = width;
        });

        const padding = 15;
        let dynamicDividerX = leftBorder + (rightBorder - leftBorder) * 0.88;
        if (maxValueWidth + padding > (rightBorder - dynamicDividerX)) {
            dynamicDividerX = rightBorder - (maxValueWidth + padding);
        }

        doc.line(rightCenterX, yStart, rightBorder, yStart);
        doc.line(rightCenterX, yEnd, rightBorder, yEnd);
        doc.line(rightCenterX, yStart, rightCenterX, yEnd);
        doc.line(rightBorder, yStart, rightBorder, yEnd);
        doc.line(dynamicDividerX, yStart, dynamicDividerX, yEnd);

        rows.forEach((row, i) => {
            const rowTop = yStart + i * rowHeight;
            const rowMiddle = rowTop + rowHeight / 2 + 2;

            const isTotal = row.label.startsWith("Total");

            doc.setFont("helvetica", "bold");
            doc.setFontSize(isTotal ? 7.5 : 6.5);
            doc.text(row.label, rightCenterX + 2, rowMiddle, { align: "left" });
            if (isTotal) {
                doc.setFont("helvetica", "bold");
            } else {
                doc.setFont("helvetica", "normal");
            }
            doc.text(
                typeof row.value === "string" ? row.value : rupeeFormatter(`${row.value}`),
                rightBorder - 2,
                rowMiddle,
                { align: "right" }
            );

            if (i < rows.length - 1) {
                doc.line(rightCenterX, rowTop + rowHeight, rightBorder, rowTop + rowHeight);
            }
        });
        doc.setFont("helvetica", "bold");
        doc.setFontSize(6);
        doc.text(`Amount Chargeable (in words):`, leftText, yEnd - 40);

        doc.setFont("helvetica", "normal");
        doc.setTextColor("#333333");
        doc.setFontSize(6);

        const maxWidth = rightCenterX - leftText;

        const wrappedText = doc.splitTextToSize(
            `${totalinwords}  (${Invoicedata.currency}) Only /-`,
            maxWidth
        );

        let currentY = yEnd - 30;
        wrappedText.forEach((line) => {
            doc.text(line, leftText, currentY);
            currentY += 6;
        });

        doc.setFontSize(7);
        doc.setTextColor("#000000");

        doc.line(leftBorder, yEnd, rightBorder, yEnd);

        // ==================== HSN SUMMARY TABLE ====================
        if (y + 50 > bottomBorder) {
            doc.addPage([595.28, 841.89]);
            yEnd = topBorder;
            doc.setFont("helvetica", "normal");
            doc.setTextColor("#000");
            doc.setFontSize(7);
        }

        if (Invoicedata.taxtype === "GST" && ccountry === "India") {
            autoTable(doc, {
                theme: "grid",
                startY: yEnd,
                margin: { top: 0, bottom: 0, right: 15, left: 15 },
                styles: {
                    textColor: [0, 0, 0],
                    fontSize: 6,
                    cellPadding: 2,
                    lineWidth: 0.1,
                    lineColor: [51, 51, 51]
                },

                headStyles: {
                    fillColor: [256, 256, 256],
                    textColor: [0, 0, 0],
                    fontSize: 6.5,
                    fontStyle: "bold",
                    halign: "center",
                    valign: "middle",
                    lineWidth: 0.5,
                    lineColor: [0, 0, 0],
                    minCellHeight: 15
                },

                bodyStyles: {
                    halign: "center",
                    lineColor: [51, 51, 51],
                    lineWidth: 0.1,
                    valign: "middle"
                },

                columnStyles: hsnColumnStyles,

                body: hsnListWithoutTotal,
                columns: hsncolumns,

                didParseCell: function (data) {
                    if (data.section === "head" && data.column.dataKey === "hsn") {
                        data.cell.styles.halign = "left";
                        data.cell.styles.valign = "middle";
                        data.cell.styles.cellPadding = { left: 10 };
                    }
                    if (data.section === "head" && (data.column.dataKey === "taxamount" || data.column.dataKey === "totalprice")) {
                        data.cell.styles.halign = "right";
                        data.cell.styles.valign = "middle";
                        // Sync with Additional Charges table: 4pt padding as requested
                        data.cell.styles.cellPadding = { right: 4, left: 4, top: 2, bottom: 2 };
                    }
                    if (data.section === "head" && (data.column.dataKey.includes("Rate") || (data.column.dataKey.includes("Amt") && data.column.dataKey !== "taxamount"))) {
                        data.cell.styles.halign = "center";
                        data.cell.styles.valign = "middle";
                    }

                    if (data.section === "body") {
                        if (data.column.dataKey === "totalprice") {
                            data.cell.styles.halign = "right";
                            data.cell.styles.cellPadding = { right: 4 };
                        }
                        if (["cgstRate", "sgstRate", "igstRate"].includes(data.column.dataKey)) {
                            if (data.cell.raw !== "" && !isNaN(data.cell.raw)) {
                                data.cell.text = [parseFloat(data.cell.raw).toFixed(2) + "%"];
                            }
                        }

                        if (["cgstAmt", "sgstAmt", "igstAmt", "taxamount"].includes(data.column.dataKey)) {
                            if (!isNaN(data.cell.raw)) {
                                data.cell.text = [rupeeFormatter(data.cell.raw)];
                            }
                        }
                    }

                    if (data.row.raw?.hsn?.includes(`Total (${Invoicedata.currency})`)) {
                        data.cell.styles.cellPadding = { top: 4, bottom: 4, right: 2 };
                        data.cell.styles.halign = "right";
                        data.cell.styles.fontSize = "6";
                        if (Invoicedata.gsttype === "INTRASTATE") {
                            if (["cgstAmt", "sgstAmt"].includes(data.column.dataKey)) {
                                data.cell.styles.fontStyle = "normal";
                                data.cell.styles.halign = "center";
                                data.cell.styles.valign = "middle";
                                if (!isNaN(data.cell.raw)) {
                                    data.cell.text = [rupeeFormatter(data.cell.raw)];
                                }
                            }
                            if (["igstRate", "igstAmt"].includes(data.column.dataKey)) {
                                data.cell.text = [""];
                            }
                        } else {
                            if (["igstAmt"].includes(data.column.dataKey)) {
                                data.cell.styles.fontStyle = "normal";
                                data.cell.styles.halign = "center";
                                data.cell.styles.valign = "middle";
                                if (!isNaN(data.cell.raw)) {
                                    data.cell.text = [rupeeFormatter(data.cell.raw)];
                                }
                            }
                            if (["cgstRate", "cgstAmt", "sgstRate", "sgstAmt"].includes(data.column.dataKey)) {
                                data.cell.text = [""];
                            }
                        }
                        if (data.column.dataKey === "taxamount") {
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.halign = "right";
                            data.cell.styles.valign = "middle";
                            data.cell.styles.cellPadding = { right: 2 };
                            if (!isNaN(data.cell.raw)) {
                                data.cell.text = [rupeeFormatter(data.cell.raw)];
                            }
                        }

                        if (["cgstRate", "sgstRate", "igstRate"].includes(data.column.dataKey)) {
                            data.cell.text = [""];
                        }
                        if (data.column.dataKey === "hsn") {
                            data.cell.styles.halign = "right";
                            data.cell.styles.fontStyle = "bold";
                            data.cell.styles.cellPadding = { right: 2 };
                        }
                    }
                },
            });

            y = doc.lastAutoTable.finalY;
        } else {
            y = yEnd;
        }

        doc.setDrawColor("#000000");

        // ==================== FOOTER SECTIONS ====================

        if (y + 100 > bottomBorder) {
            doc.addPage([595.28, 841.89]);
            y = topBorder;
            doc.setFont("helvetica", "normal");
            doc.setTextColor("#000");
            doc.setFontSize(7);
        }

        let startEndY = y;

        const textLeftX = centerX;
        const textRightX = rightBorder;
        const textWidth = textRightX - textLeftX;
        const textCenterX = textLeftX + textWidth / 2;

        function wrapClientName(text, firstLimit = 30, otherLimit = 60) {
            if (!text) return [];
            let words = text.split(" ");
            let lines = [];
            let currentLine = "";
            let limit = firstLimit;

            words.forEach((word) => {
                if ((currentLine + word).length > limit) {
                    lines.push(currentLine.trim());
                    currentLine = word + " ";
                    limit = otherLimit;
                } else {
                    currentLine += word + " ";
                }
            });

            if (currentLine.trim()) lines.push(currentLine.trim());
            return lines;
        }

        const certLines = wrapClientName(clientname.toUpperCase(), 30, 60);
        const bankLines = [
            ["Bank Name", this.state.bankdetails.bankname || ""],
            ["Bank Acc No.", this.state.bankdetails.accno || ""],
            ["Branch Name", this.state.bankdetails.branchname || ""],
            ["IFSC", this.state.bankdetails.ifsc || ""]
        ];
        const signLines = [
            "Authorised Signatory",
            "System generated invoice - no need for signature"
        ];

        const lh = 8;
        const pad = 25;
        const margin = 5;
        const certTopHeight = 12 + lh + certLines.length * lh + 8;

        const bankHeight = bankLines.length * lh;
        const signHeight = pad + signLines.length * lh;

        const finalBoxHeight = certTopHeight + Math.max(bankHeight, signHeight) + margin;
        const boxTop = y;

        doc.setDrawColor(0).setLineWidth(0.1);
        doc.rect(leftBorder, boxTop, centerX - leftBorder, finalBoxHeight - 10);
        doc.rect(centerX, boxTop, textWidth, finalBoxHeight - 10);
        let cy = boxTop + 12;
        doc.setFont("helvetica", "normal").setFontSize(6).setTextColor("#000000");
        doc.text("We certified that particulars given above are true and correct", textCenterX, cy, { align: "center" });
        cy += lh + 2; doc.setFontSize(6);

        certLines.forEach((line, i) => {
            const yPos = cy + i * lh;

            if (i === 0) {
                doc.setFont("helvetica", "normal");
                const forText = "for ";
                const forWidth = doc.getTextWidth(forText);

                doc.setFont("helvetica", "bold");
                const lineWidth = doc.getTextWidth(line);
                const totalWidth = forWidth + lineWidth;
                const startX = textCenterX - totalWidth / 2;

                doc.setFont("helvetica", "normal");
                doc.text(forText, startX, yPos);
                doc.setFont("helvetica", "bold");
                doc.text(line, startX + forWidth, yPos);

            } else {
                doc.setFont("helvetica", "bold");
                doc.text(line, textCenterX, yPos, { align: "center" });
            }
        });

        const dividerY = boxTop + certTopHeight - 10;
        doc.setFont("helvetica", "bold").setFontSize(7);
        doc.text("Bank Details", leftText, dividerY - 5);
        doc.setDrawColor(0).setLineWidth(0.1);
        doc.line(leftBorder, dividerY, rightBorder, dividerY);

        // === BANK DETAILS SECTION ===
        cy = dividerY + 5;
        cy += 5;
        doc.setFont("helvetica", "bold").setFontSize(7);
        const lineGap = lh * 1.3;

        bankLines.forEach(([label, value], i) => {
            const yPos = cy + i * lineGap;

            doc.setFont("helvetica", "bold");
            doc.text(label, leftText, yPos);

            doc.setFont("helvetica", "normal");
            doc.text(":", leftText + 70, yPos);

            doc.text(value, leftText + 80, yPos);
        });

        // === SIGNATORY SECTION ===
        cy = dividerY + pad;
        doc.setFont("helvetica", "bold").setFontSize(7);
        doc.text(signLines[0], textCenterX, cy, { align: "center" });
        doc.setFont("helvetica", "normal").setFontSize(6);
        doc.text(signLines[1], textCenterX, cy + lh, { align: "center" });

        const endY = boxTop + finalBoxHeight;

        y = endY;

        // ==================== REMARKS SECTION ====================
        if (y + 30 > bottomBorder) {
            doc.addPage([595.28, 841.89]);
            y = topBorder;
            doc.setFont("helvetica", "normal").setTextColor("#000").setFontSize(7);
        }

        doc.setFont("helvetica", "bold").setFontSize(7);
        y += 10;
        doc.text("Remarks: ", leftText, y);

        doc.setFont("helvetica", "normal").setFontSize(6);
        const remarks = Invoicedata.invoiceremarks || "";

        if (remarks && remarks.length > 0) {
            const pageHeight = doc.internal.pageSize.height;
            const margin = 35;
            const lineHeight = 6;
            let yPos = y + 10;

            const maxRemarkWidth = rightBorder - leftText - 10;
            const wrappedRemarkText = doc.splitTextToSize(remarks, maxRemarkWidth);

            wrappedRemarkText.forEach((line) => {
                if (yPos + lineHeight > pageHeight - margin) {
                    doc.addPage();
                    yPos = margin;
                    doc.setFont("helvetica", "normal").setFontSize(6);
                }
                doc.text(line, leftText + 5, yPos);
                yPos += lineHeight;
            });

            y = yPos + 10;
        } else {
            y += 30;
        }

        // ==================== TERMS AND CONDITIONS SECTION ====================
        if (
            this.state.templete.terms !== undefined &&
            this.state.templete.terms !== null &&
            this.state.templete.terms.length > 0
        ) {
            if (y + 30 > bottomBorder) {
                doc.addPage([595.28, 841.89]);
                y = topBorder;
                doc.setFont("helvetica", "normal");
                doc.setTextColor("#000000");
                doc.setFontSize(7);

            } else {
                doc.line(leftBorder, y, rightBorder, y);
            }

            doc.setFont("helvetica", "bold").setFontSize(7);
            doc.text("Terms and Conditions: ", leftBorder + 10, y + 15);

            doc.setFont("helvetica", "normal").setFontSize(6);

            if (this.state.templete.terms) {
                const pageHeight = doc.internal.pageSize.height;
                const margin = 35;
                const lineHeight = 7;
                let yPos = y + 30;

                const splitTitle = doc.splitTextToSize(this.state.templete.terms, 500);

                splitTitle.forEach((line) => {
                    if (yPos + lineHeight > pageHeight - margin) {
                        doc.addPage();
                        yPos = margin;
                    }
                    doc.text(
                        line,
                        35,
                        yPos
                    );
                    yPos += lineHeight;
                });
            }
        }

        // ==================== FINAL PAGE BORDERS AND FOOTERS ====================
        doc.setTextColor("#000000");
        const pageCount = doc.internal.getNumberOfPages();

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setTextColor("#000000");
            doc.line(leftBorder, topBorder, rightBorder, topBorder);
            doc.line(leftBorder, bottomBorder, rightBorder, bottomBorder);
            doc.line(leftBorder, topBorder, leftBorder, bottomBorder);
            doc.line(rightBorder, topBorder, rightBorder, bottomBorder);

            const footer = `Page ${i} of ${pageCount}`;
            doc.setFont("helvetica", "normal").setFontSize(7);
            doc.setTextColor("#000000");
            doc.text(footer, headerCenterX - doc.getTextWidth(footer) / 2, footerY, { baseline: "bottom" });
        }

        // ==================== FINAL OUTPUT HANDLING ====================
        if (type === "pdf") {
            doc.autoPrint({ variant: "non-conform" });
            doc.save(
                `${pagename === "Tax Invoice Details"
                    ? Invoicedata.custominvid
                    : Invoicedata.invid
                }.pdf`
            );
        } else {
            const blob = doc.output("blob");
            let file = null;
            if (pagename === "Tax Invoice Details") {
                file = new File([blob], `${Invoicedata.custominvid}.pdf`);
            } else {
                file = new File([blob], `${Invoicedata.invid}.pdf`);
            }

            let formData = new FormData();
            formData.append("file", file);
            formData.append("id", this.state.id);

            if (pagename === "Tax Invoice Details") {
                SalesServices.SendInvoicemail(formData)
                    .then((response) =>
                        this.setState({ loader: false }, () => {
                            if (Invoicedata.approvestatus !== "Pending") {
                                Swal.fire({
                                    title: `Mail Sent Successfully`,
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                            }
                        })
                    )
                    .catch((e) =>
                        this.setState(
                            { message: e.response.data.message, loader: false },
                            () => {
                                if (e.response.data.error === "Unauthorized") {
                                    Swal.fire({
                                        title: `Your Session is Lost: Please login Back to resume`,
                                        text: ".",
                                        icon: "error",
                                        confirmButtonText: "Ok",
                                        confirmButtonColor: "#152f5f",
                                    }).then(() => this.props.navigate("/"));
                                } else {
                                    Swal.fire({
                                        title: `Server Error, please try again later`,
                                        text: ".",
                                        icon: "error",
                                        confirmButtonText: "Ok",
                                        confirmButtonColor: "#152f5f",
                                    });
                                }
                            }
                        )
                    );
            } else {
                SalesServices.SendProformaInvoicemail(formData)
                    .then((response) =>
                        this.setState({ loader: false }, () =>
                            Swal.fire({
                                title: `Mail Sent Successfully`,
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            })
                        )
                    )
                    .catch((e) =>
                        this.setState(
                            { message: e.response.data.message, loader: false },
                            () => {
                                if (e.response.data.error === "Unauthorized") {
                                    Swal.fire({
                                        title: `Your Session is Lost: Please login Back to resume`,
                                        text: ".",
                                        icon: "error",
                                        confirmButtonText: "Ok",
                                        confirmButtonColor: "#152f5f",
                                    }).then(() => this.props.navigate("/"));
                                } else {
                                    Swal.fire({
                                        title: `Server Error, please try again later`,
                                        text: ".",
                                        icon: "error",
                                        confirmButtonText: "Ok",
                                        confirmButtonColor: "#152f5f",
                                    });
                                }
                            }
                        )
                    );
            }
        }
    };

    handleDownloadewaybill = (type) => {
        // ewaybillpdf(this.state.einvoicedata,this.state.ewaybilldata,type)
        let invoice = this.state.einvoicedata;
        let ewaybilldata = this.state.ewaybilldata;
        let Invoicedata = this.state.Invoicedata;

        let totalinvoice = (
            Invoicedata.totalinvoice +
            (Invoicedata.insuranceamount === null ||
                Invoicedata.insuranceamount === undefined ||
                Invoicedata.insuranceamount === ""
                ? 0
                : Invoicedata.insuranceamount)
        ).toFixed(2);
        let taxamount = (
            Invoicedata.taxamount +
            (Invoicedata.insuranceamount === null ||
                Invoicedata.insuranceamount === undefined ||
                Invoicedata.insuranceamount === ""
                ? 0
                : Invoicedata.totalinsurance - Invoicedata.insuranceamount)
        ).toFixed(2);
        let totalinvoicewtax = Invoicedata.totalinvoicewtax.toFixed(2);
        let advance =
            Invoicedata.advanceamountreq === null ||
                Invoicedata.advanceamountreq === undefined
                ? 0.0
                : Invoicedata.advanceamountreq.toFixed(2);
        let totaladditionalchares = 0;
        let insuranceamount = 0;
        let totaladdincinsu = 0;
        let tcsamount = 0;
        let totalexctcs = 0;

        totaladditionalchares =
            Invoicedata.totaladditionalchares !== undefined &&
                Invoicedata.totaladditionalchares !== null
                ? Invoicedata.totaladditionalchares.toFixed(2)
                : (0).toFixed(2);
        insuranceamount = Invoicedata.insurancereq
            ? Invoicedata.totalinsurance.toFixed(2)
            : 0;
        totaladdincinsu = (
            (Invoicedata.totaladditionalchares !== undefined &&
                Invoicedata.totaladditionalchares !== null
                ? Invoicedata.totaladditionalchares
                : 0) + (Invoicedata.insurancereq ? Invoicedata.totalinsurance : 0)
        ).toFixed(2);

        if (Invoicedata.tcsreq) {
            tcsamount = Invoicedata.tcsamount.toFixed(2);
            totalexctcs = parseFloat(totalinvoicewtax).toFixed(2);
            totalinvoicewtax = (
                parseFloat(totalinvoicewtax) + Invoicedata.tcsamount
            ).toFixed(2);
        }

        if (Invoicedata.currency !== currency) {
            totalinvoice = (totalinvoice * Invoicedata.curconversionrate).toFixed(2);
            taxamount = (taxamount * Invoicedata.curconversionrate).toFixed(2);
            totalinvoicewtax = (
                totalinvoicewtax * Invoicedata.curconversionrate
            ).toFixed(2);
            advance = (advance * Invoicedata.curconversionrate).toFixed(2);
            totaladditionalchares = (
                totaladditionalchares * Invoicedata.curconversionrate
            ).toFixed(2);
            insuranceamount = (
                insuranceamount * Invoicedata.curconversionrate
            ).toFixed(2);
            // totaladdincinsu = (
            //   totaladditionalchares * Invoicedata.curconversionrate +
            //   insuranceamount * Invoicedata.curconversionrate
            // ).toFixed(2);
            if (Invoicedata.tcsreq) {
                tcsamount = (
                    totaladditionalchares * Invoicedata.curconversionrate
                ).toFixed(2);
            }
        }

        let tabledata = [
            {
                mode: invoice.invoice.transportationmode,
                vehicle: `${invoice.invoice.vehiclenum} ${moment(
                    ewaybilldata.ewbdt
                ).format("DD-MM-yyyy")}`,
                from: invoice.invoice.discity,
                enterddate: moment(ewaybilldata.ewbdt).format("DD-MM-yyyy"),
                enterdby: gstin,
                cewb: "",
                multiveh: "",
            },
        ];
        if (invoice.invoice.updtvehiclenum !== null) {
            tabledata.push({
                mode: invoice.invoice.updttransportationmode,
                vehicle: `${invoice.invoice.updtvehiclenum} ${moment(
                    invoice.invoice.updtvehdt
                ).format("DD-MM-yyyy")}`,
                from: invoice.invoice.updtfrom,
                enterddate: moment(invoice.invoice.updtvehdt).format("DD-MM-yyyy"),
                enterdby: gstin,
                cewb: "",
                multiveh: "",
            });
        }

        let tablecol = [
            { header: "Mode", dataKey: "mode" },
            { header: "Vehicle / Trans DocNo & Dt", dataKey: "vehicle" },
            { header: "From", dataKey: "from" },
            { header: "Entered Date", dataKey: "enterddate" },
            { header: "Entered By", dataKey: "enterdby" },
            { header: "CEWB No.(If Any)", dataKey: "cewb" },
            { header: "Multi Veh.Info (If Any)", dataKey: "multiveh" },
        ];

        let supplytype = invoice.invoice.supplytype === "I" ? "Inward" : "Outward";
        let transactiontype = invoice.invoice.transactiontype === undefined || invoice.invoice.transactiontype === null ? "" : invoice.invoice.transactiontype;
        let transportername = invoice.invoice.transportername;
        let amount = this.state.Invoicedata.totalinvoicewtax.toFixed(2);

        let hsnlist = this.state.saleorderitems.map((e) => e.hsn);
        hsnlist = hsnlist.toString();

        const doc = new jsPDF("p", "pt", [842, 595], true);
        console.log("HSNLIST3400", hsnlist);
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.setLineWidth(0.1)
        doc.line(30, 40, 580, 40); // top line
        doc.line(30, pageHeight - 40, 580, pageHeight - 40); //bottom line
        doc.line(30, 40, 30, pageHeight - 40); // left
        doc.line(pageWidth - 15, 40, pageWidth - 15, pageHeight - 40);

        let y = 0;
        doc.setFontSize(12);
        doc.text("E-Way Bill", 280, 65);
        doc.line(30, 75, 580, 75);
        doc.addImage(this.state.ewaybillQRcode, "GIF", 480, 80, 90, 90);
        doc.line(475, 75, 475, 170);
        doc.setFontSize(8);
        doc.text("E-Way Bill No : " + ewaybilldata.ewbno, 40, 90);
        doc.text(
            "Generated Date : " +
            moment(ewaybilldata.ewbdt).format("DD-MM-yyyy HH:mm"),
            250,
            90
        );
        doc.text(`Generated By : ${gstin}`, 40, 105);
        doc.text(
            "Valid Until : " +
            moment(ewaybilldata.ewbvalidtill).format("DD-MM-yyyy HH:mm"),
            250,
            105
        );
        doc.line(30, 110, 475, 110);
        doc.text(`Type : ${supplytype} - Supply`, 40, 120);
        doc.text("Transaction Type : " + transactiontype, 250, 120);
        doc.line(30, 125, 475, 125);
        doc.text(
            `Document : ${invoice.invoice.einvid} ${moment(
                this.state.Invoicedata.createdAt
            ).format("DD-MM-yyyy")}`,
            40,
            135
        );
        doc.text(`Approx Distance :  ${invoice.invoice.distance} kms`, 250, 135);
        doc.line(30, 140, 475, 140);
        if (this.state.Invoicedata.einvoicestatus !== "NA") {
            doc.text("IRN Details", 40, 150);
            doc.text("IRN : " + invoice.irn, 40, 165);
        }
        doc.line(30, 170, 580, 170);
        y = y - 130;
        doc.text("Address Details", 40, 180);
        doc.line(30, 185, 580, 185);
        doc.text("From", 40, 195);
        doc.line(30, 200, 580, 200);
        doc.text("GSTIN : " + gstin, 40, 210);
        doc.text(`${clientname} `, 40, 220);
        doc.text(`${cstate}`, 40, 230);
        doc.text(":: Dispatch From :: ", 40, 250);
        doc.text(`${this.state.Invoicedata.dishouseno}, ${this.state.Invoicedata.disareaname}`, 40, 260);
        doc.text(`${this.state.Invoicedata.discity}, ${this.state.Invoicedata.disstate} -${this.state.Invoicedata.dispincode}`, 40, 270);
        doc.line(290, 185, 290, 280);
        doc.text("To", 300, 195);
        doc.text("GSTIN : " + this.state.Invoicedata.custgstin, 300, 210);
        doc.text(`${this.state.Invoicedata.customer}`, 300, 220);
        doc.text(`${this.state.Invoicedata.state}`, 300, 230);
        doc.text(":: Ship To :: ", 300, 250);
        doc.text(`${this.state.Invoicedata.dhouseno}, ${this.state.Invoicedata.dareaname}`, 300, 260);
        doc.text(`${this.state.Invoicedata.dcity}, ${this.state.Invoicedata.dstate} - ${this.state.Invoicedata.dpincode}`, 300, 270);
        doc.line(30, 280, 580, 280);

        doc.text("Goods Details", 40, 290);
        doc.text("Please Refer IRN Print to view Goods Details.", 40, 300);
        y = 310;
        doc.line(40, y, 555, y);

        // doc.text("Total", 220, y + 65);
        doc.line(40, y, 40, y + 50);
        doc.text("Taxable value", 45, y + 15);
        doc.text(`${totalinvoice}`, 45, y + 40);
        doc.line(115, y, 115, y + 50);
        doc.text("CGST", 120, y + 15);
        doc.text(
            `${Invoicedata.gsttype === "INTRASTATE" ? (taxamount / 2)?.toFixed(2) : 0.0
            }`,
            120,
            y + 40
        );
        doc.line(190, y, 190, y + 50);
        doc.text("SGST", 195, y + 15);
        doc.text(
            `${Invoicedata.gsttype === "INTRASTATE" ? (taxamount / 2)?.toFixed(2) : 0.0
            }`,
            195,
            y + 40
        );
        doc.line(265, y, 265, y + 50);
        doc.text("IGST", 270, y + 15);
        doc.text(
            `${Invoicedata.gsttype === "INTRASTATE" ? 0.0 : taxamount}`,
            270,
            y + 40
        );
        doc.line(340, y, 340, y + 50);
        doc.text(`Addnlcharges/Insur`, 342, y + 15);
        doc.text(`${totaladdincinsu}`, 345, y + 40);
        doc.line(415, y, 415, y + 50);
        doc.text(`TCS`, 420, y + 15);
        doc.text(`${tcsamount}`, 420, y + 40);
        doc.line(490, y, 490, y + 50);
        doc.text("Total", 495, y + 15);
        doc.text(`${NumericFormat(totalinvoicewtax)}`, 495, y + 40);
        doc.line(555, y, 555, y + 50);

        doc.line(40, y + 25, 555, y + 25);
        doc.line(40, y + 50, 555, y + 50);
        y = y + 50
        doc.line(30, y + 10, 580, y + 10);
        doc.text("Transportation Details", 40, y + 20);
        doc.text(
            `Transporter ID & Name : ${Invoicedata.transporterid === null ? "" : Invoicedata.transporterid
            } ${transportername === null ? "" : transportername}`,
            40,
            y + 35
        );
        doc.text(
            "Transporter Doc. No & Date : " +
            moment(ewaybilldata.ewbdt).format("DD-MM-yyyy"),
            300,
            y + 35
        );
        doc.line(30, y + 40, 580, y + 40);
        doc.text("Vehicle Details", 40, y + 50);

        autoTable(doc, {
            theme: "grid",
            startY: y + 65,
            margin: { top: 0, bottom: 0, right: 25, left: 40 },
            didDrawPage: (HookData) => {
                HookData.settings.margin.top = 180;
            },
            styles: { textColor: [0, 0, 0], fontSize: "8", cellPadding: 2 },
            headStyles: {
                fillColor: [256, 256, 256],
                textColor: [0, 0, 0],
                lineWidth: 0.1,
                lineColor: [211, 211, 211],
                fontStyle: "default",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
                lineColor: [211, 211, 211],
            },
            body: tabledata,
            columns: tablecol,
        });

        if (type === "pdf") {
            doc.autoPrint({ variant: "non-conform" });
            doc.save(`${ewaybilldata.ewbno}.pdf`);
        } else {
            const blob = doc.output("blob");
            const file = new File([blob], `${ewaybilldata.ewbno}.pdf`);

            // var fileURL = URL.createObjectURL(blob);
            // window.open(fileURL);
            let formData = new FormData();

            formData.append("file", file);
            formData.append("id", ewaybilldata.ewbno);

            SalesServices.SendEwaybillMail(formData)
                .then((response) =>
                    this.setState({ loader: false }, () =>
                        Swal.fire({
                            title: `Mail Sent Successfully`,
                            text: ".",
                            icon: "success",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        })
                    )
                )
                .catch((e) =>
                    this.setState(
                        { message: e.response.data.message, loader: false },
                        () => {
                            if (e.response.data.error === "Unauthorized") {
                                Swal.fire({
                                    title: `Your Session is Lost: Please login Back to resume`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                }).then(() => this.props.navigate("/"));
                            } else {
                                Swal.fire({
                                    title: `Server Error, please try again later`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                            }
                        }
                    )
                );
        }
    };

    // ==================== RECEIPT PDF GENERATION FUNCTIONS ====================
    handleDownloadReceipt = (receiptIndex = 0) => {
        const { Invoicedata, receiptData } = this.state;

        if (!receiptData || receiptData.length === 0) {
            Swal.fire({
                title: 'No Receipt Data',
                text: 'No payment receipts are available for this invoice.',
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#152f5f',
            });
            return;
        }

        // If there are multiple receipts, show options
        if (receiptData.length > 1) {
            Swal.fire({
                title: 'Multiple Receipts Found',
                html: `Select which receipt to download:<br><br>
                     ${receiptData.map((rec, idx) =>
                    `<div style="margin: 5px 0;">
                         <strong>Receipt ${idx + 1}:</strong> ${rec.transid} - ${moment(rec.createdAt).format('DD/MM/YYYY')} - ${rec.receiptamount} ${Invoicedata.currency || currency}
                         <br><small>Ref: ${rec.receiptref || 'N/A'}</small>
                       </div>`
                ).join('')}`,
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Download All',
                confirmButtonColor: '#152f5f',
                cancelButtonText: 'Cancel',
                showDenyButton: true,
                denyButtonText: 'Download Latest',
            }).then((result) => {
                if (result.isConfirmed) {
                    // Download all receipts as separate PDFs
                    receiptData.forEach((rec, idx) => {
                        setTimeout(() => {
                            this.generateReceiptPDF(rec, idx + 1);
                        }, idx * 500);
                    });
                } else if (result.isDenied) {
                    // Download the latest receipt
                    const latestReceipt = receiptData.reduce((latest, current) => {
                        const latestDate = new Date(latest.createdAt);
                        const currentDate = new Date(current.createdAt);
                        return currentDate > latestDate ? current : latest;
                    });
                    this.generateReceiptPDF(latestReceipt, receiptData.length);
                }
            });
            return;
        }

        // Single receipt
        this.generateReceiptPDF(receiptData[0], 1);
    };

    generateReceiptPDF = (receipt, receiptNumber, shouldPrint = false) => {
        const { Invoicedata, receiptData } = this.state;

        const receiptId = receipt.transid || `RECEIPT-${moment().format('YYYYMMDD')}-${String(receiptNumber).padStart(3, '0')}`;
        const paymentDate = moment(receipt.createdAt).format("DD/MM/YYYY");
        const paymentMode = receipt.mode || 'N/A';
        const bank = receipt.bank || '';
        const branch = receipt.branch || '';
        const accountNumber = receipt.accountnumber || '';
        const receiptRef = receipt.receiptref || '';

        const invoiceCurrency = Invoicedata.currency || currency;
        const amountReceived = parseFloat(receipt.receiptamount || 0);

        const toWords = new ToWords({
            localeCode: "en-IN",
            converterOptions: {
                currency: false,
                ignoreDecimal: false,
                ignoreZeroCurrency: false,
                doNotAddOnly: true
            }
        });

        let amountInWords = "";
        try {
            amountInWords = toWords.convert(Math.round(amountReceived));
        } catch (error) {
            console.error("error in converting amount to words", error);
        }

        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const leftBorder = 35;
        const rightBorder = pageWidth - 25;
        const contentWidth = rightBorder - leftBorder;
        let y = 40;

        const addFooter = (docInstance) => {
            const pageNum = docInstance.internal.getNumberOfPages();
            docInstance.setFontSize(7).setFont("helvetica", "normal").setTextColor(0, 0, 0);
            const footerY = pageHeight - 15;
            const creationDate = Invoicedata.createdAt ? moment(Invoicedata.createdAt).format("DD/MM/YYYY") : "N/A";
            const footerText = `Invoice: ${Invoicedata.custominvid || Invoicedata.invid} | Generated on: ${creationDate} | Page ${pageNum}`;
            docInstance.text(footerText, pageWidth / 2, footerY, { align: "center" });
        };

        doc.setFontSize(11).setFont("helvetica", "bold").setTextColor("#000000");
        doc.text("PAYMENT RECEIPT", pageWidth / 2, y, { align: "center" });
        y += 10;

        const infoBoxStartY = y;
        const logoWidth = logo ? 75 : 0;
        const logoPadding = 10;
        const textHorizontalPadding = 20;
        const textWidth = logo
            ? contentWidth - logoWidth - (logoPadding * 2) - textHorizontalPadding
            : contentWidth - (textHorizontalPadding * 2);

        const logoHeight = logo ? ((this.state.imgheight / this.state.imgwidth) * logoWidth || 35) : 0;

        if (logo) {
            try {
                doc.addImage(logo, 'PNG', rightBorder - logoWidth - 10, infoBoxStartY + 10, logoWidth, logoHeight);
            } catch (e) {
                console.error("Logo add error", e);
            }
        }

        doc.setFontSize(8).setFont("helvetica", "bold");
        const clientLines = doc.splitTextToSize((clientname || "").toUpperCase(), textWidth);
        let infoY = infoBoxStartY + 20;
        clientLines.forEach(line => {
            doc.text(line, leftBorder + textHorizontalPadding, infoY);
            infoY += 11;
        });

        infoY += 2;

        doc.setFontSize(7);

        const addressDetails = [
            { label: null, value: address },
            { label: null, value: address2 },
            { label: null, value: `${ccity}, ${cstate}, ${ccountry} - ${czip}` },
            { label: "Phone : ", value: contactnumber },
            { label: "Email : ", value: companyemail },
            gstin ? { label: "GSTIN / VAT : ", value: gstin } : null,
            pan ? { label: "PAN : ", value: pan } : null
        ].filter(Boolean);

        addressDetails.forEach(item => {
            if (!item.value || item.value === 'null' || item.value === 'undefined') return;

            if (!item.label) {
                doc.setFont("helvetica", "normal");
                const lines = doc.splitTextToSize(item.value, textWidth);
                lines.forEach(l => {
                    doc.text(l, leftBorder + textHorizontalPadding, infoY);
                    infoY += 9;
                });
            } else {
                doc.setFont("helvetica", "bold");
                doc.text(item.label, leftBorder + textHorizontalPadding, infoY + 2);

                const labelWidth = doc.getTextWidth(item.label + " ");
                doc.setFont("helvetica", "normal");

                const valueLines = doc.splitTextToSize(
                    item.value,
                    textWidth - labelWidth
                );

                valueLines.forEach((l, i) => {
                    doc.text(
                        l,
                        leftBorder + textHorizontalPadding + (i === 0 ? labelWidth : 0),
                        infoY + 2
                    );
                    infoY += 11;
                });
            }
        });


        const infoBoxHeight = Math.max(infoY - infoBoxStartY + 5, logoHeight + 20);
        doc.setDrawColor(0);
        doc.setLineWidth(0.1);
        doc.rect(leftBorder, infoBoxStartY, contentWidth, infoBoxHeight);
        y = infoBoxStartY + infoBoxHeight;

        y += 20;
        doc.setFontSize(9).setFont("helvetica", "bold");
        doc.text(`RECEIPT NUMBER: ${receiptId}`, leftBorder + 5, y);
        y += 10;

        const detailsData = [
            ["Payment Received from the Customer", (Invoicedata.customer || "N/A").toUpperCase()],
            ["Payment Date", paymentDate],
            ["Reference Number", receiptRef || "N/A"],
            ["Payment Mode", paymentMode],
            ["Amount Received", `${invoiceCurrency} ${amountReceived.toFixed(2)}`],
            ["Amount In Words", `${invoiceCurrency} ${amountInWords} Only /-`]
        ];

        autoTable(doc, {
            startY: y,
            margin: { left: leftBorder, right: leftBorder },
            head: [[{ content: 'Receipt Summary', colSpan: 2 }]],
            body: detailsData,
            theme: 'grid',
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                halign: 'left',
                lineWidth: 0.1,
                fontSize: 8
            },
            styles: {
                fontSize: 7.5,
                cellPadding: 5,
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                textColor: [0, 0, 0],
                overflow: 'linebreak'
            },
            columnStyles: {
                0: { fontStyle: 'normal', cellWidth: 200 },
                1: { cellWidth: contentWidth - 200 }
            },
            didParseCell: function (data) {
                if (data.column.index === 1 && data.row.index === 4) {
                    data.cell.styles.fontStyle = 'bold';
                }
            }
        });

        y = doc.lastAutoTable.finalY;

        y += 20;
        const sigBlockWidth = 220;
        const sigBlockX = rightBorder - sigBlockWidth;
        const sigCenterX = sigBlockX + (sigBlockWidth / 2);

        doc.setFontSize(8).setFont("helvetica", "bold");
        doc.text("Authorized Signature", rightBorder - 10, y, { align: "right" });

        y += 30;
        doc.setDrawColor(0);
        doc.setLineWidth(0.1);
        doc.line(sigBlockX + 30, y, rightBorder - 10, y);
        y += 15;
        doc.setFontSize(8).setFont("helvetica", "bold");
        const sigNameLines = doc.splitTextToSize((clientname || ""), sigBlockWidth);
        sigNameLines.forEach(line => {
            doc.text(line, rightBorder - 10, y, { align: "right" });
            y += 10;
        });

        doc.setFontSize(6).setFont("helvetica", "normal").setTextColor(0, 0, 0);
        const disclaimer = "( Machine Generated Payment Receipt Signature Not Required )";
        doc.text(disclaimer, rightBorder - 10, y - 2, { align: "right" });

        doc.setTextColor(0, 0, 0);

        y += 10;
        doc.setFontSize(9).setFont("helvetica", "bold");
        doc.text("Payment Summary", leftBorder + 5, y);
        y += 8;

        const invoiceTotal = parseFloat(Invoicedata.totalinvoicewtax || 0);

        const currentReceiptDate = new Date(receipt.createdAt);
        const previousReceipts = (receiptData || [])
            .filter(r => new Date(r.createdAt) < currentReceiptDate)
            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        const previousPaymentsSum = previousReceipts.reduce((sum, r) => sum + parseFloat(r.receiptamount || 0), 0);
        const totalPaidIncludingThis = previousPaymentsSum + amountReceived;
        const balanceRemaining = invoiceTotal - totalPaidIncludingThis;

        const summaryRows = [
            ["Total Invoice Amount", `${invoiceCurrency} ${invoiceTotal.toFixed(2)}`]
        ];

        previousReceipts.forEach((r) => {
            const rDate = moment(r.createdAt).format("DD/MM/YYYY");
            const rMode = r.mode || "N/A";
            summaryRows.push([`Previous Payment (${rDate} - ${rMode})`, `${invoiceCurrency} ${parseFloat(r.receiptamount).toFixed(2)}`]);
        });

        summaryRows.push(["Current Receipt Payment", `${invoiceCurrency} ${amountReceived.toFixed(2)}`]);
        summaryRows.push(["Balance Due", `${invoiceCurrency} ${Math.max(0, balanceRemaining).toFixed(2)}`]);

        autoTable(doc, {
            startY: y,
            margin: { left: leftBorder + 5, right: leftBorder + 5, bottom: 35 },
            body: summaryRows,
            theme: 'plain',
            styles: {
                fontSize: 7,
                cellPadding: 4,
                textColor: [0, 0, 0]
            },
            columnStyles: {
                0: { halign: 'left', cellWidth: 150 },
                1: { halign: 'right' }
            },
            didParseCell: function (data) {
                const rowLabel = data.row.raw[0];
                if (rowLabel === "Total Invoice Amount" || rowLabel === "Current Receipt Payment" || rowLabel === "Balance Due") {
                    data.cell.styles.fontStyle = 'bold';
                }
            },
            didDrawPage: (data) => {
                addFooter(doc);
            },
            didDrawCell: (data) => {
                doc.setDrawColor(0);
                doc.setLineWidth(0.1);
                doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);

                if (data.row.index === summaryRows.length - 2) {
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.5);
                    doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + data.cell.width, data.cell.y + data.cell.height);
                }
            }
        });

        y = doc.lastAutoTable.finalY + 20;

        if (doc.internal.getNumberOfPages() === 1) {
            addFooter(doc);
        }
        if (shouldPrint) {
            doc.autoPrint();
            window.open(doc.output('bloburl'), '_blank');
        } else {
            const fileName = `${receiptId}.pdf`;
            doc.save(fileName);

            Swal.fire({
                title: 'Receipt Downloaded',
                text: `Receipt ${receiptId} has been downloaded successfully.`,
                icon: 'success',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#152f5f',
            });
        }
    };

    selectFile = (event) => {
        this.setState({
            selectedFiles: event.target.files,
        });
    };

    upload() {
        let currentFile = this.state.selectedFiles[0];

        this.setState({ progress: 100, currentFile: currentFile });

        UploadFilesService.upload(
            currentFile,
            year,
            curmonth,
            doctype,
            this.state.partyid,
            day
        )
            .then((response) => {
                this.setState({
                    message: response.data.message,
                    isError: false,
                });
                return FileServices.getFiles1(currentFile.name);
            })
            .then((files) => {
                this.setState({ fileInfos: files.data });
            })

            .catch(() => {
                this.setState({
                    progress: 0,
                    message: "Could not upload the file!",
                    currentFile: undefined,
                    isError: true,
                });
            });

        this.setState({ selectedFiles: undefined });
    }

    handleSendMail = () => {
        if (this.state.fileInfos.length === 0) {
            alert("Please Upload File");
        } else {
            let filedata = this.state.fileInfos.map((e) => e.name);
            path =
                prefix1 +
                "/" +
                doctype +
                "/" +
                this.state.partyid +
                "/" +
                year +
                "/" +
                curmonth +
                "/" +
                day;
            let data = {
                file: filedata.toLocaleString(),
                path: path,
                invid: this.state.id,
                amount: this.state.Invoicedata.totalinvoicewtax,
            };
            SalesServices.SendInvoicemail(data).then(() =>
                this.setState({
                    show: false,
                    selectedFiles: undefined,
                    currentFile: undefined,
                    progress: 0,
                    message: "",
                    isError: false,
                    fileInfos: [],
                    fileInfo: "",
                    partyid: "",
                    error: false,
                })
            );
        }
    };

    handleTransporterChange = (value, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
            this.setState({
                transportername: "",
                transporterid: "",
                validtrnsid: false,
            });
        } else {
            this.setState({
                transportername: newValue.transname,
                transporterid: newValue.transid,
                validtrnsid: true,
            });
        }
    };

    handleDeleteInvoice = () => {
        let data = {
            id: this.state.id,
            updatedby: userid,
        };
        Swal.fire({
            title: "Delete Invoice?",
            text: "Are you sure?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                if (this.state.pagename === "Tax Invoice Details") {
                    SalesServices.TerminateTempInvoice(data)
                        .then((response) => {
                            this.setState({ loader: false });
                            Swal.fire({
                                title: "Invoice Deleted Successfully!",
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            }).then(() => this.props.navigate(-1));
                        })
                        .catch((e) => {
                            this.setState({ loader: false });
                            if (e.response.data.error === "Unauthorized") {
                                alert("Your Session is Lost: Please login Back to resume");
                                this.props.navigate(`/`);
                            }
                        });
                } else {
                    SalesServices.DeleteProformaInvoice(data)
                        .then((response) => {
                            this.setState({ loader: false });
                            Swal.fire({
                                title: "Invoice Deleted Successfully!",
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            }).then(() => this.props.navigate(-1));
                        })
                        .catch((e) => {
                            this.setState({ loader: false });
                            if (e.response.data.error === "Unauthorized") {
                                alert("Your Session is Lost: Please login Back to resume");
                                this.props.navigate(`/`);
                            }
                        });
                }
            }
        });
    };

    handleTerminateInvoice = () => {
        if (this.state.remarks === "") {
            this.setState({ showCancelModal: true });
        } else {
            this.setState({ showCancelModal: false });
            let data = {
                id: this.state.id,
                updatedby: userid,
                remarks: this.state.remarks,
            };
            Swal.fire({
                title: "Terminate/Cancel Invoice?",
                text: "Are you sure?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: "#152f5f",
                cancelButtonText: "No",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.setState({ loader: true });
                    SalesServices.TerminateInvoice(data)
                        .then((response) => {
                            this.setState({ loader: false });
                            Swal.fire({
                                title: "Invoice Terminated Successfully!",
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            }).then(() => this.props.navigate(-1));
                        })
                        .catch((e) => {
                            this.setState({ loader: false });
                            if (e.response.data.error === "Unauthorized") {
                                alert("Your Session is Lost: Please login Back to resume");
                                this.props.navigate(`/`);
                            }
                        });
                }
            });
        }
    };

    handleTerminateEInvoice = () => {
        if (this.state.remarks === "") {
            this.setState({ showrem: true });
        } else {
            let data = {
                tenantId: currentTenant,
                Irn: this.state.einvoicedata.irn,
                CnlRsn: parseInt(this.state.reasonCodeforcnl),
                CnlRem: this.state.remarks,
            };

            Swal.fire({
                title: "Terminate/Cancel E-Invoice?",
                text: "Are you sure?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: "#152f5f",
                cancelButtonText: "No",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.setState({ loader: true });
                    SalesServices.CancelEinvoice(data)
                        .then((res) => {
                            this.setState({ showrem: false, msg: res.data, loader: false });
                            Swal.fire({
                                title: `${res.data}`,
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                        })
                        .catch((e) => {
                            this.setState({
                                loader: false,
                                errormsg:
                                    e.response.data.body === undefined
                                        ? e.response.data
                                        : JSON.parse(e.response.data.body),
                            });
                            if (
                                e.response === undefined ||
                                e.response.data.error === "Unauthorized"
                            ) {
                                alert("Your Session is Lost: Please login Back to resume");
                                this.props.navigate(`/`);
                            }
                        });
                }
            });
        }
    };

    handleTerminateEwaybill = () => {
        if (this.state.remarks === "") {
            this.setState({ showrem: true });
        } else {
            let data = {
                tenantId: currentTenant,
                ewbNo: this.state.ewaybilldata.ewbno,
                cancelRsnCode: this.state.reasonCodeforcnl,
                cancelRmrk: this.state.remarks,
            };

            Swal.fire({
                title: "Terminate/Cancel E-Way bill?",
                text: "Are you sure?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: "#152f5f",
                cancelButtonText: "No",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.setState({ loader: true });
                    SalesServices.CancelEwaybill(data)
                        .then((response) => {
                            this.setState({ loader: false });
                            Swal.fire({
                                title: "EWay-bill Terminated Successfully!",
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                        })
                        .catch((e) => {
                            this.setState({ loader: false });
                            if (e.response.data.error === "Unauthorized") {
                                alert("Your Session is Lost: Please login Back to resume");
                                this.props.navigate(`/`);
                            }
                            Swal.fire({
                                title: `${e.response.data.body === undefined
                                    ? e.response.data
                                    : e.response.data.body?.map((e, i) => e.ErrorMessage)
                                    }`,
                                text: ".",
                                icon: "error",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            });
                        });
                }
            });
        }
    };

    handleEWaybillGenration = () => {
        if (
            this.state.vehiclenum === "" ||
            this.state.distance === "" ||
            this.state.distance === null ||
            this.state.distance === 0 ||
            this.state.distance === undefined ||
            this.state.transporterid === ""
        ) {
            this.setState({ err: true });
        } else {
            if (this.state.Invoicedata.einvoicestatus === "NA") {
                let data = {
                    tenantId: currentTenant,
                    TransId: this.state.transporterid,
                    TransName: this.state.transportername,
                    Distance: this.state.distance,
                    TransDocNo: this.state.Invoicedata.invid,
                    TransDocDt: this.state.Invoicedata.createdAt,
                    VehNo: this.state.vehiclenum,
                    VehType: this.state.vehicletype,
                    TransMode: this.state.transportationmode,
                    supplytype: this.state.supplytype,
                    transactiontype: this.state.transactiontype,
                };

                Swal.fire({
                    title: "Generate E-Way bill?",
                    text: "Are you sure?",
                    icon: "question",
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#152f5f",
                    cancelButtonText: "No",
                    reverseButtons: true,
                }).then((result) => {
                    if (result.value) {
                        this.setState({ loader: true });
                        SalesServices.GenerateEwaybillAPI(data)
                            .then((response) => {
                                this.setState({ loader: false });
                                Swal.fire({
                                    title: "Eway bill generated successfully!",
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                            })
                            .catch((e) => {
                                this.setState({ loader: false });
                                this.setState({ errormsg: e.response.data.body.errormessage });
                                if (e.response.data.error === "Unauthorized") {
                                    alert("Your Session is Lost: Please login Back to resume");
                                    this.props.navigate(`/`);
                                }
                                Swal.fire({
                                    title: `${e.response.data.body.errormessage}`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                            });
                    }
                });
            } else if (this.state.Invoicedata.einvoicestatus === "Pending") {
                let data = {
                    tenantId: currentTenant,
                    Irn: this.state.Invoicedata.invid,
                    TransId: this.state.transporterid,
                    TransName: this.state.transportername,
                    Distance: this.state.distance,
                    VehNo: this.state.vehiclenum,
                    VehType: this.state.vehicletype,
                    TransMode: this.state.transportationmode,
                    supplytype: this.state.supplytype,
                    transactiontype: this.state.transactiontype,
                };
                Swal.fire({
                    title: "Update Transportation Details?",
                    text: "Are you sure?",
                    icon: "question",
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#152f5f",
                    cancelButtonText: "No",
                    reverseButtons: true,
                }).then((result) => {
                    if (result.value) {
                        this.setState({ loader: true });
                        SalesServices.UpdateTransportation(data)
                            .then((response) => {
                                this.setState({ loader: false });
                                Swal.fire({
                                    title: "Transportation details updated successfully",
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                            })
                            .catch((e) => {
                                this.setState({ loader: false });
                                this.setState({ errormsg: e.response.data.body.errormessage });
                                if (e.response.data.error === "Unauthorized") {
                                    alert("Your Session is Lost: Please login Back to resume");
                                    this.props.navigate(`/`);
                                }
                                Swal.fire({
                                    title: `${e.response.data.body.errormessage}`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                            });
                    }
                });
            } else {
                let data = {
                    tenantId: currentTenant,
                    Irn: this.state.einvoicedata.irn,
                    TransId: this.state.transporterid,
                    TransName: this.state.transportername,
                    Distance: this.state.distance,
                    TransDocNo: this.state.TransDocNo,
                    TransDocDt: this.state.TransDocDt,
                    VehNo: this.state.vehiclenum,
                    VehType: this.state.vehicletype,
                    TransMode: this.state.transportationmode,
                    supplytype: this.state.supplytype,
                    transactiontype: this.state.transactiontype,
                };

                Swal.fire({
                    title: "Generate E-Way bill?",
                    text: "Are you sure?",
                    icon: "question",
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#152f5f",
                    cancelButtonText: "No",
                    reverseButtons: true,
                }).then((result) => {
                    if (result.value) {
                        this.setState({ loader: true });
                        SalesServices.GenerateEwaybill(data)
                            .then((response) => {
                                this.setState({ loader: false });
                                Swal.fire({
                                    title: "Eway bill generated successfully!",
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                            })
                            .catch((e) => {
                                this.setState({ loader: false });
                                this.setState({ errormsg: e.response.data.body.errormessage });
                                if (e.response.data.error === "Unauthorized") {
                                    alert("Your Session is Lost: Please login Back to resume");
                                    this.props.navigate(`/`);
                                }
                                Swal.fire({
                                    title: `${e.response.data.body.errormessage}`,
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                            });
                    }
                });
            }
        }
    };

    ExtendEwaybill = () => {
        let data = {
            tenantId: currentTenant,
            ewbNo: this.state.ewaybilldata.ewbno,
            vehicleNo: this.state.vehiclenum,
            fromPlace: this.state.fromPlace,
            fromState: parseInt(this.state.fromStatecode),
            remainingDistance: this.state.remainingDistance,
            transDocNo: this.state.ewaybilldata.ewbno,
            transDocDate: moment(this.state.ewaybilldata.ewbdt).format("DD/MM/yyyy"),
            transMode: this.state.transportationmode,
            extnRsnCode: this.state.reasonCodeforewbext,
            extnRemarks: this.state.extnRemarks,
            fromPincode: parseInt(this.state.fromPincode),
            consignmentStatus: this.state.transportationmode === "5" ? "T" : "M",
            transitType:
                this.state.transportationmode === "5" ? this.state.transitType : "",
            addressLine1: this.state.addressLine1,
            addressLine2: this.state.addressLine2,
            addressLine3: this.state.addressLine3,
        };

        Swal.fire({
            title: "Extend E-Way bill?",
            text: "Are you sure you want to ?",
            icon: "question",
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                SalesServices.ExtendEwaybill(data).then((res) => {
                    this.setState({ loader: false });
                    if (res.statusCodeValue === 200) {
                        Swal.fire({
                            title: "Eway bill Date extended successfully!",
                            text: ".",
                            icon: "success",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                    } else {
                        this.setState({ loader: false });
                        Swal.fire({
                            title: res.data.body,
                            text: ".",
                            icon: "error",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        });
                    }
                });
            }
        });
    };

    handlesChangeTRNS = () => {
        let data = {
            tenantId: currentTenant,
            ewbNo: this.state.ewaybilldata.ewbno,
            transporterId: this.state.transporterid,
        };

        Swal.fire({
            title: "Change Transporter?",
            text: "Are you sure you want to change?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                SalesServices.UpdateTransporter(data).then((res) => {
                    this.setState({ loader: false });
                    if (res.data.statusCodeValue === 400) {
                        Swal.fire({
                            title: res.data.body,
                            text: ".",
                            icon: "error",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        });
                    } else {
                        this.setState({ showtrans: false, loader: false });
                        Swal.fire({
                            title: "Transporter Updated successfully!",
                            text: ".",
                            icon: "success",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                    }
                });
            }
        });
    };

    UpdateVehicel = () => {
        let data = {
            tenantId: currentTenant,
            ewbNo: this.state.ewaybilldata.ewbno,
            vehicleNo: this.state.vehiclenum,
            fromPlace: this.state.fromPlace,
            fromState: parseInt(this.state.fromStatecode),
            transDocNo: this.state.ewaybilldata.ewbno,
            transDocDate: moment(this.state.ewaybilldata.ewbdt).format("DD/MM/yyyy"),
            transMode: this.state.transportationmode,
            reasonCode: this.state.reasonCodeforvehchg,
            reasonRem: this.state.extnRemarks,
            vehicleType: this.state.vehicletype,
        };

        Swal.fire({
            title: "Update vehicle?",
            text: "Are you sure you want to update vehicle ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                SalesServices.ChangeVehBefDept(data)
                    .then((res) => {
                        this.setState({ loader: false });
                        if (res.data.statusCodeValue === 400) {
                            Swal.fire({
                                title: res.data.body,
                                text: ".",
                                icon: "error",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            });
                        } else {
                            Swal.fire({
                                title: "Vehicle Details Updated successfully!",
                                text: ".",
                                icon: "success",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                        }
                    })
                    .catch(() => {
                        this.setState({ loader: false });
                        Swal.fire({
                            title: "Error occured while updating vehicle",
                            text: ".",
                            icon: "error",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        });
                    });
            }
        });
    };

    handleCountryChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({
                fromCountry: newValue.name,
                StatesData: newValue.states,
                err: false,
            });
        }
    };

    handleStateChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({
                fromState: newValue.name,
                fromStatecode: newValue.code,
                CitiesData: newValue.cities,
                err: false,
            });
        }
    };

    handleCityChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({ fromPlace: newValue.name, err: false });
        }
    };

    handleEwaybillClose = () => {
        this.setState({ showfields: false });
    };

    handleEwaybillOpen = () => {
        this.setState({ showfields: true });
    };

    handleshowEWBExtnClose = () => {
        this.setState({ showEWBExtn: false });
    };

    handleshowEWBExtnOpen = () => {
        this.setState({ showEWBExtn: true });
    };

    handleshowchangeTRNS = () => {
        this.setState({ showtrans: true });
    };

    handleclosechangeTRNS = () => {
        this.setState({ showtrans: false });
    };

    handleshowChgVel = () => {
        this.setState({ showupdtveh: true });
    };

    handlecloseChgVel = () => {
        this.setState({ showupdtveh: false });
    };

    GenerateCreditNote = (e) => {
        let data = {
            id: e.id,
            updatedby: userid,
            status: 0,
        };
        Swal.fire({
            title: `Generate Credit Note?`,
            text: "Are you sure?",
            icon: "question",
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                // this.setState({loading:true})
                SalesServices.GenerateCreditNote(data)
                    .then(() => {
                        this.setState({ loader: false });
                        if (status === 0 && this.state.mailbehavior === "YES") {
                            this.handleDownload(this.state.Invoicedata, "mail");
                        }
                        Swal.fire({
                            title:
                                status === 0
                                    ? "Invoice Approved successfully"
                                    : "Invoice sent to Revise successfully",
                            text: ".",
                            icon: "success",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        }).then(() => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp));
                    })
                    .catch((e) => {
                        this.setState({ loader: false });
                        Swal.fire({
                            title: "Error occurred, please try again",
                            text: ".",
                            icon: "error",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        });
                        if (e.response.data.error === "Unauthorized") {
                            alert("Your Session is Lost: Please login Back to resume");
                            this.props.navigate(`/`);
                        }
                    });
            }
        });
    };

    handleApprove = (status) => {
        let data = {
            id: this.state.Invoicedata.invid,
            updatedby: userid,
            status: status,
        };
        if (this.state.ispaymentpending && status === 0) {
            Swal.fire({
                title: 'Pending payment from customer!',
                text: "Payment is due from the customer, please settle it before continuing",
                icon: "warning",
                confirmButtonColor: "#152f5f",
            });
        } else {
            Swal.fire({
                title: `${status === 0 ? "Approve Invoice" : "Send to revise"}?`,
                text: "Are you sure?",
                icon: "question",
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: "#152f5f",
                cancelButtonText: "No",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.setState({ loader: true });

                    if (this.state.pagename === "Tax Invoice Details") {
                        SalesServices.ApproveInvoice(data)
                            .then((res) => {
                                this.setState({ loader: false });
                                Swal.fire({
                                    title: status === 0
                                        ? "Invoice Approved successfully"
                                        : "Invoice sent to Revise successfully",
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                }).then(() => {
                                    if (status === 1) {
                                        // STAY on ViewInvoice and refresh with the current temp flag
                                        this.Refresh(this.state.Invoicedata.invid, "Tax Invoice Details", this.state.temp);
                                    } else {
                                        // For approval, go back to the invoice list
                                        this.props.navigate("/salesinvoice", { state: { message: "", type: "Tax Invoice" } });
                                    }
                                });
                            })
                            .catch((e) => {
                                this.setState({ loader: false });
                                Swal.fire({
                                    title: e?.response?.data?.body?.errormessage || "Error occurred, please try again",
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                                if (e?.response?.data?.error === "Unauthorized") {
                                    alert("Your Session is Lost: Please login Back to resume");
                                    this.props.navigate(`/`);
                                }
                            });
                    } else {
                        // Proforma invoice branch (unchanged)
                        SalesServices.ApproveProformainvoice(data)
                            .then(() => {
                                this.setState({ loader: false });
                                if (status === 0 && this.state.mailbehavior === "YES") {
                                    this.handleDownload(this.state.Invoicedata, "mail");
                                }
                                Swal.fire({
                                    title: "Proforma Invoice Approved successfully",
                                    text: ".",
                                    icon: "success",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                                this.Refresh(this.state.Invoicedata.invid, "Proforma Invoice Details", true);
                            })
                            .catch((e) => {
                                this.setState({ loader: false });
                                Swal.fire({
                                    title: "Error occurred, please try again",
                                    text: ".",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                                if (e?.response?.data?.error === "Unauthorized") {
                                    alert("Your Session is Lost: Please login Back to resume");
                                    this.props.navigate(`/`);
                                }
                            });
                    }
                }
            });
        }
    };

    Featcheinvoice = () => {
        this.setState({ loader: true });
        SalesServices.Featcheinvoice(this.state.Invoicedata.invid)
            .then((res) => this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp))
            .catch((err) => {
                this.setState({ loader: false });
                Swal.fire({
                    title: ``,
                    text: `${err.response.data?.errormessage}`,
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#152f5f",
                }).then(() => console.log(err, err.response, err.response.data));
            });
    };

    handleJournalEntry = () => {
        Swal.fire({
            title: `Make Journal Entry?`,
            text: "Are you sure?",
            icon: "question",
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                SalesServices.AutoJre(this.state.Invoicedata.invid).then((res) => {
                    Swal.fire('', "Journal Entry completed", 'success')
                    this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp)
                }
                ).catch(() => this.setState({ loader: false }))
            }
        })
    }

    handleCloseInvoice = () => {
        let data = {
            id: this.state.Invoicedata.invid,
            updatedby: userid,
        };

        Swal.fire({
            title: "Close Invoice",
            text: "Are you sure?",
            icon: "question",
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            confirmButtonColor: "#152f5f",
            cancelButtonText: "No",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.setState({ loader: true });
                SalesServices.CloseInvoice(data)
                    .then((res) => {
                        this.setState({ loader: false });

                        Swal.fire({
                            title: "Invoice Closed successfully",
                            text: ".",
                            icon: "success",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        }).then((res) => this.Refresh(this.state.Invoicedata.invid, "Tax Invoice Details", false))

                    })
                    .catch((e) => {
                        this.setState({ loader: false });
                        Swal.fire({
                            title: e?.response?.data?.body?.errormessage,
                            text: ".",
                            icon: "error",
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#152f5f",
                        });
                        if (e?.response?.data?.error === "Unauthorized") {
                            alert("Your Session is Lost: Please login Back to resume");
                            this.props.navigate(`/`);
                        }
                    });
            }
        })
    }

    Refresh = (invid, pn, tem) => {
        let id = invid === undefined || invid === null ? this.state.id : invid;
        let pagename = pn === undefined || pn === null ? this.state.pagename : pn;
        let temp = tem === undefined || tem === null ? this.state.temp : tem;
        this.setState({ pagename: pagename, id: invid, temp: temp });

        if (pagename === "Tax Invoice Details") {
            if (temp === true) {
                // Fetch temp invoice (used for drafts, revised invoices, etc.)
                SalesServices.GetTempInvoice(id)
                    .then((response) => {
                        this.setState({
                            Invoicedata: response.data,
                            currency: response.data.currency,
                            saleorderitems: response.data.invoiceitemlist,
                            invoiceservicelist: response.data.invoiceservicelist,
                            additionalchareslist: response.data.additionalchares,
                            vehicletype: response.data.vehicletype,
                            vehiclenum: response.data.vehiclenum,
                            distance: response.data.distance,
                            transporterid: response.data.transporterid,
                            transportername: response.data.transportername,
                            transmode: response.data.transmode,
                            showfields: false,
                            showrem: false,
                            showEWBExtn: false,
                            showtrans: false,
                            showupdtveh: false,
                            loading: false,
                            loader: false,
                        });
                    })
                    .catch(() => this.props.navigate("/salesinvoice", { state: { type: this.state.type, temp: false } }));
            } else {
                // Fetch regular approved invoice
                SalesServices.GetInvoice(id)
                    .then((response) => {
                        this.setState({
                            Invoicedata: response.data,
                            currency: response.data.currency,
                            saleorderitems: response.data.invoiceitemlist,
                            invoiceservicelist: response.data.invoiceservicelist,
                            additionalchareslist: response.data.additionalchares,
                            loading: false,
                            loader: false,
                            vehicletype: response.data.vehicletype,
                            vehiclenum: response.data.vehiclenum,
                            distance: response.data.distance,
                            transporterid: response.data.transporterid,
                            transportername: response.data.transportername,
                            transmode: response.data.transmode,
                            showfields: false,
                            showrem: false,
                            showEWBExtn: false,
                            showtrans: false,
                            showupdtveh: false,
                        });

                        // Fetch receipt data, credit notes, e‑invoice, etc.
                        SalesServices.getInvoiceReceiptData({ id: response.data.custominvid, tenantId: currentTenant })
                            .then((receiptRes) => this.setState({ receiptData: receiptRes.data || [] }))
                            .catch(() => this.setState({ receiptData: [] }));

                        SalesServices.getAllCreditnotesbyINV(id).then((res) =>
                            this.setState({ creditnoteslist: res.data })
                        );
                        SalesServices.geteDebitNotesofinvoice(id).then((res) =>
                            this.setState({ edebitnoteslist: res.data })
                        );

                        if (response.data.einvoicestatus === "Generated" || response.data.ewaybillstatus === "Generated") {
                            SalesServices.GetEinvoice(id).then((einvoiceRes) => {
                                this.setState({
                                    einvoicedata: einvoiceRes.data,
                                    showrem: false,
                                    remarks: "",
                                });
                                if (einvoiceRes.data.signedQRcode !== undefined) {
                                    QRCode.toDataURL(einvoiceRes.data.signedQRcode).then((url) => {
                                        this.setState({ QRcode: url });
                                    });
                                    SalesServices.GetEwayBill(einvoiceRes.data.id).then((ewayRes) => {
                                        this.setState({
                                            ewaybilldata: ewayRes.data,
                                            showrem: false,
                                        });
                                        QRCode.toDataURL(
                                            `${ewayRes.data.ewbno}/${gstin}/${moment(ewayRes.data.ewbdt).format("DD-MM-yyyy HH:mm")}`
                                        ).then((url) => {
                                            this.setState({ ewaybillQRcode: url });
                                        });
                                    });
                                }
                            });
                        }
                    })
                    .catch((e) => {
                        this.setState({ loading: false, loader: false });
                        if (e.response?.data?.error === "Unauthorized") {
                            alert("Your Session is Lost: Please login Back to resume");
                            this.props.navigate(`/`);
                        }
                    });
            }

            // Always fetch transporters, countries, template, settings, bank details
            TransporterServices.getTransporters(currentTenant).then((response) =>
                this.setState({ transporterslist: response.data })
            );
            MasterService.getCountries()
                .then((response) => this.setState({ CountryData: response.data }))
                .catch((e) => {
                    if (e.response?.data?.error === "Unauthorized") {
                        alert("Your Session is Lost: Please login Back to resume");
                        this.props.navigate(`/`);
                    }
                });

            let data = "Invoice";
            SettingsServices.GetActivePdfTemplate(data, currentTenant).then((response) =>
                this.setState({ templete: response.data })
            );
            SettingsServices.GetSettings(currentTenant).then((response) =>
                this.setState({ mailbehavior: response.data.mailbehavior })
            );
            SettingsServices.Getlicencesoftenant(currentTenant).then((res) =>
                this.setState({ licenses: res.data })
            );
            BankServices.getActivebank(currentTenant).then((res) =>
                this.setState({ bankdetails: res.data })
            );
        } else {
            // Proforma invoice branch (unchanged)
            SalesServices.GetProformaInvoice(id)
                .then((response) => {
                    this.setState({
                        Invoicedata: response.data,
                        saleorderitems: response.data.invoiceitemlist,
                        invoiceservicelist: response.data.invoiceservicelist,
                        loading: false,
                    });
                })
                .catch((e) => {
                    this.setState({ loading: false });
                    if (e.response?.data?.error === "Unauthorized") {
                        alert("Your Session is Lost: Please login Back to resume");
                        this.props.navigate(`/`);
                    }
                });
        }
    };

    dataURLtoFile = (dataurl, filename) => {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);

        if (userid === undefined) {
            window.confirm("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
        }

        this.setState({ loading: true });

        let i = new Image();
        i.src = logo;

        setTimeout(() => {
            this.setState({ imgwidth: i.naturalWidth, imgheight: i.naturalHeight });
        }, 100);

        year = new Date().getFullYear();
        day = new Date().getDate();
        let mn = new Date().getMonth() + 1;
        curmonth = moment(mn, "M").format("MMMM");
        this.Refresh(this.props.location.state.id, this.props.location.state.pagename, this.props.location.state.temp);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        const isTooltipDropdown = event.target.closest('[data-tooltip-dropdown]');
        const isDropdownContainer = event.target.closest('[data-dropdown-container]');

        if (isTooltipDropdown || isDropdownContainer) {
            return;
        }

        if (this.state.opendropdown !== "") {
            this.setState({ opendropdown: "" });
        }
    };

    handleOpendropdown = (val) => {
        if (this.state.opendropdown === val) {
            this.setState({ opendropdown: "" });
        } else {
            this.setState({ opendropdown: val });
        }
    };

    handleDropdownAction = (action, type, data) => {
        if (action === "download") {
            if (type === "pdf") {
                this.handleDownload(data, "pdf");
            } else if (type === "ewaybill") {
                this.handleDownloadewaybill("pdf");
            }
        } else if (action === "print") {
            if (type === "pdf") {
                this.handleDownload(data, "pdf");
            } else if (type === "ewaybill") {
                this.handleDownloadewaybill("pdf");
            }
        } else if (action === "mail") {
            this.handleDownload(data, "mail");
        } else if (action === "whatsapp") {
            this.handleDownload(data, "whatsapp");
        }
        this.setState({ opendropdown: "" });
    };

    handleClose = () => {
        this.setState({ opendropdown: "" });
    };

    handleItemDetail = (item, type) => {
        if (type === 'product') {
            this.setState({ activeProductDetail: item });
        } else if (type === 'service') {
            this.setState({ activeServiceDetail: item });
        }
    };

    handleBackToTable = (type) => {
        if (type === 'product') {
            this.setState({ activeProductDetail: null });
        } else if (type === 'service') {
            this.setState({ activeServiceDetail: null });
        }
    };

    renderProductDetailView = () => {
        if (!this.state.activeProductDetail) return null;
        const product = this.state.activeProductDetail;
        const { Invoicedata } = this.state;
        const baseCurrencySymbol = CurrencyWordsFormatter.getCurrencySymbol(currency);
        const invoiceSymbol = CurrencyWordsFormatter.getCurrencySymbol(Invoicedata.currency);
        const productTotal = this.state.saleorderitems.reduce((sum, item) => {
            const total = parseFloat(item.cctotalpricewtax ?? (item.totalpricewtax * (Invoicedata.curconversionrate || 1))) || 0;
            return sum + total;
        }, 0);

        // Compute values in invoice currency
        const price_inv = product.ccprice ?? (product.price * Invoicedata.curconversionrate);
        const totalprice_inv = product.cctotalprice ?? (product.totalprice * Invoicedata.curconversionrate);
        const tax_inv = product.cctaxamount ?? (product.taxamount * Invoicedata.curconversionrate);
        const total_wtax_inv = product.cctotalpricewtax ?? (product.totalpricewtax * Invoicedata.curconversionrate);
        const discount_inv = product.ccdiscountamount ?? (product.discountamount * Invoicedata.curconversionrate);
        const taxRate = product.tax || 0;
        const isIntraState = Invoicedata.taxtype === "GST" && Invoicedata.gsttype === "INTRASTATE";

        // Check if any additional details are present and not 'N/A'
        const hasAdditionalDetails = product.colour && product.colour !== 'N/A' && product.colour !== '' ||
            product.size && product.size !== 'N/A' && product.size !== '' ||
            product.thickness && product.thickness !== 'N/A' && product.thickness !== '' ||
            product.totalmtrroll && product.totalmtrroll !== 'N/A' && product.totalmtrroll !== '';

        return (
            <div style={this.styles.detailView}>
                <div style={this.styles.detailViewHeader}>
                    <button
                        style={{
                            ...this.styles.backButton,
                            backgroundColor: this.state.hoveredBtn === "back" ? "#4d4d4d" : this.styles.backButton.backgroundColor,
                            color: this.state.hoveredBtn === "back" ? "#ffff" : "#4d4d4d",
                            transform: this.state.hoveredBtn === "back" ? "scale(1.03)" : "scale(1)",
                            transition: "all 0.01s ease",
                        }}
                        onClick={() => this.handleBackToTable("product")}
                        onMouseEnter={() => this.setState({ hoveredBtn: "back" })}
                        onMouseLeave={() => this.setState({ hoveredBtn: null })}
                    >
                        <i className="fa fa-arrow-left" /> All Products
                    </button>

                    <h3 style={{ margin: 0, color: '#1e293b' }}>
                        Total Product:{" "}
                        <strong>
                            <NumericFormat
                                displayType={"text"}
                                value={productTotal}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                                prefix={invoiceSymbol}
                            />
                        </strong>
                    </h3>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    {/* Sidebar with product list */}
                    <div style={{ ...this.styles.sidebar, height: 'auto', minHeight: '100%' }}>
                        {this.state.saleorderitems.map((item, index) => {
                            const isHovered = this.state.hoveredSidebar === item.id;
                            const isActive = item.id === product.id;
                            const totalWtax = item.cctotalpricewtax ?? (item.totalpricewtax * Invoicedata.curconversionrate);

                            return (
                                <div
                                    key={index}
                                    style={{
                                        ...this.styles.sidebarItem,
                                        ...(isActive && this.styles.sidebarItemActive),
                                        color: isHovered || isActive ? "#5f8f3f" : this.styles.sidebarItem.color,
                                        transform: isHovered ? "scale(1.09)" : "scale(1)",
                                        transition: "color 0.03s ease, transform 0.03s ease",
                                        borderRadius: isHovered ? "6px" : "0",
                                        cursor: "pointer",
                                        fontWeight: isActive ? "bold" : "normal",
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredSidebar: item.id })}
                                    onMouseLeave={() => this.setState({ hoveredSidebar: null })}
                                    onClick={() => this.handleItemDetail(item, "product")}
                                >
                                    <div style={this.styles.sidebarItemName}>{item.name}</div>
                                    <div style={this.styles.sidebarItemDetails}>
                                        Qty: {item.quantity} {item.uom} |{" "}
                                        Total:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={totalWtax}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Main content */}
                    <div style={{ ...this.styles.detailContent, flex: 1 }}>
                        <div style={this.styles.detailGrid}>
                            <div style={this.styles.detailSection}>
                                <h4 style={this.styles.sectionTitle}>Basic Information</h4>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Name</span>
                                    <span style={this.styles.detailValue}>
                                        {product.name}
                                    </span>
                                </div>

                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Description</span>
                                    <span style={this.styles.detailValue}>
                                        {product.description || "N/A"}
                                    </span>
                                </div>

                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Brand</span>
                                    <span style={this.styles.detailValue}>{product.brand || 'N/A'}</span>
                                </div>

                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>HSN Code</span>
                                    <span style={this.styles.detailValue}>{product.hsn || 'N/A'}</span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Quantity</span>
                                    <span style={this.styles.detailValue}>{product.quantity} {product.uom}</span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Type</span>
                                    <span style={this.styles.detailValue}>{product.salesenum}</span>
                                </div>
                            </div>

                            <div style={this.styles.detailSection}>
                                <h4 style={this.styles.sectionTitle}>Pricing</h4>
                                <div style={this.styles.detailRow}>
                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Unit Price</span>
                                    <span className="tw-w-1/3" style={this.styles.detailValue}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={product.price}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={baseCurrencySymbol}
                                        />
                                    </span>
                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={price_inv}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={invoiceSymbol}
                                        />
                                    </span>}
                                </div>

                                <div style={this.styles.detailRow}>
                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Total Price</span>
                                    <span className="tw-w-1/3" style={this.styles.detailValue}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={product.totalprice}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={baseCurrencySymbol}
                                        />
                                    </span>
                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={totalprice_inv}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={invoiceSymbol}
                                        />
                                    </span>}
                                </div>

                                {(discount_inv > 0 || product.discountamount > 0) && (
                                    <div style={this.styles.detailRow}>
                                        <span className="tw-w-1/3" style={this.styles.detailLabel}>Discount ({product.discount}%)</span>
                                        <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={product.discountamount}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={`(${baseCurrencySymbol}`}
                                                suffix=")"
                                            />
                                        </span>
                                        {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={discount_inv}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={`(${invoiceSymbol}`}
                                                suffix=")"
                                            />
                                        </span>}
                                    </div>
                                )}

                                {isIntraState ? (
                                    <>
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>CGST ({(taxRate / 2).toFixed(2)}%)</span>
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={product.taxamount / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={baseCurrencySymbol}
                                                />
                                            </span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={tax_inv / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                            </span>}
                                        </div>
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>SGST ({(taxRate / 2).toFixed(2)}%)</span>
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={product.taxamount / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={baseCurrencySymbol}
                                                />
                                            </span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={tax_inv / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                            </span>}
                                        </div>
                                    </>
                                ) : (
                                    <div style={this.styles.detailRow}>
                                        <span className="tw-w-1/3" style={this.styles.detailLabel}>
                                            {Invoicedata.taxtype === "GST" ? "GST" : "VAT"} ({taxRate}%)
                                        </span>
                                        <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={product.taxamount}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={baseCurrencySymbol}
                                            />
                                        </span>
                                        {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={tax_inv}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>}
                                    </div>
                                )}

                                <div style={this.styles.detailRow}>
                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Total (Inc. Tax)</span>
                                    <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={product.totalpricewtax}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={baseCurrencySymbol}
                                        />
                                    </span>
                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={total_wtax_inv}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={invoiceSymbol}
                                        />
                                    </span>}
                                </div>
                            </div>

                            {hasAdditionalDetails && (
                                <div style={this.styles.detailSection}>
                                    <h4 style={this.styles.sectionTitle}>Additional Details</h4>
                                    {product.colour && product.colour !== 'N/A' && product.colour !== '' && (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Color</span>
                                            <span style={this.styles.detailValue}>{product.colour}</span>
                                        </div>
                                    )}
                                    {product.size && product.size !== 'N/A' && product.size !== '' && (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Size</span>
                                            <span style={this.styles.detailValue}>{product.size}</span>
                                        </div>
                                    )}
                                    {product.thickness && product.thickness !== 'N/A' && product.thickness !== '' && (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Thickness</span>
                                            <span style={this.styles.detailValue}>{product.thickness}</span>
                                        </div>
                                    )}
                                    {product.totalmtrroll && product.totalmtrroll !== 'N/A' && product.totalmtrroll !== '' && (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Total Mtr/Roll</span>
                                            <span style={this.styles.detailValue}>{product.totalmtrroll}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderServiceDetailView = () => {
        if (!this.state.activeServiceDetail) return null;
        const service = this.state.activeServiceDetail;
        const { Invoicedata } = this.state;
        const invoiceSymbol = CurrencyWordsFormatter.getCurrencySymbol(Invoicedata.currency);
        const baseCurrencySymbol = CurrencyWordsFormatter.getCurrencySymbol(currency);
        const serviceTotal = this.state.invoiceservicelist.reduce((sum, item) => {
            const total = parseFloat(item.ccservicetotalwtax ?? (item.servicetotalwtax * (Invoicedata.curconversionrate || 1))) || 0;
            return sum + total;
        }, 0);

        const price_inv = service.ccservicecost ?? (service.servicecost * Invoicedata.curconversionrate);
        const discount_inv = service.ccservicediscountamount ?? (service.servicediscountamount * Invoicedata.curconversionrate);
        const tax_inv = service.ccservicetaxamount ?? (service.servicetaxamt * Invoicedata.curconversionrate);
        const total_wtax_inv = service.ccservicetotalwtax ?? (service.servicetotalwtax * Invoicedata.curconversionrate);
        const qty = service.quantity || 1;
        const taxRate = service.servicetax || 0;
        const isIntraState = Invoicedata.taxtype === "GST" && Invoicedata.gsttype === "INTRASTATE";

        return (
            <div style={this.styles.detailView}>
                <div style={this.styles.detailViewHeader}>
                    <button
                        style={{
                            ...this.styles.backButton,
                            backgroundColor: this.state.hoveredBtn === "back-service" ? "#4d4d4d" : this.styles.backButton.backgroundColor,
                            color: this.state.hoveredBtn === "back-service" ? "#ffff" : "#4d4d4d",
                            transform: this.state.hoveredBtn === "back-service" ? "scale(1.03)" : "scale(1)",
                            transition: "all 0.01s ease",
                        }}
                        onClick={() => this.handleBackToTable("service")}
                        onMouseEnter={() => this.setState({ hoveredBtn: "back-service" })}
                        onMouseLeave={() => this.setState({ hoveredBtn: null })}
                    >
                        <i className="fa fa-arrow-left" /> All Services
                    </button>

                    <h3 style={{ margin: 0, color: '#1e293b' }}>
                        Total Services:{" "}
                        <strong>
                            <NumericFormat
                                displayType={"text"}
                                value={serviceTotal}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                                prefix={invoiceSymbol}
                            />
                        </strong>
                    </h3>
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                    {/* Sidebar with service list */}
                    <div style={{ ...this.styles.sidebar, height: 'auto', minHeight: '100%' }}>
                        {this.state.invoiceservicelist.map((item, index) => {
                            const isHovered = this.state.hoveredService === item.id;
                            const isActive = item.id === service.id;
                            const totalWtax = item.ccservicetotalwtax ?? (item.servicetotalwtax * Invoicedata.curconversionrate);

                            return (
                                <div
                                    key={index}
                                    style={{
                                        ...this.styles.sidebarItem,
                                        ...(isActive && this.styles.sidebarItemActive),
                                        color: isHovered || isActive ? "#5f8f3f" : this.styles.sidebarItem.color,
                                        transform: isHovered ? "scale(1.09)" : "scale(1)",
                                        transition: "color 0.03s ease, transform 0.03s ease",
                                        borderRadius: isHovered ? "6px" : "0",
                                        cursor: "pointer",
                                        fontWeight: isActive ? "bold" : "normal",
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredService: item.id })}
                                    onMouseLeave={() => this.setState({ hoveredService: null })}
                                    onClick={() => this.handleItemDetail(item, "service")}
                                >
                                    <div style={this.styles.sidebarItemName}>{item.service}</div>
                                    <div style={this.styles.sidebarItemDetails}>
                                        Total:{" "}
                                        <span style={{ fontWeight: "bold" }}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={totalWtax}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Main content */}
                    <div style={{ ...this.styles.detailContent, flex: 1 }}>
                        <div style={this.styles.detailGrid}>
                            <div style={this.styles.detailSection}>
                                <h4 style={this.styles.sectionTitle}>Service Information</h4>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Service</span>
                                    <span style={this.styles.detailValue}>{service.service}</span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Description</span>
                                    <span style={this.styles.detailValue}>{service.description}</span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>HSN/SAC Code</span>
                                    <span style={this.styles.detailValue}>{service.servicecode || 'N/A'}</span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>Quantity</span>
                                    <span style={this.styles.detailValue}>{service.quantity}</span>
                                </div>
                            </div>

                            <div style={this.styles.detailSection}>
                                <h4 style={this.styles.sectionTitle}>Pricing ({Invoicedata.currency})</h4>
                                <div style={this.styles.detailRow}>
                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Unit Price</span>
                                    <span className="tw-w-1/3" style={this.styles.detailValue}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={service.servicecost}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={baseCurrencySymbol}
                                        />
                                    </span>
                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={price_inv}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={invoiceSymbol}
                                        />
                                    </span>}
                                </div>
                                {discount_inv > 0 && (
                                    <div style={this.styles.detailRow}>
                                        <span className="tw-w-1/3" style={this.styles.detailLabel}>Discount ({service.servicediscount}%)</span>
                                        <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={service.servicediscountamount}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={baseCurrencySymbol}
                                            />
                                        </span>
                                        {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={discount_inv}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={`(${invoiceSymbol}`}
                                                suffix=")"
                                            />
                                        </span>}
                                    </div>
                                )}

                                {isIntraState ? (
                                    <>
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>CGST ({(taxRate / 2).toFixed(2)}%)</span>
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={service.servicetaxamount / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={baseCurrencySymbol}
                                                />
                                            </span>
                                            {this.state.basecurrency !== this.state.currency &&
                                                <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                    <NumericFormat
                                                        displayType={"text"}
                                                        value={tax_inv / 2}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={thousandsdisplay}
                                                        prefix={invoiceSymbol}
                                                    />
                                                </span>}
                                        </div>
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>SGST ({(taxRate / 2).toFixed(2)}%)</span>
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={service.servicetaxamount / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={baseCurrencySymbol}
                                                />
                                            </span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={tax_inv / 2}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                            </span>}
                                        </div>
                                    </>
                                ) : (
                                    <div style={this.styles.detailRow}>
                                        <span className="tw-w-1/3" style={this.styles.detailLabel}>
                                            {Invoicedata.taxtype === "GST" ? "GST" : "VAT"} ({taxRate}%)
                                        </span>
                                        <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={service.servicetaxamount}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={baseCurrencySymbol}
                                            />
                                        </span>
                                        {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={tax_inv}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>}
                                    </div>
                                )}

                                <div style={this.styles.detailRow}>
                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Total (Inc. Tax)</span>
                                    <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={service.servicetaxamount / 2}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={baseCurrencySymbol}
                                        />
                                    </span>
                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: "bold" }}>
                                        <NumericFormat
                                            displayType={"text"}
                                            value={total_wtax_inv}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            thousandSeparator={true}
                                            thousandsGroupStyle={thousandsdisplay}
                                            prefix={invoiceSymbol}
                                        />
                                    </span>}
                                </div>

                                {service.contracttype && this.state.Invoicedata.soid !== null && (
                                    <>
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Contract Type</span>
                                            <span style={this.styles.detailValue}>{service.contracttype}</span>
                                        </div>
                                        {service.contracttype === "Recurring" && (
                                            <div style={this.styles.detailRow}>
                                                <span style={this.styles.detailLabel}>Recurring Type</span>
                                                <span style={this.styles.detailValue}>{service.recurringtype}</span>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    dataURLtoFile = (dataurl, filename) => {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };

    handleOpendropdown = (val) => {
        if (this.state.opendropdown === val) {
            this.setState({ opendropdown: "" })
        } else {
            this.setState({ opendropdown: val });
        }

    };

    handleCloseDropdown = () => {
        this.setState({ opendropdown: "" });
    };

    updateDeliveryStatus = () => {
        SalesServices.updatedeliverystatusofnoninventoryinvoices(this.state.Invoicedata.invid).then((res) => {
            if (res.data === 1) {
                toast.error("Delivery Status Not Updated")
            } else {
                toast.success("Delivery Status Updated Successfully")
                this.Refresh(this.state.Invoicedata.invid, this.state.pagename, this.state.temp)
            }
        })
    }

    render() {
        let { selectedFiles, message, isError, transporterid, transportername } =
            this.state;
        const baseSymbol = CurrencyWordsFormatter.getCurrencySymbol(currency);
        const invoiceSymbol = CurrencyWordsFormatter.getCurrencySymbol(this.state.Invoicedata.currency || currency);

        // Dynamic Column Calculation for Footer Spans
        const companyCountry = this.state.Invoicedata.companycountry;
        const ccountry = companyCountry;

        const isCancelled = this.state.Invoicedata &&
            this.state.Invoicedata.payment === "Completed" &&
            this.state.Invoicedata.ledgerentry === "Pending" &&
            this.state.Invoicedata.paid === 0;

        // Product Table Columns
        let productCols = 7; // Fixed: Item, Price, Type, Qty, UOM, Discount, Total
        if (this.state.Invoicedata.taxtype !== "NA") {
            productCols += 1; // HSN
            if (this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE") {
                productCols += 2; // CGST, SGST
            } else {
                productCols += 1; // IGST/VAT
            }
        }
        productCols += 1; // Total with Tax

        // Service Table Columns
        let serviceCols = 5; // Fixed: Service, SAC, Price, Qty, Discount
        if (this.state.Invoicedata.taxtype !== "NA") {
            if (this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE") {
                serviceCols += 2; // CGST, SGST
            } else {
                serviceCols += 1; // IGST/VAT
            }
        }
        serviceCols += 1; // Total with Tax

        // Additional Charges Table Columns
        let additionalChargesCols = 2; // Nature, Charge
        if (this.state.Invoicedata.taxtype !== "NA") {
            if (this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE") {
                additionalChargesCols += 2; // CGST, SGST
            } else {
                additionalChargesCols += 1; // IGST/VAT
            }
        }
        additionalChargesCols += 1; // Total with Tax

        const showBase = [0, 1].includes(this.state.showPricesIn);
        const showInvoiceCurr = currency !== this.state.Invoicedata.currency && [0, 2].includes(this.state.showPricesIn);

        // ========== PRODUCT & SERVICE TOTALS (for table footers) ==========
        const productTotal = this.state.saleorderitems.reduce((sum, item) => {
            const total = parseFloat(item.cctotalpricewtax ?? (item.totalpricewtax * (this.state.Invoicedata.curconversionrate || 1))) || 0;
            return sum + total;
        }, 0);
        const serviceTotal = this.state.invoiceservicelist.reduce((sum, item) => {
            const total = parseFloat(item.ccservicetotalwtax ?? (item.servicetotalwtax * (this.state.Invoicedata.curconversionrate || 1))) || 0;
            return sum + total;
        }, 0);

        // ========== FINANCIAL DETAILS (corrected for old invoices) ==========
        const rate = this.state.Invoicedata.curconversionrate || 1;

        // Products subtotal (after discount, before tax)
        const productSubtotal = this.state.saleorderitems.reduce((sum, item) => {
            // Prefer the already calculated net total (includes markup and discount)
            const net = item.cctotalprice ?? (item.totalprice != null ? item.totalprice * rate : null);
            if (net != null) return sum + net;
            // Fallback for old invoices where totalprice is null: compute from base price minus discount
            const qty = item.quantity || 1;
            const price = item.ccprice ?? (item.price * rate);
            const discount = item.ccdiscountamount ?? (item.discountamount * rate);
            return sum + (price * qty - (discount || 0));
        }, 0);

        const baseproductSubtotal = this.state.saleorderitems.reduce((sum, item) => {
            // Prefer the already calculated net total (includes markup and discount)
            const net = item.totalprice
            if (net != null) return sum + net;
            // Fallback for old invoices where totalprice is null: compute from base price minus discount
            const qty = item.quantity || 1;
            const price = item.price;
            const discount = item.discountamount;
            return sum + (price * qty - (discount || 0));
        }, 0);

        // Services subtotal (after discount, before tax)
        const serviceSubtotal = this.state.invoiceservicelist.reduce((sum, item) => {
            if (item.invoicemilestones) {
                // Prefer the already calculated net total (includes markup and discount)
                const net = item.invoicemilestones.cctotalprice ?? (item.invoicemilestones.totalprice != null ? item.invoicemilestones.totalprice * rate : null);
                if (net != null) return sum + net;
                // Fallback for old invoices
                const qty = 1;
                const price = item.invoicemilestones.cctotalprice ?? (item.invoicemilestones.totalprice * rate);
                const discount = item.ccservicediscountamount ?? (item.servicediscountamount * rate);
                return sum + (price * qty - (discount || 0));

            } else {
                // Prefer the already calculated net total (includes markup and discount)
                const net = item.ccservicetotal ?? (item.servicetotal != null ? item.servicetotal * rate : null);
                if (net != null) return sum + net;
                // Fallback for old invoices
                const qty = item.quantity || 1;
                const price = item.ccservicecost ?? (item.servicecost * rate);
                const discount = item.ccservicediscountamount ?? (item.servicediscountamount * rate);
                return sum + (price * qty - (discount || 0));
            }
        }, 0);

        const baseserviceSubtotal = this.state.invoiceservicelist.reduce((sum, item) => {
            if (item.invoicemilestones) {
                // Prefer the already calculated net total (includes markup and discount)
                const net = item.invoicemilestones.totalprice;
                if (net != null) return sum + net;
                // Fallback for old invoices
                const qty = 1;
                const price = item.invoicemilestones.totalprice;
                const discount = item.servicediscountamount;
                return sum + (price * qty - (discount || 0));

            } else {
                // Prefer the already calculated net total (includes markup and discount)
                const net = item.servicetotal;
                if (net != null) return sum + net;
                // Fallback for old invoices
                const qty = item.quantity || 1;
                const price = item.servicecost;
                const discount = item.servicediscountamount;
                return sum + (price * qty - (discount || 0));
            }
        }, 0);

        // Additional charges base amount (before tax)
        const additionalChargesSubtotal = this.state.additionalchareslist.reduce((sum, item) => {
            const amt = item.ccadditionalcharges ?? (item.additionalcharges * rate);
            return sum + (amt || 0);
        }, 0);

        // Insurance base amount
        const insuranceAmountConverted = this.state.Invoicedata.insurancereq
            ? (this.state.Invoicedata.ccinsuranceamount ?? (this.state.Invoicedata.insuranceamount * rate)) || 0
            : 0;

        const productTaxTotal = this.state.saleorderitems.reduce((sum, item) => {
            const tax = item.cctaxamount ?? (item.taxamount * rate);
            return sum + (tax || 0);
        }, 0);

        const serviceTaxTotal = this.state.invoiceservicelist.reduce((sum, item) => {
            if (item.invoicemilestones) {
                let tax = item.invoicemilestones.cctaxamount;
                if (tax === undefined || tax === null) {

                    // Fallback to calculation if tax amount is missing
                    const cost = item.invoicemilestones.cctotalprice ?? (item.invoicemilestones.totalprice * rate);
                    const qty = 1;
                    const discount = 0;
                    const taxRate = item.servicetax || 0;
                    tax = ((cost * qty) - (discount || 0)) * (taxRate / 100);
                }
                return sum + (tax || 0);
            } else {
                let tax = item.ccservicetaxamount;
                if (tax === undefined || tax === null) {
                    const baseTax = item.servicetaxamount ?? item.servicetaxamt;
                    if (baseTax != null) {
                        tax = baseTax * rate;
                    } else {
                        // Fallback to calculation if tax amount is missing
                        const cost = item.ccservicecost ?? (item.servicecost * rate);
                        const qty = item.quantity || 1;
                        const discount = item.ccservicediscountamount ?? (item.servicediscountamount * rate);
                        const taxRate = item.servicetax || 0;
                        tax = ((cost * qty) - (discount || 0)) * (taxRate / 100);
                    }
                }
                return sum + (tax || 0);
            }
        }, 0);

        const additionalChargesTaxTotal = this.state.additionalchareslist.reduce((sum, item) => {
            const tax = item.ccadditionalchargestaxamount ?? (item.additionalchargestaxamount * rate);
            return sum + (tax || 0);
        }, 0);

        // Insurance tax amount (totalinsurance includes base + tax, so tax = total - base)
        const insuranceTaxAmount = this.state.Invoicedata.insurancereq
            ? ((this.state.Invoicedata.cctotalinsurance ?? (this.state.Invoicedata.totalinsurance * rate)) - insuranceAmountConverted)
            : 0;

        // Total tax (used for grouping)
        const totalTaxAmountCalculated = productTaxTotal + serviceTaxTotal + additionalChargesTaxTotal + insuranceTaxAmount;

        // Discount totals (for reference)
        const productDiscountTotal = this.state.saleorderitems.reduce((sum, item) => {
            const disc = item.ccdiscountamount ?? (item.discountamount * rate);
            return sum + (disc || 0);
        }, 0);

        const serviceDiscountTotal = this.state.invoiceservicelist.reduce((sum, item) => {
            const disc = item.ccservicediscountamount ?? (item.servicediscountamount * rate);
            return sum + (disc || 0);
        }, 0);

        // TCS amount (if applicable)
        const tcsAmount = this.state.Invoicedata.tcsreq && this.state.Invoicedata.tcsamount
            ? (this.state.Invoicedata.cctcsamount ?? (this.state.Invoicedata.tcsamount * rate))
            : 0;

        // Grouped taxes for display
        let totalCGST = 0, totalSGST = 0, totalIGST = 0, totalVAT = 0;
        if (this.state.Invoicedata.taxtype === "GST") {
            if (this.state.Invoicedata.gsttype === "INTRASTATE") {
                totalCGST = totalTaxAmountCalculated / 2;
                totalSGST = totalTaxAmountCalculated / 2;
            } else {
                totalIGST = totalTaxAmountCalculated;
            }
        } else if (this.state.Invoicedata.taxtype === "VAT") {
            totalVAT = totalTaxAmountCalculated;
        }

        // Final total invoice amount (after discount, tax, TCS)
        const totalInvoiceAmount = productSubtotal + serviceSubtotal
            + additionalChargesSubtotal + insuranceAmountConverted
            + totalTaxAmountCalculated + tcsAmount;

        const productCount = this.state.saleorderitems.length;
        const serviceCount = this.state.invoiceservicelist.length;

        return (
            <div className="UI-container">
                <div className="UI-header">
                    <Breadcrumb back="/salesinvoice" breadcrumbs={[{ name: "Home", path: "/sales" }, { name: "Sales Invoices", path: "/salesinvoice" }, { name: this.state.pagename, path: null }]} />
                    <div style={this.styles.headerContent}>
                        <div>
                            <h1 style={this.styles.title}>
                                {this.state.pagename} - {this.state.pagename ===
                                    "Tax Invoice Details"
                                    ? this.state.Invoicedata?.custominvid
                                    : this.state.Invoicedata?.invid}
                            </h1>
                            <p style={this.styles.subtitle}>
                                Detailed view of invoice information and transactions
                            </p>
                        </div>

                        <div style={this.styles.headerActions}>
                            {/* {this.state.currency !== currency && (
                                    <div style={{ minWidth: '150px', marginRight: '8px' }}>
                                        <FormControl variant="standard" size="small" fullWidth>
                                            <Select
                                                value={this.state.showPricesIn}
                                                onChange={(e) => this.setState({ showPricesIn: e.target.value })}
                                                displayEmpty
                                                inputProps={{ 'aria-label': 'Show Prices In' }}
                                                style={{ fontSize: '0.8rem' }}
                                            >
                                                <MenuItem value={0}>Default View</MenuItem>
                                                <MenuItem value={1}>Base Currency ({currency})</MenuItem>
                                                <MenuItem value={2}>Invoice Currency ({this.state.Invoicedata.currency})</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                )} */}

                            {!this.state.loading && (
                                <div style={this.styles.headerActions}>
                                    {this.state.pagename === "Tax Invoice Details" && !isCancelled && this.state.Invoicedata.approvestatus === "Approved" && <Link
                                        to={{ pathname: "/newsalesinvoice" }}
                                        state={{
                                            id: this.state.Invoicedata.invid,
                                            pagename: "New Invoice",
                                            clone: true
                                        }}
                                        type="button"
                                        className="btn btn-sm pdf-bgcolor button-shadow text-white !tw-bg-[#4d4d4d] hover:!tw-bg-[#1f2937] hover:!tw-scale-[1.03] !tw-transition !tw-ease-in-out"
                                        style={{ ...this.styles.btn }}

                                    ><img src={cloneicon} width="15px" height="15px" alt="pdf" /> Clone
                                    </Link>}
                                    {/* ---------- PDF BUTTON (always visible) ---------- */}
                                    <div
                                        style={this.styles.dropdownContainer}
                                        data-dropdown-container
                                        onMouseEnter={() => this.setState({ opendropdown: 'pdf' })}
                                        onMouseLeave={() => {
                                            setTimeout(() => {
                                                if (!this.isMouseOverDropdown) {
                                                    this.setState({ opendropdown: '' });
                                                }
                                            }, 100);
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-sm pdf-bgcolor button-shadow text-white"
                                            style={{
                                                ...this.styles.btn,
                                                backgroundColor: (this.state.opendropdown === 'pdf' || this.state.hoveredBtn === "pdf") ? "#1f2937" : "#4d4d4d",
                                                transform: (this.state.opendropdown === 'pdf' || this.state.hoveredBtn === "pdf") ? "scale(1.03)" : "scale(1)",
                                                transition: "all 0.01s ease",
                                            }}
                                            onMouseEnter={() => this.setState({ hoveredBtn: "pdf" })}
                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                            onClick={() => this.handleOpendropdown('pdf')}
                                        >
                                            <img src={pdficon} width="15px" height="15px" alt="pdf" /> PDF
                                        </button>

                                        {this.state.opendropdown === "pdf" && (
                                            <div
                                                style={this.styles.tooltipDropdown}
                                                data-tooltip-dropdown
                                                onMouseEnter={() => { this.isMouseOverDropdown = true; }}
                                                onMouseLeave={() => {
                                                    this.isMouseOverDropdown = false;
                                                    setTimeout(() => {
                                                        this.setState({ opendropdown: '' });
                                                    }, 100);
                                                }}
                                            >
                                                <div style={this.styles.tooltipArrow}></div>
                                                <button
                                                    style={{
                                                        ...this.styles.tooltipDropdownItem,
                                                        ...(this.state.hoveredDropdownItem === 'pdf-download' ? this.styles.tooltipDropdownItemHover : {})
                                                    }}
                                                    type="button"
                                                    onMouseEnter={() => this.setState({ hoveredDropdownItem: 'pdf-download' })}
                                                    onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                    onClick={() => this.handleDropdownAction("download", "pdf", this.state.Invoicedata)}
                                                >
                                                    Download PDF
                                                </button>
                                                <button
                                                    style={{
                                                        ...this.styles.tooltipDropdownItem,
                                                        ...(this.state.hoveredDropdownItem === 'pdf-print' ? this.styles.tooltipDropdownItemHover : {})
                                                    }}
                                                    type="button"
                                                    onMouseEnter={() => this.setState({ hoveredDropdownItem: 'pdf-print' })}
                                                    onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                    onClick={() => this.handleDropdownAction("print", "pdf", this.state.Invoicedata)}
                                                >
                                                    Print PDF
                                                </button>

                                                {this.state.pagename === "Tax Invoice Details" &&
                                                    this.state.Invoicedata.ewaybillstatus === "Generated" &&
                                                    (this.state.ewaybilldata.ewbno !== null && this.state.ewaybilldata.ewbno !== undefined) && (
                                                        <>
                                                            <button
                                                                style={{
                                                                    ...this.styles.tooltipDropdownItem,
                                                                    ...(this.state.hoveredDropdownItem === 'pdf-eway-download' ? this.styles.tooltipDropdownItemHover : {})
                                                                }}
                                                                type="button"
                                                                onMouseEnter={() => this.setState({ hoveredDropdownItem: 'pdf-eway-download' })}
                                                                onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                                onClick={() => this.handleDropdownAction("download", "ewaybill")}
                                                            >
                                                                Download Ewaybill PDF
                                                            </button>
                                                            <button
                                                                style={{
                                                                    ...this.styles.tooltipDropdownItem,
                                                                    ...(this.state.hoveredDropdownItem === 'pdf-eway-print' ? this.styles.tooltipDropdownItemHover : {})
                                                                }}
                                                                type="button"
                                                                onMouseEnter={() => this.setState({ hoveredDropdownItem: 'pdf-eway-print' })}
                                                                onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                                onClick={() => this.handleDropdownAction("print", "ewaybill")}
                                                            >
                                                                Print Ewaybill PDF
                                                            </button>
                                                        </>
                                                    )}
                                            </div>
                                        )}
                                    </div>

                                    {/* ---------- RECEIPT BUTTON (only if not cancelled) ---------- */}
                                    {!isCancelled && (
                                        <div
                                            style={this.styles.dropdownContainer}
                                            data-dropdown-container
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-sm recipt-bgcolor button-shadow text-white"
                                                style={{
                                                    ...this.styles.btn,
                                                    backgroundColor: this.state.hoveredBtn === "receipt" ? "#1f2937" : "#4d4d4d",
                                                    transform: this.state.hoveredBtn === "receipt" ? "scale(1.03)" : "scale(1)",
                                                    transition: "all 0.01s ease",
                                                    opacity: (!this.state.receiptData || this.state.receiptData.length === 0) ? 0.6 : 1
                                                }}
                                                disabled={!this.state.receiptData || this.state.receiptData.length === 0}
                                                onMouseEnter={() => this.setState({ hoveredBtn: "receipt" })}
                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                onClick={() => this.handleOpendropdown('receipt')}
                                            >
                                                <img src={receiptIcon} width="15px" height="15px" alt="receipt" /> RECEIPT
                                            </button>
                                            {this.state.opendropdown === "receipt" && this.state.receiptData && (
                                                <div style={this.styles.tooltipDropdown} data-tooltip-dropdown>
                                                    <div style={this.styles.tooltipArrow}></div>
                                                    {this.state.receiptData.length === 1 ? (
                                                        <button
                                                            style={this.styles.tooltipDropdownItem}
                                                            onClick={() => this.generateReceiptPDF(this.state.receiptData[0], 1)}
                                                        >
                                                            Download Receipt
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button
                                                                style={this.styles.tooltipDropdownItem}
                                                                onClick={() => {
                                                                    this.state.receiptData.forEach((rec, idx) => {
                                                                        setTimeout(() => {
                                                                            this.generateReceiptPDF(rec, idx + 1);
                                                                        }, idx * 500);
                                                                    });
                                                                }}
                                                            >
                                                                Download All
                                                            </button>
                                                            <button
                                                                style={this.styles.tooltipDropdownItem}
                                                                onClick={() => {
                                                                    const latestReceipt = this.state.receiptData.reduce((latest, current) => {
                                                                        return new Date(current.createdAt) > new Date(latest.createdAt) ? current : latest;
                                                                    });
                                                                    const latestIdx = this.state.receiptData.indexOf(latestReceipt);
                                                                    this.generateReceiptPDF(latestReceipt, latestIdx + 1);
                                                                }}
                                                            >
                                                                Download Recent
                                                            </button>
                                                            {this.state.receiptData.map((r, i) => (
                                                                <button
                                                                    key={i}
                                                                    style={this.styles.tooltipDropdownItem}
                                                                    onClick={() => this.generateReceiptPDF(r, i + 1)}
                                                                >
                                                                    Receipt {i + 1} - {r.transid}
                                                                </button>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* ---------- SEND SMS BUTTON (only if not cancelled) ---------- */}
                                    {!isCancelled && (
                                        <div style={this.styles.dropdownContainer}>
                                            <button
                                                type="button"
                                                className="btn btn-sm sms-bgcolor button-shadow text-white"
                                                style={{
                                                    ...this.styles.btn,
                                                    backgroundColor: this.state.hoveredBtn === "sms" ? "#1f2937" : "#4d4d4d",
                                                    transform: this.state.hoveredBtn === "sms" ? "scale(1.03)" : "scale(1)",
                                                    transition: "all 0.01s ease",
                                                }}
                                                onMouseEnter={() => this.setState({ hoveredBtn: "sms" })}
                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                            >
                                                <img src={smsIcon} width="15px" height="15px" alt="sms" /> SEND SMS
                                            </button>
                                        </div>
                                    )}

                                    {/* ---------- WHATSAPP BUTTON (only if not cancelled) ---------- */}
                                    {!isCancelled && (
                                        <div style={this.styles.dropdownContainer}>
                                            <button
                                                type="button"
                                                className="btn btn-sm whatsapp-bgcolor button-shadow text-white"
                                                style={{
                                                    ...this.styles.btn,
                                                    backgroundColor: this.state.hoveredBtn === "whatsapp" ? "#1f2937" : "#4d4d4d",
                                                    transform: this.state.hoveredBtn === "whatsapp" ? "scale(1.03)" : "scale(1)",
                                                    transition: "all 0.01s ease",
                                                }}
                                                onMouseEnter={() => this.setState({ hoveredBtn: "whatsapp" })}
                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                onClick={() => this.handleDropdownAction("whatsapp", "invoice-created", this.state.Invoicedata)}
                                            >
                                                <img src={whatsappIcon} width="15px" height="15px" alt="whatsapp" /> WHATSAPP
                                            </button>
                                        </div>
                                    )}

                                    {/* ---------- SEND EMAIL BUTTON (only if not cancelled) ---------- */}
                                    {!isCancelled && (
                                        <div
                                            style={this.styles.dropdownContainer}
                                            data-dropdown-container
                                            onMouseEnter={() => this.setState({ opendropdown: 'mail' })}
                                            onMouseLeave={() => {
                                                setTimeout(() => {
                                                    if (!this.isMouseOverDropdown) {
                                                        this.setState({ opendropdown: '' });
                                                    }
                                                }, 100);
                                            }}
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-sm mail-bgcolor button-shadow text-white"
                                                style={{
                                                    ...this.styles.btn,
                                                    backgroundColor: (this.state.opendropdown === 'mail' || this.state.hoveredBtn === "mail") ? "#1f2937" : "#4d4d4d",
                                                    transform: (this.state.opendropdown === 'mail' || this.state.hoveredBtn === "mail") ? "scale(1.03)" : "scale(1)",
                                                    transition: "all 0.01s ease",
                                                }}
                                                onMouseEnter={() => this.setState({ hoveredBtn: "mail" })}
                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                onClick={() => this.handleOpendropdown('mail')}
                                            >
                                                <img src={mailIcon} width="15px" height="15px" alt="mail" /> SEND EMAIL
                                            </button>

                                            {this.state.opendropdown === "mail" && (
                                                <div
                                                    style={this.styles.tooltipDropdown}
                                                    data-tooltip-dropdown
                                                    onMouseEnter={() => { this.isMouseOverDropdown = true; }}
                                                    onMouseLeave={() => {
                                                        this.isMouseOverDropdown = false;
                                                        setTimeout(() => {
                                                            this.setState({ opendropdown: '' });
                                                        }, 100);
                                                    }}
                                                >
                                                    <div style={this.styles.tooltipArrow}></div>
                                                    <button
                                                        style={{
                                                            ...this.styles.tooltipDropdownItem,
                                                            ...(this.state.hoveredDropdownItem === 'mail-invoice-created' ? this.styles.tooltipDropdownItemHover : {})
                                                        }}
                                                        type="button"
                                                        onMouseEnter={() => this.setState({ hoveredDropdownItem: 'mail-invoice-created' })}
                                                        onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                        onClick={() => this.handleDropdownAction("mail", "invoice-created", this.state.Invoicedata)}
                                                    >
                                                        Invoice Created
                                                    </button>
                                                    <button
                                                        style={{
                                                            ...this.styles.tooltipDropdownItem,
                                                            ...(this.state.hoveredDropdownItem === 'mail-payment-reminder' ? this.styles.tooltipDropdownItemHover : {})
                                                        }}
                                                        type="button"
                                                        onMouseEnter={() => this.setState({ hoveredDropdownItem: 'mail-payment-reminder' })}
                                                        onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                        onClick={() => this.handleDropdownAction("mail", "payment-reminder", this.state.Invoicedata)}
                                                    >
                                                        Invoice Payment Reminder
                                                    </button>
                                                    <button
                                                        style={{
                                                            ...this.styles.tooltipDropdownItem,
                                                            ...(this.state.hoveredDropdownItem === 'mail-overdue-notice' ? this.styles.tooltipDropdownItemHover : {})
                                                        }}
                                                        type="button"
                                                        onMouseEnter={() => this.setState({ hoveredDropdownItem: 'mail-overdue-notice' })}
                                                        onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                        onClick={() => this.handleDropdownAction("mail", "overdue-notice", this.state.Invoicedata)}
                                                    >
                                                        Invoice Overdue Notice
                                                    </button>
                                                    <button
                                                        style={{
                                                            ...this.styles.tooltipDropdownItem,
                                                            ...(this.state.hoveredDropdownItem === 'mail-payment-confirmation' ? this.styles.tooltipDropdownItemHover : {})
                                                        }}
                                                        type="button"
                                                        onMouseEnter={() => this.setState({ hoveredDropdownItem: 'mail-payment-confirmation' })}
                                                        onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                        onClick={() => this.handleDropdownAction("mail", "payment-confirmation", this.state.Invoicedata)}
                                                    >
                                                        Invoice Payment Confirmation
                                                    </button>
                                                    <button
                                                        style={{
                                                            ...this.styles.tooltipDropdownItem,
                                                            ...(this.state.hoveredDropdownItem === 'mail-refund-confirmation' ? this.styles.tooltipDropdownItemHover : {})
                                                        }}
                                                        type="button"
                                                        onMouseEnter={() => this.setState({ hoveredDropdownItem: 'mail-refund-confirmation' })}
                                                        onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                        onClick={() => this.handleDropdownAction("mail", "refund-confirmation", this.state.Invoicedata)}
                                                    >
                                                        Invoice Refund Confirmation
                                                    </button>
                                                    {this.state.pagename === "Tax Invoice Details" &&
                                                        this.state.Invoicedata.ewaybillstatus === "Generated" &&
                                                        (this.state.ewaybilldata.ewbno !== null && this.state.ewaybilldata.ewbno !== undefined) && (
                                                            <button
                                                                style={{
                                                                    ...this.styles.tooltipDropdownItem,
                                                                    ...(this.state.hoveredDropdownItem === 'mail-ewaybill' ? this.styles.tooltipDropdownItemHover : {})
                                                                }}
                                                                type="button"
                                                                onMouseEnter={() => this.setState({ hoveredDropdownItem: 'mail-ewaybill' })}
                                                                onMouseLeave={() => this.setState({ hoveredDropdownItem: null })}
                                                                onClick={() => this.handleDownloadewaybill("mail")}
                                                            >
                                                                Ewaybill
                                                            </button>
                                                        )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Backdrop
                    sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={this.state.loader}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                {this.state.loading === true ? (
                    <div style={this.styles.loadingContainer}>
                        {spin}
                    </div>
                ) : (
                    <div className="UI-form-card">
                        {/* E-Invoice and E-Way Bill Information */}
                        {this.state.pagename === "Tax Invoice Details" &&
                            (this.state.Invoicedata.einvoicestatus === "Generated" ||
                                this.state.Invoicedata.einvoicestatus === "Cancelled") &&
                            this.state.einvoicedata.irn !== undefined ? (
                            <div style={{
                                ...this.styles.detailSection,
                                marginBottom: '15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <h3 style={this.styles.sectionTitle}>E-Invoice Information</h3>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>IRN</span>
                                        <span style={this.styles.detailValue}>{this.state.einvoicedata.irn}</span>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Ack No</span>
                                        <span style={this.styles.detailValue}>{this.state.einvoicedata.ackno}</span>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Ack Date</span>
                                        <span style={this.styles.detailValue}>
                                            {moment(this.state.einvoicedata.ackDt).format("DD-MM-yyyy HH:mm")}
                                        </span>
                                    </div>

                                    {(this.state.Invoicedata.ewaybillstatus === "Generated" ||
                                        this.state.Invoicedata.ewaybillstatus === "Cancelled") &&
                                        this.state.ewaybilldata.ewbno !== undefined ? (
                                        <>
                                            <div style={this.styles.detailRow}>
                                                <span style={this.styles.detailLabel}>E-Way Bill No</span>
                                                <span style={this.styles.detailValue}>{this.state.ewaybilldata.ewbno}</span>
                                            </div>
                                            <div style={this.styles.detailRow}>
                                                <span style={this.styles.detailLabel}>E-Way Bill Date</span>
                                                <span style={this.styles.detailValue}>
                                                    {moment(this.state.ewaybilldata.ewbdt).format("DD-MM-yyyy HH:mm")}
                                                </span>
                                            </div>
                                            <div style={this.styles.detailRow}>
                                                <span style={this.styles.detailLabel}>E-Way Bill Valid Till</span>
                                                <span style={this.styles.detailValue}>
                                                    {moment(this.state.ewaybilldata.ewbvalidtill).format("DD-MM-yyyy HH:mm")}
                                                </span>
                                            </div>
                                        </>
                                    ) : ""}
                                </div>
                                <div style={{ marginLeft: '20px' }}>
                                    <img
                                        src={this.state.QRcode}
                                        alt="qrcode"
                                        width="180"
                                        height="180"
                                        style={{ objectFit: "contain" }}
                                    />
                                </div>
                            </div>
                        ) : ""}

                        {/* E-Way Bill Only Information */}
                        {(this.state.Invoicedata.ewaybillstatus === "Generated" ||
                            this.state.Invoicedata.ewaybillstatus === "Cancelled") &&
                            this.state.ewaybilldata.ewbno !== undefined &&
                            this.state.Invoicedata.einvoicestatus === "NA" ? (
                            <div style={{ ...this.styles.detailSection, marginBottom: '15px' }}>
                                <h3 style={this.styles.sectionTitle}>E-Way Bill Information</h3>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>E-Way Bill No</span>
                                    <span style={this.styles.detailValue}>{this.state.ewaybilldata.ewbno}</span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>E-Way Bill Date</span>
                                    <span style={this.styles.detailValue}>
                                        {moment(this.state.ewaybilldata.ewbdt).format("DD-MM-yyyy HH:mm")}
                                    </span>
                                </div>
                                <div style={this.styles.detailRow}>
                                    <span style={this.styles.detailLabel}>E-Way Bill Valid Till</span>
                                    <span style={this.styles.detailValue}>
                                        {moment(this.state.ewaybilldata.ewbvalidtill).format("DD-MM-yyyy HH:mm")}
                                    </span>
                                </div>
                            </div>
                        ) : ""}

                        {/* ========== INVOICE SUMMARY ========== */}
                        <div style={{ ...this.styles.detailSectionMain, marginBottom: '15px' }}>
                            <h3 style={this.styles.sectionTitleMain}>Invoice Summary</h3>
                            <div style={this.styles.detailGrid}>
                                {/* Invoice Information */}
                                <div style={this.styles.detailSection}>
                                    <h3 style={this.styles.sectionTitle}>Invoice Information</h3>
                                    {this.state.pagename === "Tax Invoice Details" ? (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Invoice Id</span>
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.einvid === null || this.state.Invoicedata.einvid === undefined
                                                    ? this.state.Invoicedata.invid
                                                    : this.state.Invoicedata.einvid}
                                            </span>
                                        </div>
                                    ) : ""}
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Detailed Invoice Id</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.pagename === "Tax Invoice Details"
                                                ? this.state.Invoicedata.custominvid
                                                : this.state.Invoicedata.invid}
                                        </span>
                                    </div>
                                    {this.state.Invoicedata.customsoid === null || this.state.Invoicedata.customsoid === undefined ? "" : (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Order Id</span>
                                            <span style={this.styles.detailValue}>
                                                <Link
                                                    to={{ pathname: "/saleorderdetails" }}
                                                    state={{
                                                        id: this.state.Invoicedata.soid,
                                                        pagename: this.state.type === "Tax Invoice" ? "Tax Invoice Details" : "Proforma Invoice Details",
                                                        type: this.state.type,
                                                    }}
                                                    style={{ color: '#4d4d4d', textDecoration: 'none' }}
                                                >
                                                    {this.state.Invoicedata.customsoid}
                                                </Link>
                                            </span>
                                        </div>
                                    )}
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Created By</span>
                                        <span style={this.styles.detailValue}>{this.state.Invoicedata.createdbyname}</span>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Invoice Date</span>
                                        <span style={this.styles.detailValue}>
                                            {moment(this.state.Invoicedata.createdAt).format("DD-MM-yyyy")}
                                        </span>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Due Date</span>
                                        <span style={this.styles.detailValue}>
                                            {moment(this.state.Invoicedata.duedate || this.state.Invoicedata.createdAt).format("DD-MM-yyyy")}
                                        </span>
                                    </div>
                                    {this.state.Invoicedata.sotype === "Services" || !this.state.Invoicedata.warehouse || this.state.Invoicedata.warehouse === "" ? "" : (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>Org Unit</span>
                                            <span style={this.styles.detailValue}>{this.state.Invoicedata.warehouse}</span>
                                        </div>
                                    )}
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Tax Type</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.taxtype}
                                            {this.state.Invoicedata.taxtype === "GST" ? ` (${this.state.Invoicedata.gsttype})` : ""}
                                        </span>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Delivery Status</span>
                                        <span style={this.styles.detailValue}>{this.state.Invoicedata.deliverystatus} {this.state.Invoicedata.deliverystatus === "Pending" && this.state.Invoicedata.payment === "Completed" && <button className="tw-ml-2 tw-bg-primary-500 hover:tw-bg-primary-600 tw-text-black tw-px-2 tw-py-1 tw-rounded tw-text-xs" onClick={this.updateDeliveryStatus}>Update</button>}</span>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Payment Status</span>
                                        <span style={this.styles.detailValue} className="tw-flex tw-items-center tw-justify-end tw-gap-1">{this.state.Invoicedata.payment} {this.state.Invoicedata.payment !== "Completed" && <span className="tw-cursor-pointer" onClick={this.fetchPaymentStatus}><RefreshCw size={12} /></span>}</span>
                                    </div>
                                    {this.state.pagename === "Proforma Invoice Details" && (
                                        <div style={{ ...this.styles.detailRow, borderBottom: 'none' }}>
                                            <span style={this.styles.detailLabel}>Advance Status</span>
                                            <span style={{
                                                ...this.styles.detailValue,
                                                color: this.state.Invoicedata.advansepaystatus === 'Paid' ? '#16a34a' : '#ef4444'
                                            }}>
                                                {this.state.Invoicedata.advansepaystatus || 'Pending'}
                                            </span>
                                        </div>
                                    )}

                                    {this.state.Invoicedata.recurring === "TRUE" && (<>
                                        <div style={{ ...this.styles.detailRow, borderBottom: 'none' }}>
                                            <span style={this.styles.detailLabel}>Recurring Periood</span>
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.recurringperiod}
                                            </span>
                                        </div>
                                        <div style={{ ...this.styles.detailRow, borderBottom: 'none' }}>
                                            <span style={this.styles.detailLabel}>Recurring End Date</span>
                                            <span style={this.styles.detailValue}>
                                                {moment(this.state.Invoicedata.recurringenddate).format("DD-MM-yyyy")}
                                            </span>
                                        </div>
                                    </>)}
                                </div>

                                {/* Financial Details */}
                                <div style={this.styles.detailSection}>
                                    <h3 style={this.styles.sectionTitle}>Financial Details</h3>

                                    {/* Subtotal (Products + Services) */}
                                    <div style={this.styles.detailRow}>
                                        <span className="tw-w-1/3" style={this.styles.detailLabel}>Subtotal (Excl. Tax)</span>
                                        {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            {/* <NumericFormat
                                                        displayType={"text"}
                                                        value={baseproductSubtotal + baseserviceSubtotal}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={thousandsdisplay}
                                                        prefix={invoiceSymbol}
                                                    /> */}
                                        </span>}
                                        <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={productSubtotal + serviceSubtotal}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                disabled={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>
                                    </div>

                                    {/* Additional Charges (Charges + Insurance) */}
                                    {(additionalChargesSubtotal + insuranceAmountConverted) > 0 && (
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>Additional Charges</span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={additionalChargesSubtotal + insuranceAmountConverted}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                            </span>
                                        </div>
                                    )}

                                    {/* Grouped Taxes */}
                                    {this.state.Invoicedata.taxtype === "GST" ? (
                                        this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                            <>
                                                <div style={this.styles.detailRow}>
                                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Total CGST</span>
                                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                                    <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={totalCGST}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                            prefix={invoiceSymbol}
                                                        />
                                                    </span>
                                                </div>
                                                <div style={this.styles.detailRow}>
                                                    <span className="tw-w-1/3" style={this.styles.detailLabel}>Total SGST</span>
                                                    {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                                    <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={totalSGST}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                            prefix={invoiceSymbol}
                                                        />
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            <div style={this.styles.detailRow}>
                                                <span className="tw-w-1/3" style={this.styles.detailLabel}>Total IGST</span>
                                                {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                                <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                    <NumericFormat
                                                        displayType={"text"}
                                                        value={totalIGST}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={thousandsdisplay}
                                                        prefix={invoiceSymbol}
                                                    />
                                                </span>
                                            </div>
                                        )
                                    ) : this.state.Invoicedata.taxtype === "VAT" ? (
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>Total VAT</span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={totalVAT}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                            </span>
                                        </div>
                                    ) : null}

                                    {/* TCS */}
                                    {this.state.Invoicedata.tcsreq && tcsAmount > 0 ? (
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>
                                                TCS ({this.state.Invoicedata.tcs}% On{' '}
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={this.state.Invoicedata.tcsableamount}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                                )
                                            </span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={tcsAmount}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={invoiceSymbol}
                                                />
                                            </span>
                                        </div>
                                    ) : ""}

                                    {/* Total Discount */}
                                    {(productDiscountTotal + serviceDiscountTotal) > 0 && (
                                        <div style={this.styles.detailRow}>
                                            <span className="tw-w-1/3" style={this.styles.detailLabel}>Total Discount</span>
                                            {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={this.styles.detailValue}></span>}
                                            <span className="tw-w-1/3" style={this.styles.detailValue}>
                                                <NumericFormat
                                                    displayType={"text"}
                                                    value={productDiscountTotal + serviceDiscountTotal}
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                    disabled={true}
                                                    thousandSeparator={true}
                                                    thousandsGroupStyle={thousandsdisplay}
                                                    prefix={`(${invoiceSymbol}`}
                                                    suffix={')'}
                                                />
                                            </span>
                                        </div>
                                    )}

                                    {/* Total Invoice Amount */}
                                    <div style={{ ...this.styles.detailRow, borderTop: '1px solid #e2e8f0', paddingTop: '8px', marginTop: '8px' }}>
                                        <span className="tw-w-1/3" style={{ ...this.styles.detailLabel, fontWeight: 700, color: '#1e293b' }}>Total (Inc. Tax)</span>
                                        {this.state.basecurrency !== this.state.currency && <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: 700, color: '#1e293b' }}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={this.state.Invoicedata.totalinvoicewtax}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={baseSymbol}
                                            />
                                        </span>}
                                        <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: 700, color: '#1e293b' }}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={totalInvoiceAmount}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>
                                    </div>

                                    {/* Received and Due Amount */}
                                    <div style={this.styles.detailRow}>
                                        <span className="tw-w-1/3" style={this.styles.detailLabel}>Received Amount</span>
                                        <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={this.state.Invoicedata.paid}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={baseSymbol}
                                            />
                                        </span>
                                        {this.state.Invoicedata.currency !== currency && <span className="tw-w-1/3" style={this.styles.detailValue}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={this.state.Invoicedata.currency !== currency ? this.state.Invoicedata.curconversionrate ? (1 / this.state.Invoicedata.curconversionrate) * this.state.Invoicedata.paid : this.state.Invoicedata.paid : this.state.Invoicedata.paid}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>}
                                    </div>
                                    <div style={{ ...this.styles.detailRow, borderBottom: 'none' }}>
                                        <span className="tw-w-1/3" style={{ ...this.styles.detailLabel, color: '#ef4444', fontWeight: 600 }}>Due Amount</span>
                                        <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: 700, color: '#ef4444' }}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={this.state.Invoicedata.due}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={baseSymbol}
                                            />
                                        </span>
                                        {this.state.Invoicedata.currency !== currency && <span className="tw-w-1/3" style={{ ...this.styles.detailValue, fontWeight: 700, color: '#ef4444' }}>
                                            <NumericFormat
                                                displayType={"text"}
                                                value={this.state.Invoicedata.currency !== currency ? this.state.Invoicedata.curconversionrate ? (1 / this.state.Invoicedata.curconversionrate) * this.state.Invoicedata.due : this.state.Invoicedata.due : this.state.Invoicedata.due}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                thousandSeparator={true}
                                                thousandsGroupStyle={thousandsdisplay}
                                                prefix={invoiceSymbol}
                                            />
                                        </span>}
                                    </div>
                                    {this.state.Invoicedata.approvestatus === "Approved" ?
                                        this.state.Invoicedata.status === "Cancelled" ?
                                            <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                <div className="tw-border-2 tw-rounded-md tw-border-red-500 tw-px-5 -tw-rotate-12">
                                                    <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                        CANCELLED
                                                    </div>
                                                </div>
                                            </div> :
                                            this.state.Invoicedata.payment === "Completed" ?
                                                <div className="tw-flex tw-justify-center mt-3 tw-items-center">
                                                    <div className="tw-border-2 tw-rounded-md tw-border-green-500 tw-px-5 -tw-rotate-12">
                                                        <div className="tw-text-green-500 tw-font-black tw-text-xl">
                                                            PAID
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                    <div className="tw-border-2 tw-rounded-md tw-border-red-500 tw-px-5 -tw-rotate-12">
                                                        <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                            PAYMENT DUE
                                                        </div>
                                                    </div>
                                                </div>
                                        : ""
                                    }
                                </div>

                                {/* Customer Details (Bill To) */}
                                <div style={this.styles.detailSection}>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}></span>
                                        <h3 style={this.styles.sectionTitle}>Bill To</h3>
                                        <h3 style={this.styles.sectionTitle}>Ship To</h3>
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Name</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.customer}
                                        </span>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null &&
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.dname}
                                            </span>}
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Address</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.custadress}
                                        </span>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null &&
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.dhouseno}, {this.state.Invoicedata.dareaname}
                                            </span>}
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>City/State</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.cityname}, {this.state.Invoicedata.state}
                                        </span>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null &&
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.dcity}, {this.state.Invoicedata.dstate}
                                            </span>}
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Country/Zip</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.country} - {this.state.Invoicedata.zip}
                                        </span>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null &&
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.dcountry} - {this.state.Invoicedata.dpincode}
                                            </span>}
                                    </div>
                                    <div style={this.styles.detailRow}>
                                        <span style={this.styles.detailLabel}>Email</span>
                                        <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.custmail}
                                        </span>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null && <span style={this.styles.detailValue}></span>}
                                    </div>
                                    <div style={{ ...this.styles.detailRow, borderBottom: 'none' }}>
                                        <span style={this.styles.detailLabel}>Phone</span>
                                        <span style={this.styles.detailValue}>
                                            +{this.state.Invoicedata.custphonecode}-{this.state.Invoicedata.custphno}
                                        </span>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null && <span style={this.styles.detailValue}>
                                            {this.state.Invoicedata.dphoneno}
                                        </span>}
                                    </div>
                                    {this.state.Invoicedata.custgstin && (
                                        <div style={this.styles.detailRow}>
                                            <span style={this.styles.detailLabel}>GSTIN</span>
                                            <span style={this.styles.detailValue}>
                                                {this.state.Invoicedata.custgstin}
                                            </span>
                                            {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null &&
                                                <span style={this.styles.detailValue}>
                                                </span>}
                                        </div>
                                    )}

                                    {this.state.Invoicedata.approvestatus === "Approved" ?
                                        this.state.Invoicedata.status === "Cancelled" ?
                                            <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                <div className="tw-border-2 tw-rounded-md tw-border-red-500 tw-px-5 -tw-rotate-12">
                                                    <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                        CANCELLED
                                                    </div>
                                                </div>
                                            </div> : this.state.Invoicedata.deliverystatus === "Completed" ?
                                                <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                    <div className="tw-border-2 tw-rounded-md tw-border-green-500 tw-px-5 -tw-rotate-12">
                                                        <div className="tw-text-green-500 tw-font-black tw-text-xl">
                                                            DELIVERED
                                                        </div>
                                                    </div>
                                                </div> :
                                                <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                    <div className="tw-border-2 tw-rounded-md tw-border-red-500 tw-px-5  -tw-rotate-12">
                                                        <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                            DELIVERY PENDING
                                                        </div>
                                                        {/* <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                            Pending
                                                        </div> */}
                                                    </div>
                                                </div> : ""
                                    }
                                </div>

                                {/* Ship To */}
                                {/* {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.sotype !== "Services" && this.state.Invoicedata.dname !== "" && this.state.Invoicedata.dname !== undefined && this.state.Invoicedata.dname !== null ? (
                                            <div style={this.styles.detailSection}>
                                                <h3 style={this.styles.sectionTitle}>Ship To</h3>
                                                <div style={this.styles.detailRow}>
                                                    <span style={this.styles.detailLabel}>Name</span>
                                                    <span style={this.styles.detailValue}>
                                                        {this.state.Invoicedata.dname}
                                                    </span>
                                                </div>
                                                <div style={this.styles.detailRow}>
                                                    <span style={this.styles.detailLabel}>Address</span>
                                                    <span style={this.styles.detailValue}>
                                                        {this.state.Invoicedata.dhouseno}, {this.state.Invoicedata.dareaname}
                                                    </span>
                                                </div>
                                                <div style={this.styles.detailRow}>
                                                    <span style={this.styles.detailLabel}>City/State</span>
                                                    <span style={this.styles.detailValue}>
                                                        {this.state.Invoicedata.dcity}, {this.state.Invoicedata.dstate}
                                                    </span>
                                                </div>
                                                <div style={this.styles.detailRow}>
                                                    <span style={this.styles.detailLabel}>Country/Zip</span>
                                                    <span style={this.styles.detailValue}>
                                                        {this.state.Invoicedata.dcountry} - {this.state.Invoicedata.dpincode}
                                                    </span>
                                                </div>
                                                <div style={{ ...this.styles.detailRow, borderBottom: 'none' }}>
                                                    <span style={this.styles.detailLabel}>Phone</span>
                                                    <span style={this.styles.detailValue}>
                                                        +{this.state.Invoicedata.dphoneno}
                                                    </span>
                                                </div>
                                                {this.state.Invoicedata.approvestatus === "Approved"?
                                                this.state.Invoicedata.status === "Cancelled"?
                                                <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                <div className="tw-border-2 tw-rounded-md tw-border-red-500 tw-px-5 -tw-rotate-12">
                                                    <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                    CANCELLED
                                                    </div>
                                                </div>
                                            </div>:this.state.Invoicedata.deliverystatus === "Completed"?
                                                <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                    <div className="tw-border-2 tw-rounded-md tw-border-green-500 tw-px-5 -tw-rotate-12">
                                                        <div className="tw-text-green-500 tw-font-black tw-text-xl">
                                                        DELIVERED
                                                        </div>
                                                    </div>
                                                </div>:
                                                    <div className="tw-flex tw-justify-center mt-5 tw-items-center">
                                                    <div className="tw-border-2 tw-rounded-md tw-border-red-500 tw-px-5  -tw-rotate-12">
                                                    <div className="tw-text-red-500 tw-font-black tw-text-xl">
                                                    DELIVERY PENDING
                                                        </div>
                                                    </div>
                                                </div>:""
                                            }
                                            </div>
                                        ) : ""} */}
                            </div>
                        </div>

                        {/* Credit Notes and Debit Notes */}
                        {this.state.creditnoteslist.length > 0 ? (
                            <div style={{ ...this.styles.detailSection, marginBottom: '15px' }}>
                                <h3 style={this.styles.sectionTitle}>Credit Notes</h3>
                                <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                    <table style={this.styles.table}>
                                        <thead style={this.styles.tableHeader}>
                                            <tr style={this.styles.tableRow}>
                                                <th style={this.styles.th}>ID</th>
                                                <th style={this.styles.th}>Type</th>
                                                <th style={this.styles.th}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.creditnoteslist.map((e, idx) => (
                                                <tr key={idx} style={this.styles.tableRow}>
                                                    <td style={{ ...this.styles.td, color: '#4d4d4d' }}>
                                                        <Link
                                                            to={{ pathname: "/customercreditnotedetails" }}
                                                            state={{
                                                                creditnote: e,
                                                                invdata: this.state.Invoicedata,
                                                                pagename: "Customer Creditnote",
                                                            }}
                                                            style={{ color: '#4d4d4d', textDecoration: 'none' }}
                                                        >
                                                            {e.customid}
                                                        </Link>
                                                    </td>
                                                    <td style={this.styles.td}>{e.type}</td>
                                                    <td style={this.styles.td}>{e.einvoicestatus}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : ""}

                        {this.state.edebitnoteslist.length > 0 ? (
                            <div style={{ ...this.styles.detailSection, marginBottom: '15px' }}>
                                <h3 style={this.styles.sectionTitle}>Debit Notes</h3>
                                <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                    <table style={this.styles.table}>
                                        <thead style={this.styles.tableHeader}>
                                            <tr style={this.styles.tableRow}>
                                                <th style={this.styles.th}>ID</th>
                                                <th style={this.styles.th}>Type</th>
                                                <th style={this.styles.th}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.edebitnoteslist.map((e, idx) => (
                                                <tr key={idx} style={this.styles.tableRow}>
                                                    <td style={{ ...this.styles.td, color: '#4d4d4d' }}>
                                                        {e.einvoicestatus !== "Pending" ? (
                                                            <Link
                                                                to={{ pathname: "/customercreditnotedetails" }}
                                                                state={{
                                                                    creditnote: e,
                                                                    invdata: this.state.Invoicedata,
                                                                    pagename: "Customer Creditnote",
                                                                }}
                                                                style={{ color: '#4d4d4d', textDecoration: 'none' }}
                                                            >
                                                                {e.customid}
                                                            </Link>
                                                        ) : e.customid}
                                                    </td>
                                                    <td style={this.styles.td}>{e.type}</td>
                                                    <td style={this.styles.td}>{e.einvoicestatus}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : ""}

                        {/* ========== PRODUCTS SECTION ========== */}
                        {this.state.activeProductDetail
                            ? this.renderProductDetailView()
                            : this.state.saleorderitems.length > 0 && (
                                <div style={{ ...this.styles.detailSectionMain, marginBottom: '15px' }}>
                                    <h3 style={this.styles.sectionTitleMain}>
                                        {productCount > 1 ? `Products` : 'Product'}
                                    </h3>
                                    <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                        <table style={this.styles.table}>
                                            <thead style={this.styles.tableHeader}>
                                                <tr style={this.styles.tableRow}>
                                                    <th style={this.styles.th}>Item Name</th>
                                                    {this.state.Invoicedata.taxtype === "NA" ? "" : <th style={this.styles.th}>HSN</th>}
                                                    <th style={this.styles.th}>Price ({invoiceSymbol})</th>
                                                    <th style={this.styles.th}>Type</th>
                                                    <th style={this.styles.th}>Qty</th>
                                                    <th style={this.styles.th}>UOM</th>
                                                    <th style={this.styles.th}>Discount ({invoiceSymbol})</th>
                                                    <th style={this.styles.th}>Total ({invoiceSymbol})</th>
                                                    {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                        <>
                                                            {this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                                <>
                                                                    <th style={this.styles.th}>CGST ({invoiceSymbol})</th>
                                                                    <th style={this.styles.th}>SGST ({invoiceSymbol})</th>
                                                                </>
                                                            ) : (
                                                                <th style={this.styles.th}>
                                                                    {this.state.Invoicedata.taxtype === "GST" ? "IGST" : "VAT"} ({invoiceSymbol})
                                                                </th>
                                                            )}
                                                        </>
                                                    )}
                                                    <th style={{ ...this.styles.th, textAlign: 'right' }}>Total with Tax ({invoiceSymbol})</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.saleorderitems.map((row, index) => {
                                                    const itemId = `product-${index}`;
                                                    const isHovered = this.state.hovered === itemId;

                                                    // Compute invoice currency values
                                                    const price_inv = row.ccprice ?? (row.price * rate);
                                                    const discount_inv = row.ccdiscountamount ?? (row.discountamount * rate);
                                                    const total_inv = row.cctotalprice ?? (row.totalprice * rate);
                                                    const tax_inv = row.cctaxamount ?? (row.taxamount * rate);
                                                    const total_wtax_inv = row.cctotalpricewtax ?? (row.totalpricewtax * rate);
                                                    const taxRate = row.tax || 0;

                                                    return (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                ...this.styles.tableRow,
                                                                ...(isHovered && this.styles.tableRowHovered)
                                                            }}
                                                            onMouseEnter={() => this.setState({ hovered: itemId })}
                                                            onMouseLeave={() => this.setState({ hovered: null })}
                                                            onClick={() => this.handleItemDetail(row, 'product')}
                                                        >
                                                            <td style={{
                                                                ...this.styles.td,
                                                                ...this.styles.itemName,
                                                                fontWeight: "bold",
                                                                color: isHovered ? '#5f8f3f' : this.styles.itemName.color,
                                                                transform: isHovered ? 'scale(1.009)' : 'scale(1)',
                                                                transition: 'color 0.03s ease, transform 0.03s ease',
                                                                minWidth: '250px',
                                                                wordBreak: "break-word",
                                                                overflowWrap: "anywhere",
                                                                whiteSpace: "pre-wrap",
                                                            }}>
                                                                <Tooltip
                                                                    title="Details"
                                                                    placement="right"
                                                                    arrow
                                                                    open={isHovered}
                                                                >
                                                                    <span>{row.name}</span>
                                                                </Tooltip>
                                                            </td>
                                                            {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                                <td style={this.styles.td}>{row.hsn}</td>
                                                            )}
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={price_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={invoiceSymbol}
                                                                />
                                                            </td>
                                                            <td style={this.styles.td}>{row.salesenum}</td>
                                                            <td style={this.styles.td}>{row.quantity}</td>
                                                            <td style={this.styles.td}>{row.uom}</td>
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={discount_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={`${invoiceSymbol}`}
                                                                />
                                                                &nbsp;({row.discount}%)
                                                            </td>
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={total_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={invoiceSymbol}
                                                                />
                                                            </td>
                                                            {
                                                                this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                                    <>
                                                                        {this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                                            <>
                                                                                <td style={this.styles.td}>
                                                                                    <NumericFormat
                                                                                        displayType={"text"}
                                                                                        value={tax_inv / 2}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        thousandSeparator={true}
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                        prefix={invoiceSymbol}
                                                                                    />
                                                                                    &nbsp;({(taxRate / 2).toFixed(2)}%)
                                                                                </td>
                                                                                <td style={this.styles.td}>
                                                                                    <NumericFormat
                                                                                        displayType={"text"}
                                                                                        value={tax_inv / 2}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        thousandSeparator={true}
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                        prefix={invoiceSymbol}
                                                                                    />
                                                                                    &nbsp;({(taxRate / 2).toFixed(2)}%)
                                                                                </td>
                                                                            </>
                                                                        ) : (
                                                                            <td style={this.styles.td}>
                                                                                <NumericFormat
                                                                                    displayType={"text"}
                                                                                    value={tax_inv}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale={true}
                                                                                    thousandSeparator={true}
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                    prefix={invoiceSymbol}
                                                                                />
                                                                                &nbsp;({taxRate}%)
                                                                            </td>
                                                                        )}
                                                                    </>
                                                                )
                                                            }
                                                            <td style={{ ...this.styles.td, textAlign: 'right', fontWeight: "bold" }}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={total_wtax_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={invoiceSymbol}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                            {productCount > 1 && (
                                                <tfoot>
                                                    <tr style={this.styles.tableRow}>
                                                        <td colSpan={productCols - 1} style={{ textAlign: 'right', fontWeight: 'bold', padding: '12px', fontSize: '0.9rem', color: '#374151' }}>
                                                            Total Products:
                                                        </td>
                                                        <td style={{ fontWeight: 'bold', textAlign: 'right', padding: '12px', fontSize: '0.9rem', color: '#000000' }}>
                                                            <NumericFormat
                                                                displayType={"text"}
                                                                value={productTotal}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                thousandSeparator={true}
                                                                thousandsGroupStyle={thousandsdisplay}
                                                                prefix={invoiceSymbol}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            )
                        }

                        {/* ========== SERVICES SECTION ========== */}
                        {this.state.activeServiceDetail
                            ? this.renderServiceDetailView()
                            : this.state.invoiceservicelist.length > 0 && (
                                <div style={{ ...this.styles.detailSectionMain, marginBottom: '15px' }}>
                                    <h3 style={this.styles.sectionTitleMain}>
                                        {serviceCount > 1 ? `All Services ` : 'Service'}
                                    </h3>
                                    <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                        <table style={this.styles.table}>
                                            <thead style={this.styles.tableHeader}>
                                                <tr style={this.styles.tableRow}>
                                                    <th style={this.styles.th}>Service Name</th>
                                                    <th style={this.styles.th}>SAC</th>
                                                    <th style={this.styles.th}>Price ({invoiceSymbol})</th>
                                                    <th style={this.styles.th}>Qty</th>
                                                    <th style={this.styles.th}>Discount (%)</th>
                                                    {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                        this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                            <>
                                                                <th style={this.styles.th}>CGST (%)</th>
                                                                <th style={this.styles.th}>SGST (%)</th>
                                                            </>
                                                        ) : (
                                                            <th style={this.styles.th}>
                                                                {this.state.Invoicedata.taxtype === "GST" ? "IGST" : "VAT"} (%)
                                                            </th>
                                                        )
                                                    )}
                                                    <th style={{ ...this.styles.th, textAlign: 'right' }}>Total with Tax ({invoiceSymbol})</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.invoiceservicelist.map((data, index) => {
                                                    const itemId = `service-${index}`;
                                                    const isHovered = this.state.hovered === itemId;

                                                    const price_inv = data.ccservicetotal ?? (data.ccservicetotal * rate);
                                                    const discount_inv = data.ccservicediscountamount ?? (data.servicediscountamount * rate);
                                                    const tax_inv = data.ccservicetaxamount ?? (data.servicetaxamt * rate);
                                                    const total_wtax_inv = data.ccservicetotalwtax ?? (data.servicetotalwtax * rate);
                                                    const qty = data.quantity || 1;
                                                    const taxRate = data.servicetax || 0;
                                                    const isIntraState = this.state.Invoicedata.taxtype === "GST" && this.state.Invoicedata.gsttype === "INTRASTATE";

                                                    return (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                ...this.styles.tableRow,
                                                                ...(isHovered && this.styles.tableRowHovered)
                                                            }}
                                                            onMouseEnter={() => this.setState({ hovered: itemId })}
                                                            onMouseLeave={() => this.setState({ hovered: null })}
                                                            onClick={() => this.handleItemDetail(data, 'service')}
                                                        >
                                                            <td style={{
                                                                ...this.styles.td,
                                                                ...this.styles.itemName,
                                                                fontWeight: "bold",
                                                                color: isHovered ? '#5f8f3f' : this.styles.itemName.color,
                                                                transform: isHovered ? 'scale(1.009)' : 'scale(1)',
                                                                transition: 'color 0.03s ease, transform 0.03s ease',
                                                                minWidth: '250px',
                                                                wordBreak: "break-word",
                                                                overflowWrap: "anywhere",
                                                                whiteSpace: "pre-wrap",
                                                            }}>
                                                                <Tooltip
                                                                    title="Details"
                                                                    placement="right"
                                                                    arrow
                                                                    open={isHovered}
                                                                >
                                                                    <span>{data.service}</span>
                                                                </Tooltip>
                                                            </td>
                                                            <td style={this.styles.td}>{data.servicecode}</td>
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={price_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={invoiceSymbol}
                                                                />
                                                            </td>
                                                            <td style={this.styles.td}>{data.quantity}</td>
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={discount_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={`${invoiceSymbol}`}
                                                                    suffix=""
                                                                />
                                                                &nbsp;({data.servicediscount}%)
                                                            </td>
                                                            {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                                isIntraState ? (
                                                                    <>
                                                                        <td style={this.styles.td}>
                                                                            <NumericFormat
                                                                                displayType={"text"}
                                                                                value={tax_inv / 2}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                thousandSeparator={true}
                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                                prefix={invoiceSymbol}
                                                                            />
                                                                            &nbsp;({(taxRate / 2).toFixed(2)}%)
                                                                        </td>
                                                                        <td style={this.styles.td}>
                                                                            <NumericFormat
                                                                                displayType={"text"}
                                                                                value={tax_inv / 2}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                thousandSeparator={true}
                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                                prefix={invoiceSymbol}
                                                                            />
                                                                            &nbsp;({(taxRate / 2).toFixed(2)}%)
                                                                        </td>
                                                                    </>
                                                                ) : (
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={tax_inv}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                            prefix={invoiceSymbol}
                                                                        />
                                                                        &nbsp;({taxRate}%)
                                                                    </td>
                                                                )
                                                            )}
                                                            <td style={{ ...this.styles.td, fontWeight: "bold", textAlign: 'right' }}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={total_wtax_inv}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                    prefix={invoiceSymbol}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                            {serviceCount > 0 && (
                                                <tfoot>
                                                    <tr style={this.styles.tableRow}>
                                                        <td colSpan={serviceCols - 1} style={{ textAlign: 'right', fontWeight: 'bold', padding: '12px', fontSize: '0.9rem', color: '#374151' }}>
                                                            Total Services:
                                                        </td>
                                                        <td style={{ fontWeight: 'bold', textAlign: 'right', padding: '12px', fontSize: '0.9rem', color: '#000000' }}>
                                                            <NumericFormat
                                                                displayType={"text"}
                                                                value={serviceTotal}
                                                                decimalScale={2}
                                                                fixedDecimalScale={true}
                                                                thousandSeparator={true}
                                                                thousandsGroupStyle={thousandsdisplay}
                                                                prefix={invoiceSymbol}
                                                            />
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            )}
                                        </table>
                                    </div>
                                </div>
                            )
                        }

                        {/* ========== ADDITIONAL CHARGES / INSURANCE ========== */}
                        {(this.state.additionalchareslist.length > 0 || this.state.Invoicedata.insurancereq) && (
                            <div style={{ ...this.styles.detailSectionMain, borderBottom: 'none', marginBottom: '15px' }}>
                                <h3 style={this.styles.sectionTitleMain}>Additional Charges / Insurance</h3>
                                <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                    <table style={this.styles.table}>
                                        <thead style={this.styles.tableHeader}>
                                            <tr style={this.styles.tableRow}>
                                                <th style={this.styles.th}>Nature of charge</th>
                                                <th style={this.styles.th}>Additional charge</th>
                                                {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                    this.state.Invoicedata.taxtype === "GST" ? (
                                                        this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                            <>
                                                                <th style={this.styles.th}>CGST ({invoiceSymbol})</th>
                                                                <th style={this.styles.th}>SGST ({invoiceSymbol})</th>
                                                            </>
                                                        ) : (
                                                            <th style={this.styles.th}>IGST ({invoiceSymbol})</th>
                                                        )
                                                    ) : (
                                                        <th style={this.styles.th}>VAT ({invoiceSymbol})</th>
                                                    )
                                                )}
                                                <th style={{ ...this.styles.th, textAlign: 'right' }}>Additional charge Inc Tax</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.additionalchareslist.map((e, i) => (
                                                <tr key={i} style={this.styles.tableRow}>
                                                    <td style={this.styles.td}>{e.natureofcharge}</td>
                                                    <td style={this.styles.td}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={e.ccadditionalcharges ?? e.additionalcharges}
                                                            prefix={invoiceSymbol}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            disabled={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                        />
                                                    </td>
                                                    {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                        this.state.Invoicedata.taxtype === "GST" ? (
                                                            this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                                <>
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={(e.ccadditionalchargestaxamount ?? (e.additionalchargestaxamount * rate)) / 2}
                                                                            prefix={invoiceSymbol}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                        />
                                                                        &nbsp;({((e.ccadditionalchargestax ?? e.additionalchargestax) / 2).toFixed(2)}%)
                                                                    </td>
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={(e.ccadditionalchargestaxamount ?? (e.additionalchargestaxamount * rate)) / 2}
                                                                            prefix={invoiceSymbol}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                        />
                                                                        &nbsp;({((e.ccadditionalchargestax ?? e.additionalchargestax) / 2).toFixed(2)}%)
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <td style={this.styles.td}>
                                                                    <NumericFormat
                                                                        displayType={"text"}
                                                                        value={e.ccadditionalchargestaxamount ?? (e.additionalchargestaxamount * rate)}
                                                                        prefix={invoiceSymbol}
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        disabled={true}
                                                                        thousandSeparator={true}
                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                    />
                                                                    &nbsp;({(e.ccadditionalchargestax ?? e.additionalchargestax).toFixed(2)}%)
                                                                </td>
                                                            )
                                                        ) : (
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={e.ccadditionalchargestaxamount ?? (e.additionalchargestaxamount * rate)}
                                                                    prefix={invoiceSymbol}
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    disabled={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                />
                                                                &nbsp;({(e.ccadditionalchargestax ?? e.additionalchargestax).toFixed(2)}%)
                                                            </td>
                                                        )
                                                    )}
                                                    <td style={{ ...this.styles.td, textAlign: 'right' }}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={e.cctotaladditionalcharges ?? e.totaladditionalcharges}
                                                            decimalScale={2}
                                                            prefix={invoiceSymbol}
                                                            fixedDecimalScale={true}
                                                            disabled={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            {this.state.Invoicedata.insurancereq ? (
                                                <tr style={this.styles.tableRow}>
                                                    <td style={this.styles.td}>Insurance</td>
                                                    <td style={this.styles.td}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={insuranceAmountConverted}
                                                            decimalScale={2}
                                                            prefix={invoiceSymbol}
                                                            fixedDecimalScale={true}
                                                            disabled={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                        />
                                                    </td>
                                                    {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                        this.state.Invoicedata.taxtype === "GST" ? (
                                                            this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                                <>
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={insuranceTaxAmount / 2}
                                                                            decimalScale={2}
                                                                            prefix={invoiceSymbol}
                                                                            fixedDecimalScale={true}
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                        />
                                                                        &nbsp;({(this.state.Invoicedata.insurancetax / 2).toFixed(2)}%)
                                                                    </td>
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={insuranceTaxAmount / 2}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={invoiceSymbol}
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                        />
                                                                        &nbsp;({(this.state.Invoicedata.insurancetax / 2).toFixed(2)}%)
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <td style={this.styles.td}>
                                                                    <NumericFormat
                                                                        displayType={"text"}
                                                                        value={insuranceTaxAmount}
                                                                        decimalScale={2}
                                                                        prefix={invoiceSymbol}
                                                                        fixedDecimalScale={true}
                                                                        disabled={true}
                                                                        thousandSeparator={true}
                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                    />
                                                                    &nbsp;({this.state.Invoicedata.insurancetax.toFixed(2)}%)
                                                                </td>
                                                            )
                                                        ) : (
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={insuranceTaxAmount}
                                                                    decimalScale={2}
                                                                    prefix={invoiceSymbol}
                                                                    fixedDecimalScale={true}
                                                                    disabled={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                />
                                                                &nbsp;({this.state.Invoicedata.insurancetax.toFixed(2)}%)
                                                            </td>
                                                        )
                                                    )}
                                                    <td style={{ ...this.styles.td, textAlign: 'right' }}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={this.state.Invoicedata.cctotalinsurance ?? this.state.Invoicedata.totalinsurance}
                                                            prefix={invoiceSymbol}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            disabled={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                        />
                                                    </td>
                                                </tr>
                                            ) : ""}
                                            {this.state.Invoicedata.tcsreq && tcsAmount > 0 ? (
                                                <tr style={this.styles.tableRow}>
                                                    <td style={this.styles.td}>TCS</td>
                                                    <td style={this.styles.td}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={this.state.Invoicedata.cctcsableamount ?? this.state.Invoicedata.tcsableamount}
                                                            decimalScale={2}
                                                            prefix={invoiceSymbol}
                                                            fixedDecimalScale={true}
                                                            disabled={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                        />
                                                    </td>
                                                    {this.state.Invoicedata.taxtype === "NA" ? "" : (
                                                        this.state.Invoicedata.taxtype === "GST" ? (
                                                            this.state.Invoicedata.gsttype === "INTRASTATE" ? (
                                                                <>
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={tcsAmount / 2}
                                                                            decimalScale={2}
                                                                            prefix={invoiceSymbol}
                                                                            fixedDecimalScale={true}
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                        />
                                                                        &nbsp;({(this.state.Invoicedata.tcs / 2).toFixed(2)}%)
                                                                    </td>
                                                                    <td style={this.styles.td}>
                                                                        <NumericFormat
                                                                            displayType={"text"}
                                                                            value={tcsAmount / 2}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={invoiceSymbol}
                                                                            disabled={true}
                                                                            thousandSeparator={true}
                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                        />
                                                                        &nbsp;({(this.state.Invoicedata.tcs / 2).toFixed(2)}%)
                                                                    </td>
                                                                </>
                                                            ) : (
                                                                <td style={this.styles.td}>
                                                                    <NumericFormat
                                                                        displayType={"text"}
                                                                        value={tcsAmount}
                                                                        decimalScale={2}
                                                                        prefix={invoiceSymbol}
                                                                        fixedDecimalScale={true}
                                                                        disabled={true}
                                                                        thousandSeparator={true}
                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                    />
                                                                    &nbsp;({parseFloat(this.state.Invoicedata.tcs || 0).toFixed(2)}%)
                                                                </td>
                                                            )
                                                        ) : (
                                                            <td style={this.styles.td}>
                                                                <NumericFormat
                                                                    displayType={"text"}
                                                                    value={tcsAmount}
                                                                    decimalScale={2}
                                                                    prefix={invoiceSymbol}
                                                                    fixedDecimalScale={true}
                                                                    disabled={true}
                                                                    thousandSeparator={true}
                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                />
                                                                &nbsp;({parseFloat(this.state.Invoicedata.tcs || 0).toFixed(2)}%)
                                                            </td>
                                                        )
                                                    )}
                                                    <td style={{ ...this.styles.td, textAlign: 'right' }}>
                                                        <NumericFormat
                                                            displayType={"text"}
                                                            value={tcsAmount}
                                                            prefix={invoiceSymbol}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            disabled={true}
                                                            thousandSeparator={true}
                                                            thousandsGroupStyle={thousandsdisplay}
                                                        />
                                                    </td>
                                                </tr>
                                            ) : ""}
                                        </tbody>
                                        <tfoot>
                                            <tr style={this.styles.tableRow}>
                                                <td colSpan={additionalChargesCols - 1} style={{ textAlign: 'right', fontWeight: 'bold', padding: '12px', fontSize: '0.9rem', color: '#374151' }}>
                                                    Total Additional Charges:
                                                </td>
                                                <td style={{ fontWeight: 'bold', textAlign: 'right', padding: '12px', fontSize: '0.9rem', color: '#000000' }}>
                                                    <NumericFormat
                                                        displayType={"text"}
                                                        value={(this.state.Invoicedata.cctotaladditionalchares ?? this.state.Invoicedata.totaladditionalchares) + (this.state.Invoicedata.cctotalinsurance ?? this.state.Invoicedata.totalinsurance)}
                                                        decimalScale={2}
                                                        prefix={invoiceSymbol}
                                                        fixedDecimalScale={true}
                                                        disabled={true}
                                                        thousandSeparator={true}
                                                        thousandsGroupStyle={thousandsdisplay}
                                                    />
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Transportation Details */}
                        {this.state.pagename === "Tax Invoice Details" &&
                            (this.state.Invoicedata.samedaydelivery === "True" || this.state.Invoicedata.ewaybillstatus !== "Pending") &&
                            this.state.Invoicedata.sotype !== "Services" ? (
                            <div style={{ ...this.styles.detailSectionMain, borderBottom: 'none', marginBottom: '15px' }}>
                                <h3 style={this.styles.sectionTitleMain}>Transportation Details</h3>
                                <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                    <table style={this.styles.table}>
                                        <thead style={this.styles.tableHeader}>
                                            <tr style={this.styles.tableRow}>
                                                <th style={this.styles.th}>Transporter Name</th>
                                                <th style={this.styles.th}>Transporter Id</th>
                                                <th style={this.styles.th}>Vehicle No.</th>
                                                <th style={this.styles.th}>Approximate Distance(Km)</th>
                                                <th style={this.styles.th}>Vehicle Type</th>
                                                <th style={this.styles.th}>Transaction Type</th>
                                                <th style={this.styles.th}>Transportation Mode</th>
                                                <th style={this.styles.th}>Supply Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={this.styles.tableRow}>
                                                <td style={this.styles.td}>{this.state.transportername}</td>
                                                <td style={this.styles.td}>{this.state.Invoicedata.transporterid}</td>
                                                <td style={this.styles.td}>{this.state.Invoicedata.vehiclenum}</td>
                                                <td style={this.styles.td}>{this.state.Invoicedata.distance}</td>
                                                <td style={this.styles.td}>
                                                    {this.state.Invoicedata.vehicletype === "R" ? "Regular" : "ODC"}
                                                </td>
                                                <td style={this.styles.td}>{this.state.Invoicedata.transactiontype}</td>
                                                <td style={this.styles.td}>{this.state.Invoicedata.transportationmode}</td>
                                                <td style={this.styles.td}>
                                                    {this.state.Invoicedata.supplytype === "I" ? "Inward" : "Outward"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : ""}

                        {/* Updated Transportation Details */}
                        {this.state.einvoicedata !== undefined && this.state.einvoicedata !== "" && this.state.einvoicedata !== null && this.state.Invoicedata.updtvehiclenum !== null ? (
                            <div style={{ ...this.styles.detailSectionMain, borderBottom: 'none', marginBottom: '15px' }}>
                                <h3 style={this.styles.sectionTitleMain}>Updated Transportation Details</h3>
                                <div style={{ ...this.styles.tableContainer, border: '1px solid #e2e8f0', borderRadius: '8px' }}>
                                    <table style={this.styles.table}>
                                        <thead style={this.styles.tableHeader}>
                                            <tr style={this.styles.tableRow}>
                                                <th style={this.styles.th}>From</th>
                                                <th style={this.styles.th}>Vehicle No.</th>
                                                <th style={this.styles.th}>Vehicle Type</th>
                                                <th style={this.styles.th}>Transaction Type</th>
                                                <th style={this.styles.th}>Transportation Mode</th>
                                                <th style={this.styles.th}>Supply Type</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style={this.styles.tableRow}>
                                                <td style={this.styles.td}>{this.state.einvoicedata.invoice.updtfrom}</td>
                                                <td style={this.styles.td}>{this.state.einvoicedata.invoice.updtvehiclenum}</td>
                                                <td style={this.styles.td}>
                                                    {this.state.einvoicedata.invoice.updtvehicletype === "R" ? "Regular" : "ODC"}
                                                </td>
                                                <td style={this.styles.td}>{this.state.einvoicedata.invoice.transactiontype}</td>
                                                <td style={this.styles.td}>{this.state.einvoicedata.invoice.updttransportationmode}</td>
                                                <td style={this.styles.td}>
                                                    {this.state.einvoicedata.invoice.supplytype === "I" ? "Inward" : "Outward"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : ""}

                        {/* Remarks */}
                        <div style={{ ...this.styles.detailSectionMain, borderBottom: 'none', marginBottom: '15px' }}>
                            <h3 style={this.styles.sectionTitleMain}>Remarks</h3>
                            <div style={{ padding: '12px', backgroundColor: '#ffffff', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                                <span style={this.styles.detailValue}>{this.state.Invoicedata.invoiceremarks || "No remarks"}</span>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        {!isCancelled && (
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '15px' }}>
                                {salesid === "3" || salesid === "2" ? (
                                    <>
                                        {this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.approvestatus === "Approved" && this.state.Invoicedata.ledgerentry === "Pending" && this.state.Invoicedata.autojre === "TRUE" && !this.state.Invoicedata.openadjusted && !this.state.Invoicedata.debitadjusted ?
                                            <button
                                                style={{
                                                    ...this.styles.btn,
                                                    ...this.styles.btnOutline,
                                                    backgroundColor: this.state.hoveredBtn === "journal" ? "#4d4d4d" : "#ffffff",
                                                    color: this.state.hoveredBtn === "journal" ? "#ffffff" : "#4d4d4d",
                                                    transition: "all 0.01s ease",
                                                }}
                                                onClick={() => this.handleJournalEntry()}
                                                onMouseEnter={() => this.setState({ hoveredBtn: "journal" })}
                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                            >
                                                <i className="fa fa-check m-0" /> JournalEntry
                                            </button> : ""}

                                        {this.state.pagename === "Tax Invoice Details" ? (
                                            <>
                                                {this.state.Invoicedata.approvestatus !== "Approved" || this.state.Invoicedata.einvoicestatus === "Pending" ? (
                                                    this.state.Invoicedata.einvid === null ? (
                                                        <>
                                                            {this.state.Invoicedata.approvestatus === "Pending" ? (
                                                                <>
                                                                    {salesid === "3" ? (
                                                                        <button
                                                                            style={{
                                                                                ...this.styles.btn,
                                                                                ...this.styles.btnPrimary,
                                                                                backgroundColor: this.state.hoveredBtn === "approve" ? "#1f2937" : "#4d4d4d",
                                                                                transform: this.state.hoveredBtn === "approve" ? "scale(1.03)" : "scale(1)",
                                                                                transition: "all 0.01s ease",
                                                                            }}
                                                                            onClick={() => this.handleApprove(0)}
                                                                            onMouseEnter={() => this.setState({ hoveredBtn: "approve" })}
                                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                        >
                                                                            <i className="fa fa-check m-0" /> Approve
                                                                        </button>
                                                                    ) : ""}

                                                                    {this.state.pagename !== "Tax Invoice Details" ? "" : (
                                                                        <button
                                                                            style={{
                                                                                ...this.styles.btn,
                                                                                backgroundColor: this.state.hoveredBtn === "revise" ? "#d97706" : "#f59e0b",
                                                                                color: '#ffffff',
                                                                                transform: this.state.hoveredBtn === "revise" ? "scale(1.03)" : "scale(1)",
                                                                                transition: "all 0.01s ease",
                                                                            }}
                                                                            onClick={() => this.handleApprove(1)}
                                                                            onMouseEnter={() => this.setState({ hoveredBtn: "revise" })}
                                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                        >
                                                                            <i className="fa fa-rotate-right m-0" /> Revise Invoice
                                                                        </button>
                                                                    )}
                                                                </>
                                                            ) : this.state.pagename === "Tax Invoice Details" ? (
                                                                <Link
                                                                    style={{
                                                                        ...this.styles.btn,
                                                                        ...this.styles.btnOutline,
                                                                        backgroundColor: this.state.hoveredBtn === "edit" ? "#4d4d4d" : "#ffffff",
                                                                        color: this.state.hoveredBtn === "edit" ? "#ffffff" : "#4d4d4d",
                                                                        transform: this.state.hoveredBtn === "edit" ? "scale(1.03)" : "scale(1)",
                                                                        transition: "all 0.01s ease",
                                                                    }}
                                                                    to={{ pathname: "/newsalesinvoice" }}
                                                                    state={{
                                                                        id: this.state.Invoicedata.invid,
                                                                        pagename: "Edit Invoice",
                                                                    }}
                                                                    onMouseEnter={() => this.setState({ hoveredBtn: "edit" })}
                                                                    onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                >
                                                                    <i className="fa fa-edit"></i> Edit Invoice
                                                                </Link>
                                                            ) : ""}
                                                            <button
                                                                style={{
                                                                    ...this.styles.btn,
                                                                    ...this.styles.btnDanger,
                                                                    ...(this.state.hoveredBtn === "delete" ? this.styles.hoveredBtnDanger : {})
                                                                }}
                                                                onClick={this.handleDeleteInvoice}
                                                                onMouseEnter={() => this.setState({ hoveredBtn: "delete" })}
                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                            >
                                                                <i className="fa fa-times m-0" /> Delete Invoice
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <button
                                                            style={{
                                                                ...this.styles.btn,
                                                                ...this.styles.btnPrimary,
                                                                backgroundColor: this.state.hoveredBtn === "fetch" ? "#1f2937" : "#4d4d4d",
                                                                transform: this.state.hoveredBtn === "fetch" ? "scale(1.03)" : "scale(1)",
                                                                transition: "all 0.01s ease",
                                                            }}
                                                            onClick={this.Featcheinvoice}
                                                            onMouseEnter={() => this.setState({ hoveredBtn: "fetch" })}
                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                        >
                                                            <i className="fas fa-file-invoice m-0"></i> Fetch E-invoice
                                                        </button>
                                                    )
                                                ) : this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.status === "Processing" && this.state.Invoicedata.deliverystatus === "Pending" ? (
                                                    <>
                                                        {/* Generate E-way Bill Button */}
                                                        {(this.state.Invoicedata.ewaybillstatus === "Pending" ||
                                                            this.state.Invoicedata.ewaybillstatus === "Cancelled") &&
                                                            (this.state.Invoicedata.einvoicestatus === "Generated" ||
                                                                this.state.Invoicedata.einvoicestatus === "NA") ? (
                                                            <button
                                                                style={{
                                                                    ...this.styles.btn,
                                                                    ...(this.state.hoveredBtn === "ewaybill" ? this.styles.btnPrimary : this.styles.btnOutline),
                                                                }}
                                                                onClick={() => this.setState({ showfields: true })}
                                                                onMouseEnter={() => this.setState({ hoveredBtn: "ewaybill" })}
                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                            >
                                                                <i className="fas fa-file-invoice" style={{ margin: 0 }}></i>
                                                                Generate E-way bill
                                                            </button>
                                                        ) : this.state.Invoicedata.ewaybillstatus === "Generated" &&
                                                            this.state.ewaybilldata.ewbno !== null &&
                                                            this.state.ewaybilldata.ewbno !== undefined ? (
                                                            <>
                                                                {this.state.showtrans ? "" : (
                                                                    <>
                                                                        {/* Extend E-way Bill Button */}
                                                                        {moment().isAfter(moment(this.state.ewaybilldata.ewbvalidtill).subtract(8, "hours")) &&
                                                                            moment().isBefore(moment(this.state.ewaybilldata.ewbvalidtill).add(8, "hours")) ? (
                                                                            <button
                                                                                style={{
                                                                                    ...this.styles.btn,
                                                                                    ...(this.state.hoveredBtn === "extend" ? this.styles.btnPrimary : this.styles.btnOutline),
                                                                                }}
                                                                                onClick={this.handleshowEWBExtnOpen}
                                                                                onMouseEnter={() => this.setState({ hoveredBtn: "extend" })}
                                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                            >
                                                                                <i className="fas fa-file-invoice" style={{ margin: 0 }}></i>
                                                                                Extend E-way bill
                                                                            </button>
                                                                        ) : ""}

                                                                        {/* Change Vehicle Button */}
                                                                        <button
                                                                            style={{
                                                                                ...this.styles.btn,
                                                                                ...(this.state.hoveredBtn === "changeVehicle" ? this.styles.btnPrimary : this.styles.btnOutline),
                                                                            }}
                                                                            onClick={this.handleshowChgVel}
                                                                            onMouseEnter={() => this.setState({ hoveredBtn: "changeVehicle" })}
                                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                        >
                                                                            <i className="fas fa-truck" style={{ margin: 0 }}></i>
                                                                            Change Vehicle
                                                                        </button>

                                                                        {/* Update Transporter Button */}
                                                                        <button
                                                                            style={{
                                                                                ...this.styles.btn,
                                                                                ...(this.state.hoveredBtn === "updateTransporter" ? this.styles.btnPrimary : this.styles.btnOutline),
                                                                            }}
                                                                            onClick={this.handleshowchangeTRNS}
                                                                            onMouseEnter={() => this.setState({ hoveredBtn: "updateTransporter" })}
                                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                        >
                                                                            <i className="fa fa-truck-moving" style={{ margin: 0 }}></i>
                                                                            Update Transporter
                                                                        </button>

                                                                        {/* Terminate E-way Bill Button */}
                                                                        <button
                                                                            style={{
                                                                                ...this.styles.btn,
                                                                                ...(this.state.hoveredBtn === "terminateEwaybill" ? this.styles.hoveredBtnDanger : this.styles.btnDanger),
                                                                            }}
                                                                            onClick={this.handleTerminateEwaybill}
                                                                            onMouseEnter={() => this.setState({ hoveredBtn: "terminateEwaybill" })}
                                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                                        >
                                                                            <i className="fa fa-times" style={{ margin: 0 }}></i>
                                                                            Terminate/Cancel E-way bill
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </>
                                                        ) : ""}

                                                        {/* Terminate E-invoice Button */}
                                                        {this.state.Invoicedata.einvoicestatus === "Generated" &&
                                                            (this.state.Invoicedata.ewaybillstatus === "Pending" ||
                                                                this.state.Invoicedata.ewaybillstatus === "Cancelled") &&
                                                            moment().isBefore(moment(this.state.einvoicedata.ackDt).add(1, "d")) ? (
                                                            <button
                                                                style={{
                                                                    ...this.styles.btn,
                                                                    ...(this.state.hoveredBtn === "terminateEinvoice" ? this.styles.hoveredBtnDanger : this.styles.btnDanger),
                                                                }}
                                                                onClick={this.handleTerminateEInvoice}
                                                                onMouseEnter={() => this.setState({ hoveredBtn: "terminateEinvoice" })}
                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                            >
                                                                <i className="fa fa-times" style={{ margin: 0 }}></i>
                                                                Terminate/Cancel E-invoice
                                                            </button>
                                                        ) : ""}

                                                        {/* Terminate Invoice Button */}
                                                        {this.state.Invoicedata.payment === "Pending" &&
                                                            (this.state.Invoicedata.einvoicestatus === "Cancelled" ||
                                                                this.state.Invoicedata.einvoicestatus === "NA") ? (
                                                            <button
                                                                style={{
                                                                    ...this.styles.btn,
                                                                    ...(this.state.hoveredBtn === "terminateInvoice" ? this.styles.hoveredBtnDanger : this.styles.btnDanger),
                                                                }}
                                                                onClick={this.handleTerminateInvoice}
                                                                onMouseEnter={() => this.setState({ hoveredBtn: "terminateInvoice" })}
                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                            >
                                                                <i className="fa fa-times" style={{ margin: 0 }}></i>
                                                                Terminate/Cancel Invoice
                                                            </button>
                                                        ) : ""}
                                                    </>

                                                ) : ""}
                                            </>
                                        ) : (
                                            <>
                                                {this.state.Invoicedata.approvestatus === "Pending" ? (
                                                    <>
                                                        {salesid === "3" ? (
                                                            <button
                                                                style={{
                                                                    ...this.styles.btn,
                                                                    ...this.styles.btnPrimary,
                                                                    backgroundColor: this.state.hoveredBtn === "approve" ? "#1f2937" : "#4d4d4d",
                                                                    transform: this.state.hoveredBtn === "approve" ? "scale(1.03)" : "scale(1)",
                                                                    transition: "all 0.01s ease",
                                                                }}
                                                                onClick={() => this.handleApprove(0)}
                                                                onMouseEnter={() => this.setState({ hoveredBtn: "approve" })}
                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                            >
                                                                <i className="fa fa-check m-0" /> Approve
                                                            </button>
                                                        ) : ""}
                                                        <button
                                                            style={{
                                                                ...this.styles.btn,
                                                                ...this.styles.btnDanger,
                                                                ...(this.state.hoveredBtn === "delete" ? this.styles.hoveredBtnDanger : {})
                                                            }}
                                                            onClick={this.handleDeleteInvoice}
                                                            onMouseEnter={() => this.setState({ hoveredBtn: "delete" })}
                                                            onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                        >
                                                            <i className="fa fa-times m-0" /> Delete Invoice
                                                        </button>

                                                        {this.state.Invoicedata.sotype === "Services" || this.state.pagename !== "Tax Invoice Details" ? "" : (
                                                            <button
                                                                style={{
                                                                    ...this.styles.btn,
                                                                    backgroundColor: this.state.hoveredBtn === "revise" ? "#d97706" : "#f59e0b",
                                                                    color: '#ffffff',
                                                                    transform: this.state.hoveredBtn === "revise" ? "scale(1.03)" : "scale(1)",
                                                                    transition: "all 0.01s ease",
                                                                }}
                                                                onClick={() => this.handleApprove(1)}
                                                                onMouseEnter={() => this.setState({ hoveredBtn: "revise" })}
                                                                onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                            >
                                                                <i className="fa fa-rotate-right m-0" /> Revise Invoice
                                                            </button>
                                                        )}
                                                    </>
                                                ) : this.state.pagename === "Tax Invoice Details" ? (
                                                    <Link
                                                        style={{
                                                            ...this.styles.btn,
                                                            ...this.styles.btnOutline,
                                                            backgroundColor: this.state.hoveredBtn === "edit" ? "#4d4d4d" : "#ffffff",
                                                            color: this.state.hoveredBtn === "edit" ? "#ffffff" : "#4d4d4d",
                                                            transform: this.state.hoveredBtn === "edit" ? "scale(1.03)" : "scale(1)",
                                                            transition: "all 0.01s ease",
                                                        }}
                                                        to={{ pathname: "/newsalesinvoice" }}
                                                        state={{
                                                            id: this.state.Invoicedata.invid,
                                                            pagename: "New Invoice",
                                                        }}
                                                        onMouseEnter={() => this.setState({ hoveredBtn: "edit" })}
                                                        onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                    >
                                                        <i className="fa fa-edit"></i> Edit Invoice
                                                    </Link>
                                                ) : ""}
                                            </>
                                        )}

                                        {(this.state.Invoicedata.einvoicestatus === "NA" || this.state.Invoicedata.einvoicestatus === "Generated") && this.state.pagename === "Tax Invoice Details" && this.state.Invoicedata.approvestatus === "Approved" && this.state.Invoicedata.payment !== "Pending" ? (
                                            <>
                                                <Link
                                                    style={{
                                                        ...this.styles.btn,
                                                        ...this.styles.btnPrimary,
                                                        backgroundColor: this.state.hoveredBtn === "creditNote" ? "#1f2937" : "#4d4d4d",
                                                        transform: this.state.hoveredBtn === "creditNote" ? "scale(1.03)" : "scale(1)",
                                                        transition: "all 0.01s ease",
                                                    }}
                                                    to={{ pathname: "/customercreditnote" }}
                                                    state={{
                                                        id: this.state.Invoicedata.invid,
                                                        customer: this.state.Invoicedata.customer,
                                                        custid: this.state.Invoicedata.custid,
                                                        cnlist: this.state.creditnoteslist.filter((e) => e.ackno === null || e.ackno === undefined),
                                                        invdata: this.state.Invoicedata,
                                                        pagename: "Customer Creditnote",
                                                    }}
                                                    onMouseEnter={() => this.setState({ hoveredBtn: "creditNote" })}
                                                    onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                >
                                                    New Credit Note
                                                </Link>

                                                <Link
                                                    style={{
                                                        ...this.styles.btn,
                                                        ...this.styles.btnPrimary,
                                                        backgroundColor: this.state.hoveredBtn === "debitNote" ? "#1f2937" : "#4d4d4d",
                                                        transform: this.state.hoveredBtn === "debitNote" ? "scale(1.03)" : "scale(1)",
                                                        transition: "all 0.01s ease",
                                                    }}
                                                    to={{ pathname: "/customerdebitnote" }}
                                                    state={{
                                                        id: this.state.Invoicedata.invid,
                                                        customer: this.state.Invoicedata.customer,
                                                        custid: this.state.Invoicedata.custid,
                                                        invdata: this.state.Invoicedata,
                                                        pagename: "Customer Debitnote",
                                                    }}
                                                    onMouseEnter={() => this.setState({ hoveredBtn: "debitNote" })}
                                                    onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                                >
                                                    New Debit Note
                                                </Link>
                                            </>
                                        ) : ""}
                                    </>
                                ) : ""}

                                {this.state.Invoicedata.due < 0.09 && this.state.Invoicedata.due !== 0 ? (
                                    <button
                                        style={{
                                            ...this.styles.btn,
                                            backgroundColor: this.state.hoveredBtn === "close" ? "#d97706" : "#f59e0b",
                                            color: '#ffffff',
                                            transform: this.state.hoveredBtn === "close" ? "scale(1.03)" : "scale(1)",
                                            transition: "all 0.01s ease",
                                        }}
                                        onClick={() => this.handleCloseInvoice()}
                                        onMouseEnter={() => this.setState({ hoveredBtn: "close" })}
                                        onMouseLeave={() => this.setState({ hoveredBtn: null })}
                                    >
                                        Close Invoice
                                    </button>
                                ) : ""}
                            </div>
                        )}

                        {/* Cancellation Messages */}
                        {this.state.Invoicedata.canceldesc !== null && this.state.Invoicedata.canceldesc !== undefined && this.state.Invoicedata.canceldesc !== "" ? (
                            <div style={{
                                padding: '12px',
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                borderRadius: '6px',
                                marginBottom: '16px'
                            }}>
                                <span style={{ color: '#dc2626', fontWeight: '500' }}>
                                    Reason for invoice cancellation: {this.state.Invoicedata.canceldesc}
                                </span>
                            </div>
                        ) : ""}

                        {this.state.Invoicedata.remarks !== null && this.state.Invoicedata.remarks !== undefined && this.state.Invoicedata.remarks !== "" ? (
                            <div style={{
                                padding: '12px',
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                borderRadius: '6px',
                                marginBottom: '16px'
                            }}>
                                <span style={{ color: '#dc2626', fontWeight: '500' }}>
                                    Reason for E-invoice cancellation: {this.state.Invoicedata.remarks}
                                </span>
                            </div>
                        ) : ""}
                    </div>
                )
                }

                {/* Updated Modal with new design */}
                <Modal
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop={true}
                    keyboard={true}
                    centered
                    size="lg"
                >
                    <div style={this.styles.modalHeader}>
                        <h5 style={this.styles.modalTitle}>Send Email</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={this.handleClose}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer'
                            }}
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>

                    <div style={this.styles.modalBody}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <label htmlFor="btn-upload" style={{ margin: 0 }}>
                                    <input
                                        className="btn-choose"
                                        id="btn-upload"
                                        name="btn-upload"
                                        style={{ display: "none" }}
                                        type="file"
                                        onChange={this.selectFile}
                                    />
                                    <Button
                                        variant="outlined"
                                        component="span"
                                        style={{
                                            borderColor: '#4d4d4d',
                                            color: '#4d4d4d',
                                            textTransform: 'none'
                                        }}
                                    >
                                        Select File to Upload
                                    </Button>
                                </label>

                                <div style={{ flex: 1 }}>
                                    {selectedFiles && selectedFiles.length > 0 ? (
                                        <div style={{
                                            padding: '8px 12px',
                                            backgroundColor: '#f8fafc',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '4px',
                                            fontSize: '0.8rem'
                                        }}>
                                            {selectedFiles[0].name}
                                        </div>
                                    ) : null}
                                </div>

                                <Button
                                    color="primary"
                                    variant="contained"
                                    component="span"
                                    disabled={!selectedFiles}
                                    onClick={this.upload}
                                    style={{
                                        backgroundColor: '#4d4d4d',
                                        textTransform: 'none'
                                    }}
                                >
                                    Upload
                                </Button>
                            </div>

                            {message && (
                                <div style={{
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    fontSize: '0.8rem',
                                    backgroundColor: isError ? '#fef2f2' : '#f0fdf4',
                                    border: `1px solid ${isError ? '#fecaca' : '#bbf7d0'}`,
                                    color: isError ? '#dc2626' : '#16a34a'
                                }}>
                                    {message}
                                </div>
                            )}

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                                <button
                                    style={{
                                        ...this.styles.btn,
                                        ...this.styles.btnOutline
                                    }}
                                    onClick={this.handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    style={{
                                        ...this.styles.btn,
                                        ...this.styles.btnPrimary
                                    }}
                                    onClick={this.handleSendMail}
                                >
                                    Send <i className="fa fa-paper-plane ml-1" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* E-way bill modal with updated design */}
                <Modal
                    show={this.state.showfields}
                    onHide={this.handleEwaybillClose}
                    backdrop={true}
                    keyboard={true}
                    centered
                    size="lg"
                >
                    <div
                        style={{
                            ...this.styles.modalHeader,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "12px 20px",
                            borderBottom: "1px solid #ddd",
                        }}
                    >
                        <h5 style={{ ...this.styles.modalTitle, margin: 0 }}>Transportation Details</h5>
                        <button
                            type="button"
                            className="close"
                            onClick={this.handleEwaybillClose}
                            style={{
                                backgroundColor: 'transparent',
                                border: "none",
                                fontSize: "1.5rem",
                                cursor: "pointer",
                                lineHeight: 1,
                            }}
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>

                    <div style={this.styles.modalBody}>
                        <Formik
                            initialValues={{ transporterid }}
                            validateOnChange={false}
                            validate={this.validate}
                            onSubmit={this.onSubmit}
                            enableReinitialize={true}
                        >
                            {({ setFieldValue, values }) => (
                                <Form>
                                    {/* Transportation Fields */}
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            gap: "16px",
                                            marginBottom: "16px",
                                        }}
                                    >
                                        <TextField
                                            type="text"
                                            name="vehiclenum"
                                            label="Vehicle No."
                                            onChange={(e) =>
                                                this.setState({ vehiclenum: e.target.value, err: false })
                                            }
                                            error={this.state.vehiclenum === "" && this.state.err}
                                            helperText={
                                                this.state.vehiclenum === "" && this.state.err
                                                    ? "Empty field!"
                                                    : " "
                                            }
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />

                                        <TextField
                                            type="number"
                                            name="distance"
                                            label="Approximate Distance (Km)"
                                            onChange={(e) =>
                                                this.setState({ distance: e.target.value, err: false })
                                            }
                                            error={this.state.distance === "" && this.state.err}
                                            helperText={
                                                this.state.distance === "" && this.state.err
                                                    ? "Empty field!"
                                                    : " "
                                            }
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                        />

                                        <FormControl variant="outlined" size="small" fullWidth>
                                            <InputLabel>Mode of Transportation</InputLabel>
                                            <Select
                                                value={this.state.transmode}
                                                onChange={(e) =>
                                                    this.setState({ transmode: e.target.value })
                                                }
                                                label="Mode of Transportation"
                                            >
                                                {this.state.deliverymethods.map((option, i) => (
                                                    <MenuItem key={i} value={option.value}>
                                                        {option.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                        <FormControl variant="outlined" size="small" fullWidth>
                                            <InputLabel>Vehicle Type</InputLabel>
                                            <Select
                                                value={this.state.vehicletype}
                                                onChange={(e) =>
                                                    this.setState({ vehicletype: e.target.value })
                                                }
                                                label="Vehicle Type"
                                            >
                                                <MenuItem value="R">Regular</MenuItem>
                                                <MenuItem value="O">ODC</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <FormControl variant="outlined" size="small" fullWidth>
                                            <InputLabel>Transaction Types</InputLabel>
                                            <Select
                                                value={this.state.transactiontype}
                                                onChange={(e) =>
                                                    this.setState({ transactiontype: e.target.value })
                                                }
                                                label="Transaction Types"
                                            >
                                                <MenuItem value={1}>Regular</MenuItem>
                                                <MenuItem value={2}>Bill To - Ship To</MenuItem>
                                                <MenuItem value={3}>Bill From - Dispatch From</MenuItem>
                                                <MenuItem value={4}>Combination of 2 and 3</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <FormControl variant="outlined" size="small" fullWidth>
                                            <InputLabel>Transportation Mode</InputLabel>
                                            <Select
                                                value={this.state.transportationmode}
                                                onChange={(e) =>
                                                    this.setState({ transportationmode: e.target.value })
                                                }
                                                label="Transportation Mode"
                                            >
                                                <MenuItem value={"1"}>Road</MenuItem>
                                                <MenuItem value={"2"}>Rail</MenuItem>
                                                <MenuItem value={"3"}>Air</MenuItem>
                                                <MenuItem value={"4"}>Ship</MenuItem>
                                                <MenuItem value={"5"}>inTransit</MenuItem>
                                            </Select>
                                        </FormControl>

                                        <FormControl variant="outlined" size="small" fullWidth>
                                            <InputLabel>Supply Type</InputLabel>
                                            <Select
                                                value={this.state.supplytype}
                                                onChange={(e) =>
                                                    this.setState({ supplytype: e.target.value })
                                                }
                                                label="Supply Type"
                                            >
                                                <MenuItem value={"I"}>Inward</MenuItem>
                                                <MenuItem value={"O"}>Outward</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>

                                    {/* Transporter Toggle */}
                                    <FormGroup row style={{ marginBottom: "16px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.transidreq}
                                                    onChange={() =>
                                                        this.setState({
                                                            transidreq: !this.state.transidreq,
                                                            transporterid: null,
                                                            transportername: null,
                                                        })
                                                    }
                                                    name="transidreq"
                                                    color="primary"
                                                />
                                            }
                                            label="Add transporter details for Part A?"
                                        />
                                    </FormGroup>

                                    {/* Transporter Details */}
                                    {this.state.transidreq && (
                                        <>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "8px",
                                                    marginBottom: "16px",
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    style={{
                                                        ...this.styles.btn,
                                                        ...(this.state.transporterselectiontype === false
                                                            ? this.styles.btnPrimary
                                                            : this.styles.btnOutline),
                                                        flex: 1,
                                                    }}
                                                    onClick={() =>
                                                        this.setState({
                                                            transporterselectiontype: false,
                                                            transportername: "",
                                                            transporterid: "",
                                                        })
                                                    }
                                                >
                                                    Enter Manually
                                                </button>
                                                <button
                                                    type="button"
                                                    style={{
                                                        ...this.styles.btn,
                                                        ...(this.state.transporterselectiontype === true
                                                            ? this.styles.btnPrimary
                                                            : this.styles.btnOutline),
                                                        flex: 1,
                                                    }}
                                                    onClick={() =>
                                                        this.setState({
                                                            transporterselectiontype: true,
                                                            transportername: "",
                                                            transporterid: "",
                                                        })
                                                    }
                                                >
                                                    Select
                                                </button>
                                            </div>

                                            {this.state.transporterselectiontype ? (
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "1fr 1fr",
                                                        gap: "16px",
                                                        marginBottom: "16px",
                                                    }}
                                                >
                                                    <Autocomplete
                                                        id="transporter-select"
                                                        options={this.state.transporterslist}
                                                        getOptionLabel={(option) => option.transname}
                                                        value={values.transname ? undefined : undefined}
                                                        onChange={this.handleTransporterChange}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Transporter"
                                                                variant="outlined"
                                                                size="small"
                                                                error={
                                                                    this.state.transportername === "" &&
                                                                    this.state.err
                                                                }
                                                                helperText={
                                                                    this.state.transportername === "" &&
                                                                        this.state.err
                                                                        ? "Empty field!"
                                                                        : " "
                                                                }
                                                            />
                                                        )}
                                                    />
                                                    <TextField
                                                        type="text"
                                                        name="transporterid"
                                                        label="Transporter Id"
                                                        value={this.state.transporterid}
                                                        variant="outlined"
                                                        size="small"
                                                        disabled
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns: "1fr 1fr",
                                                        gap: "16px",
                                                        marginBottom: "16px",
                                                    }}
                                                >
                                                    <TextField
                                                        type="text"
                                                        name="transportername"
                                                        label="Transporter Name"
                                                        onChange={(e) =>
                                                            this.setState({
                                                                transportername: e.target.value,
                                                                err: false,
                                                            })
                                                        }
                                                        error={this.state.transportername === "" && this.state.err}
                                                        helperText={
                                                            this.state.transportername === "" && this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                    <TextField
                                                        type="text"
                                                        name="transporterid"
                                                        label="Transporter Id"
                                                        onChange={(e) =>
                                                            this.TransporteridChange(e.target.value)
                                                        }
                                                        error={
                                                            (this.state.transporterid === "" ||
                                                                this.state.validtrnsid === false) &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.transporterid === "" && this.state.err
                                                                ? "Empty field!"
                                                                : this.state.validtrnsid === false
                                                                    ? "Invalid Transportor Id"
                                                                    : " "
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {/* Submit Button */}
                                    <button
                                        className="btn btn-sm hovbuttonColour float-center"
                                        onClick={this.handleEWaybillGenration}
                                    >
                                        {this.state.Invoicedata.einvoicestatus === "Pending"
                                            ? "Update Transportation"
                                            : "Generate Ewaybill"}
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Modal>

                {/* E-way bill Date Extention modal */}
                <Modal
                    show={this.state.showEWBExtn}
                    onHide={this.handleshowEWBExtnClose}
                    backdrop="static"
                    keyboard={false}
                    centered
                    size="xl"
                >
                    <Modal.Header closeButton>
                        <b>E-way bill Date Extention:</b>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            <Formik
                                initialValues={{}}
                                validateOnChange={false}
                                validate={this.validate}
                                onSubmit={this.onSubmit}
                                enableReinitialize={true}
                            >
                                {({ setFieldValue, values }) => (
                                    <div className="row">
                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="text"
                                                name="vehiclenum"
                                                label="Vehicel No."
                                                onChange={(e) =>
                                                    this.setState({
                                                        vehiclenum: e.target.value,
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.vehiclenum === "" &&
                                                    this.state.err
                                                }
                                                helperText={
                                                    this.state.vehiclenum === "" &&
                                                        this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="number"
                                                name="remainingDistance"
                                                label="Approximate Remaining Distance(Km)"
                                                onChange={(e) =>
                                                    this.setState({
                                                        remainingDistance: parseInt(
                                                            e.target.value
                                                        ),
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.remainingDistance ===
                                                    "" && this.state.err
                                                }
                                                helperText={
                                                    this.state.remainingDistance ===
                                                        "" && this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <FormControl
                                                className="col-md-12"
                                                variant="standard"
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">
                                                    Mode of Transportation
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={this.state.transmode}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            transmode: e.target.value,
                                                        })
                                                    }
                                                >
                                                    {this.state.deliverymethods.map(
                                                        (option, i) => {
                                                            return (
                                                                <MenuItem
                                                                    key={i}
                                                                    value={option.value}
                                                                >
                                                                    {option.name}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <FormControl
                                                variant="standard"
                                                className="col-md-12"
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">
                                                    Transportation Mode{" "}
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={
                                                        this.state.transportationmode
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            transportationmode:
                                                                e.target.value,
                                                        })
                                                    }
                                                    label="Vehicle Type"
                                                    fullWidth
                                                >
                                                    <MenuItem value={"1"}>
                                                        Road
                                                    </MenuItem>
                                                    <MenuItem value={"2"}>
                                                        Rail
                                                    </MenuItem>
                                                    <MenuItem value={"3"}>Air</MenuItem>
                                                    <MenuItem value={"4"}>
                                                        Ship
                                                    </MenuItem>
                                                    <MenuItem value={"5"}>
                                                        inTransit
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <Autocomplete
                                                id="subaccount"
                                                className="subacc-select"
                                                name="fromCountry"
                                                options={this.state.CountryData}
                                                getOptionLabel={(option) =>
                                                    option.name
                                                }
                                                getOptionSelected={(option) =>
                                                    option.name
                                                }
                                                value={
                                                    values.country
                                                        ? undefined
                                                        : undefined
                                                }
                                                onChange={this.handleCountryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="form-control"
                                                        type="text"
                                                        name="fromCountry"
                                                        value={this.state.fromCountry}
                                                        label={`Select Country (${this.state.fromCountry})`}
                                                        variant="standard"
                                                        error={
                                                            this.state.fromCountry === "" &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.fromCountry === "" &&
                                                                this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </fieldset>
                                        <fieldset className="form-group col-md-3">
                                            <Autocomplete
                                                id="subaccount"
                                                className="subacc-select"
                                                name="fromState"
                                                options={this.state.StatesData}
                                                getOptionLabel={(option) =>
                                                    option.name
                                                }
                                                getOptionSelected={(option) =>
                                                    option.name
                                                }
                                                value={
                                                    values.state ? undefined : undefined
                                                }
                                                onChange={this.handleStateChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="form-control"
                                                        type="text"
                                                        name="fromState"
                                                        value={this.state.fromState}
                                                        label={`Select State (${this.state.fromState})`}
                                                        variant="standard"
                                                        error={
                                                            this.state.fromState === "" &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.fromState === "" &&
                                                                this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <Autocomplete
                                                id="subaccount"
                                                className="subacc-select"
                                                name="fromPlace"
                                                options={this.state.CitiesData}
                                                getOptionLabel={(option) =>
                                                    option.name
                                                }
                                                getOptionSelected={(option) =>
                                                    option.name
                                                }
                                                value={
                                                    values.city ? undefined : undefined
                                                }
                                                onChange={this.handleCityChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="form-control"
                                                        type="text"
                                                        name="fromPlace"
                                                        value={this.state.fromPlace}
                                                        label={`Select City (${this.state.fromPlace})`}
                                                        variant="standard"
                                                        error={
                                                            this.state.fromPlace === "" &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.fromPlace === "" &&
                                                                this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="text"
                                                name="fromPincode"
                                                label="From Pincode"
                                                onChange={(e) =>
                                                    this.setState({
                                                        fromPincode: e.target.value,
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.fromPincode === "" &&
                                                    this.state.err
                                                }
                                                helperText={
                                                    this.state.fromPincode === "" &&
                                                        this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="text"
                                                name="addressLine1"
                                                label="Address1"
                                                onChange={(e) =>
                                                    this.setState({
                                                        addressLine1: e.target.value,
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.addressLine1 === "" &&
                                                    this.state.err
                                                }
                                                helperText={
                                                    this.state.addressLine1 === "" &&
                                                        this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>
                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="text"
                                                name="addressLine2"
                                                label="Address2"
                                                onChange={(e) =>
                                                    this.setState({
                                                        addressLine2: e.target.value,
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.addressLine2 === "" &&
                                                    this.state.err
                                                }
                                                helperText={
                                                    this.state.addressLine2 === "" &&
                                                        this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>
                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="text"
                                                name="addressLine3"
                                                label="Address3"
                                                onChange={(e) =>
                                                    this.setState({
                                                        addressLine3: e.target.value,
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.addressLine3 === "" &&
                                                    this.state.err
                                                }
                                                helperText={
                                                    this.state.addressLine3 === "" &&
                                                        this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <FormControl
                                                className="col-md-12"
                                                variant="standard"
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">
                                                    Reason for Extending Validity
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={
                                                        this.state.reasonCodeforewbext
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            reasonCodeforewbext:
                                                                e.target.value,
                                                        })
                                                    }
                                                >
                                                    {this.state.ResforEWBExt.map(
                                                        (option, i) => {
                                                            return (
                                                                <MenuItem
                                                                    key={i}
                                                                    value={option.value}
                                                                >
                                                                    {option.name}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </fieldset>

                                        <fieldset className="form-group col-md-12">
                                            <TextField
                                                name="extnRemarks"
                                                className="form-control"
                                                multiline
                                                rows={1}
                                                label="Add Remarks"
                                                variant="outlined"
                                                value={this.state.extnRemarks}
                                                error={this.state.extnRemarks === ""}
                                                onChange={(e) =>
                                                    this.setState({
                                                        extnRemarks: e.target.value,
                                                    })
                                                }
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-12">
                                            <button
                                                className="btn btn-sm hovbuttonColour float-center mt-2"
                                                onClick={this.ExtendEwaybill}
                                            >
                                                Submit{" "}
                                            </button>
                                        </fieldset>
                                    </div>
                                )}
                            </Formik>
                        </>
                    </Modal.Body>
                </Modal>

                {/* E-way bill Vehicle Update modal */}
                <Modal
                    show={this.state.showupdtveh}
                    onHide={this.handlecloseChgVel}
                    backdrop="static"
                    keyboard={false}
                    centered
                    size="xl"
                >
                    <Modal.Header closeButton>
                        <b>Vehicle Update Details :</b>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            <Formik
                                initialValues={{}}
                                validateOnChange={false}
                                validate={this.validate}
                                onSubmit={this.onSubmit}
                                enableReinitialize={true}
                            >
                                {({ setFieldValue, values }) => (
                                    <div className="row">
                                        <fieldset className="form-group col-md-3">
                                            <TextField
                                                className="form-control"
                                                type="text"
                                                name="vehiclenum"
                                                label="Vehicel No."
                                                onChange={(e) =>
                                                    this.setState({
                                                        vehiclenum: e.target.value,
                                                        err: false,
                                                    })
                                                }
                                                error={
                                                    this.state.vehiclenum === "" &&
                                                    this.state.err
                                                }
                                                helperText={
                                                    this.state.vehiclenum === "" &&
                                                        this.state.err
                                                        ? "Empty field!"
                                                        : " "
                                                }
                                                variant="standard"
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <FormControl
                                                variant="standard"
                                                className="col-md-12"
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">
                                                    Vehicle Type
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={this.state.vehicletype}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            vehicletype: e.target.value,
                                                        })
                                                    }
                                                    label="Vehicle Type"
                                                    fullWidth
                                                >
                                                    <MenuItem value="R">
                                                        Regular
                                                    </MenuItem>
                                                    <MenuItem value="O">ODC</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <FormControl
                                                variant="standard"
                                                className="col-md-12"
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">
                                                    Transportation Mode{" "}
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={
                                                        this.state.transportationmode
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            transportationmode:
                                                                e.target.value,
                                                        })
                                                    }
                                                    label="Vehicle Type"
                                                    fullWidth
                                                >
                                                    <MenuItem value={"1"}>
                                                        Road
                                                    </MenuItem>
                                                    <MenuItem value={"2"}>
                                                        Rail
                                                    </MenuItem>
                                                    <MenuItem value={"3"}>Air</MenuItem>
                                                    <MenuItem value={"4"}>
                                                        Ship
                                                    </MenuItem>
                                                    <MenuItem value={"5"}>
                                                        inTransit
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <Autocomplete
                                                id="subaccount"
                                                className="subacc-select"
                                                name="fromCountry"
                                                options={this.state.CountryData}
                                                getOptionLabel={(option) =>
                                                    option.name
                                                }
                                                getOptionSelected={(option) =>
                                                    option.name
                                                }
                                                value={
                                                    values.country
                                                        ? undefined
                                                        : undefined
                                                }
                                                onChange={this.handleCountryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="form-control"
                                                        type="text"
                                                        name="fromCountry"
                                                        value={this.state.fromCountry}
                                                        label={`Select Country (${this.state.fromCountry})`}
                                                        variant="standard"
                                                        error={
                                                            this.state.fromCountry === "" &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.fromCountry === "" &&
                                                                this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </fieldset>
                                        <fieldset className="form-group col-md-3">
                                            <Autocomplete
                                                id="subaccount"
                                                className="subacc-select"
                                                name="fromState"
                                                options={this.state.StatesData}
                                                getOptionLabel={(option) =>
                                                    option.name
                                                }
                                                getOptionSelected={(option) =>
                                                    option.name
                                                }
                                                value={
                                                    values.state ? undefined : undefined
                                                }
                                                onChange={this.handleStateChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="form-control"
                                                        type="text"
                                                        name="fromState"
                                                        value={this.state.fromState}
                                                        label={`Select State (${this.state.fromState})`}
                                                        variant="standard"
                                                        error={
                                                            this.state.fromState === "" &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.fromState === "" &&
                                                                this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <Autocomplete
                                                id="subaccount"
                                                className="subacc-select"
                                                name="fromPlace"
                                                options={this.state.CitiesData}
                                                getOptionLabel={(option) =>
                                                    option.name
                                                }
                                                getOptionSelected={(option) =>
                                                    option.name
                                                }
                                                value={
                                                    values.city ? undefined : undefined
                                                }
                                                onChange={this.handleCityChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        className="form-control"
                                                        type="text"
                                                        name="fromPlace"
                                                        value={this.state.fromPlace}
                                                        label={`Select City (${this.state.fromPlace})`}
                                                        variant="standard"
                                                        error={
                                                            this.state.fromPlace === "" &&
                                                            this.state.err
                                                        }
                                                        helperText={
                                                            this.state.fromPlace === "" &&
                                                                this.state.err
                                                                ? "Empty field!"
                                                                : " "
                                                        }
                                                        fullWidth
                                                    />
                                                )}
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-3">
                                            <FormControl
                                                className="col-md-12"
                                                variant="standard"
                                            >
                                                <InputLabel id="demo-simple-select-standard-label">
                                                    Reason
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-standard"
                                                    value={
                                                        this.state.reasonCodeforvehchg
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            reasonCodeforvehchg:
                                                                e.target.value,
                                                        })
                                                    }
                                                >
                                                    {this.state.ResforVehChange.map(
                                                        (option, i) => {
                                                            return (
                                                                <MenuItem
                                                                    key={i}
                                                                    value={option.value}
                                                                >
                                                                    {option.name}
                                                                </MenuItem>
                                                            );
                                                        }
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </fieldset>

                                        <fieldset className="form-group col-md-12">
                                            <TextField
                                                name="extnRemarks"
                                                className="form-control"
                                                multiline
                                                rows={1}
                                                label="Add Remarks"
                                                variant="outlined"
                                                value={this.state.extnRemarks}
                                                error={this.state.extnRemarks === ""}
                                                onChange={(e) =>
                                                    this.setState({
                                                        extnRemarks: e.target.value,
                                                    })
                                                }
                                            />
                                        </fieldset>

                                        <fieldset className="form-group col-md-12">
                                            <button
                                                className="btn btn-sm hovbuttonColour float-center mt-2"
                                                onClick={this.UpdateVehicel}
                                            >
                                                Submit{" "}
                                            </button>
                                        </fieldset>
                                    </div>
                                )}
                            </Formik>
                        </>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={this.state.showCancelModal}
                    onHide={() => this.setState({ showCancelModal: false, remarks: "" })}
                    backdrop="static"
                    keyboard={false}
                    centered
                    size="lg"
                >
                    <Modal.Header closeButton>
                        Invoice Cancellation
                    </Modal.Header>
                    <div className="form-row mt-3 ml-3">
                        <fieldset className="form-group col-md-8">
                            <TextField
                                name="remarks"
                                className="form-control"
                                multiline
                                rows={2}
                                label={`Reason For Cancellation`}
                                variant="outlined"
                                value={this.state.remarks}
                                onChange={(e) => this.setState({ remarks: e.target.value })}
                            />
                        </fieldset>
                        <fieldset className="form-group col-md-12" />
                        <fieldset className="form-group col-md-12" />
                        {this.state.remarks === "" ? (
                            <button
                                className="btn btn-sm hovbuttonColour float-center ml-2"
                                disabled
                            >
                                Submit
                            </button>
                        ) : (
                            <button
                                className="btn btn-sm hovbuttonColour float-center ml-2"
                                onClick={this.handleTerminateInvoice}
                            >
                                Submit
                            </button>
                        )}
                    </div>
                    <Modal.Body> </Modal.Body>
                </Modal>
            </div >
        );
    }
}

export default withRouter(ViewInvoice);